import 'bootstrap4-duallistbox'
import 'bootstrap4-duallistbox/dist/bootstrap-duallistbox.css'
import $ from 'jquery'
import moment from 'moment'
import 'moment/min/locales'
import React, { Component } from 'react'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import { Redirect } from 'react-router-dom'
import Select from 'react-select'
import 'react-select/dist/react-select.css'
import Switch from "react-switch"
import AjaxHandler from '../../commons/ajax/AjaxHandler.js'
import Config from '../../commons/config/Config.js'
import ConfigBusiness from '../../commons/config/ConfigBusiness.js'
import UnitSystem from '../../commons/utils/UnitSystem.js'
import LocaleFormat from '../../commons/utils/LocaleFormat.js'
import Dialog from '../../commons/dialog/Dialog.js'
import Security from '../../commons/security/Security.js'
import Loading from '../ui/Loading.js'
import 'dropzone/dist/min/dropzone.min.css'
import 'react-dropzone-component/styles/filepicker.css'
import '../../assets/css/vec-dropzone.css'
import ChoferesGrid from './ChoferesGrid'
import LugarDeGuardaGrid from './LugarDeGuardaGrid'
import * as Utils from '../../commons/utils/Utils';

import swal from 'sweetalert'
import swal2 from 'sweetalert2'
import MovilesAbmAdjuntos from './MovilesAbmAdjuntos.js'

import { Link } from 'react-router-dom'
import DireccionAutocompletar from '../direccionAutocompletar/DireccionAutocompletar'

import SelectWithIcons from '../selectWithIcons/SelectWithIcons.js'
import { TIPOS_UNIDAD_MEDIDOR as UNIDAD_MEDIDOR, ID__UM_ODOMETRO } from '../unidadMedidor/constants.js'
import MovilesAbmGPS from './MovilesAbmGPS.js'

import { FormattedMessage, injectIntl } from 'react-intl'
import backendStrings from '../../lang/backendStrings.js'
import AtributoDinamicoInstancia from '../atributoDinamico/AtributoDinamicoInstancia.js'
import { castValoresDinamicos } from '../atributoDinamico/helpers.js'
import { TIPOS_TRACCION } from '../tiposTraccion/constants.js'

import Swal from "sweetalert2"
import withReactContent from "sweetalert2-react-content"
import * as Yup from 'yup'
import { validateForm } from '../../commons/validation/ValidateForm.js'
import CambioCentroCostoMovil from "./CambioCentroCostoMovil"
import CambioDominioMovil from "./CambioDominioMovil"
import CambioUnidadMovil from "./CambioUnidadMovil"
import CambioTarjetaCombustible from './CambioTarjetaCombustible'
import HistoricoAdmGrid from './HistoricoAdmGrid'
import GestionarTransportadorasGrid from './GestionarTransportadorasGrid'
import HistoricoDatosGeneralesGrid from './HistoricoDatosGeneralesGrid'
import HistoricoRelacionesGrid from './HistoricoRelacionesGrid'
import MovilesCambioTipologia from './MovilesCambioTipologia'
import RentadoraComponent from './RentadoraComponent.jsx'
import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import MovilesCambioEstado from "./MovilesCambioEstado.js";

// Cache de session para datos estáticos del ABM (se limpia al recargar la página)
const _abmSelectCache = {};

function _cachedSelect(ajaxHandler, url, cacheKey) {
  if (_abmSelectCache[cacheKey] !== undefined) {
    return Promise.resolve(_abmSelectCache[cacheKey]);
  }
  return ajaxHandler.getJson(url).then(function(data) {
    _abmSelectCache[cacheKey] = data;
    return data;
  });
}

class MovilesAbm extends Component {
    constructor(props) {
        super(props);
        this.ajaxHandler = new AjaxHandler();
        moment.locale('es');
        
        // Cache para personas - optimización de rendimiento
        this.personasCache = new Map();
        this.personasCachePromises = new Map(); // Trackeo para evitar llamadas duplicadas en simultáneo
        
        this.state = {
            redirectTo: null,
            props: this.props,
            tipoModal: null,
            tickets: [],
            unidadMedidorIdOriginal: null,
            formData: {
                id: 0,
                unidad: '',
                dominio: '',
                base: null,
                sedeExterna: null,
                activo: true,
                marca: null,
                modelo: null,
                chasis: '',
                motor: '',
                imei: '',
                color: '',
                anio: 0,
                valorAdquisicion: 0,
                valorAmortizacion: 0,
                valorContable: 0,
                valorAlquiler: 0,
                pesoCargaTotalAutorizado: 0,
                pesoCargaMaxima: 0,
                volumenAreaCarga: 0,
                cantidadCompartimentos: 0,
                alturaEspacioCarga: 0,
                anchoEspacioCarga: 0,
                longitudEspacioCarga: 0,
                tipo: null,
                planPreventivo: null,
                planVencimiento: null,
                fechaAlta: null,
                fechaBaja: null,
                fechaFinGarantia: null,
                fechaFinContrato: null,
                valorPoliza: 0,
                valorFranquicia: 0,
                responsable1: null,
                responsable2: null,
                responsable3: null,
                responsable4: null,
                responsable5: null,
                supervisor: null,
                temporal: null,
                coordinador: null,
                centroCostos: null,
                cebe: null,
                poliza: '',
                lugarGuarda: '',
                certificadoVtv: '',
                telepeaje: '',
                ypfRuta: '',
                kmActual: null,
                dnrpaSeccional: null,
                activoFijo: '',
                equipo: '',
                nroTitulo: '',
                observaciones: '',
                adjuntos: [],
                estado: '',
                movilCombustibleTipo: null,
                traccion: '',
                titular: null,
                proveedorGps: null,
                companiaOrigen: '',
                dnrpa: 0,
                guardaEnBase: 1,
                equipamientos: [],
                activos_asociados_ids: null,
                gps_model: null,
                gps_model_id: null,
                force_avl_odometer: false,
                unidadMedidorId: null,
                tipologia_posicion: null,
                fechaInicioOperacion: null,
                funcion: null,
                buscar_infracciones: 1,
                rendimientoPropio: false,
                rendimientoEsperado: '',
                tanquePropio: false,
                capacidadTanque: '',
                estadoErp: '',
                valores_dinamicos: [],
                claseEloquent: '',
                division: null,
                kmUpdate: null,
                kmUpdateEditAbm: false,
                gerenciador: null,
                responsable_base: null,
                compania_origen_id: null,
                movil_reserva_id: null,
                es_reserva_asignada: null,
                rentadora: null,
                contrato: {},
                transportadora: null,
                transportadoras: [],
                es_reserva: null,
                motivoCambioEstado: '',
                catalogoAyudante: null,
                catalogoPloteado: null,
                catalogoTipoPloteo: null,
                asignadoA: null,
            },
            basellantas: null,
            showModalTipologiaLlanta: false,
            tipologiaOriginal: null,
            tipologiaSelect: null,
            llantasDeMovil: [],
            clases: [],
            bases: [],
            sedesExternas: [],
            marcas: [],
            modelos: [],
            planesVencimiento: [],
            movilCombustibleTipos: [],
            centrosCostos: [],
            cebes: [],
            errors: [],
            estados: [],
            estadosActivos: [],
            estadosInactivos: [],
            disableAvlFields: false,
            dnrpaSeccionales: [],
            tipologias: [],
            loading: false,
            basesLoading: false,
            sedesExternasLoading: false,
            marcasLoading: false,
            modelosLoading: false,
            centrosCostosLoading: false,
            dnrpaSeccionalesLoading: false,
            cebesLoading: false,
            estadosLoading: false,
            combustiblesLoading: false,
            traccionLoading: false,
            planesVencimientosLoading: false,
            planesPreventivosLoading: false,
            unidadMedidorIdLoading: false,
            rentadorasLoading: false,
            viewColor: false,
            companiaOrigenInputType: 'text',
            companiasOrigen: [],
            companiasLoading: false,
            titularInputType: 'select',
            titulares: [],
            titularesLoading: false,
            equipamientosDisponibles: [],
            activosVinculables: [],
            activosAsociadosLabels: [],
            relacionComoAsociado: null,
            modeloTipoPermiteVinculacion: false,
            kmTemporal: 0,
            funciones: [],
            valores_dinamicos: [],
            proveedoresGps: [],
            proveedoresGpsLoading: false,
            schema: null,
            validationErrors: {},
            validationDirty: {},
            divisiones: [],
            divisionesLoading: false,
            dominioGuardado: '',
            unidadGuardada: '',
            arrayDisponibles: [],
            arrayNodisponibles: [],
            estadoClasificadorText: "",
            tarjetaCombustibleOrig: "",
            cambiokmActual: false,
            gerenciadores: [],
            responsablesBase: [],
            asignacionManualGerenciador: ConfigBusiness.get('moviles.gerenciador.asignacionManual') === 'true',
            asignacionManualResponsableBase: ConfigBusiness.get('moviles.responsableBase.asignacionManual') === 'true',
            movilesReserva: [],
            utilizaMovilesReserva: ConfigBusiness.get('moviles.movil_reserva.habilitado') === 'true',
            movilesReservaLoading: false,
            rentingHabilitado: ConfigBusiness.get('moviles.rentadora.habilitado') === 'true',
            rentadoras: [],
            transportadoras: [],
            esReservaOpcion: [
              {
                'value': true,
                'label': this.props.intl.formatMessage({ id: 'Si', defaultMessage: 'Si' })
              },
              {
                'value': false,
                'label': this.props.intl.formatMessage({ id: 'No', defaultMessage: 'No' })
              }
            ],
            formDataCopy: null,
            catalogo_ayudantes: [],
            catalogo_ploteados: [],
            catalogo_tipo_ploteos: []
        };

        this.handleGuardaPersonalizada = this.handleGuardaPersonalizada.bind(this);
        this.handleChangeDireccion = this.handleChangeDireccion.bind(this);
        this.handleKmActualChange = this.handleKmActualChange.bind(this);
        this.handleInputFormChange = this.handleInputFormChange.bind(this);
        this.handleFormChangeSelectString = this.handleFormChangeSelectString.bind(this);
        this.handleFormChangeSelectTitular = this.handleFormChangeSelectTitular.bind(this);
        this.handleFormChangeSelectObject = this.handleFormChangeSelectObject.bind(this);
        this.handleFormChangeTipologia = this.handleFormChangeTipologia.bind(this);
        this.handleDatePickerFormChange = this.handleDatePickerFormChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.setEstadoActivo = this.setEstadoActivo.bind(this);
        this.handleInputSeparadoFormChange = this.handleInputSeparadoFormChange.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.getPlanPreventivos = this.getPlanPreventivos.bind(this);
        this.handlePlanPreventivoChange = this.handlePlanPreventivoChange.bind(this);
        this.handleFormChangeSelectFuncion = this.handleFormChangeSelectFuncion.bind(this);
        this.handleFormChangeSelectTransportadora = this.handleFormChangeSelectTransportadora.bind(this);
        this.handleFormChangeSelectAyudante = this.handleFormChangeSelectAyudante.bind(this);
        this.handleFormChangeSelectPloteado = this.handleFormChangeSelectPloteado.bind(this);
        this.handleFormChangeSelectTipoPloteo = this.handleFormChangeSelectTipoPloteo.bind(this);
        this.getBackendPersonasPorBase = this.getBackendPersonasPorBase.bind(this);
        this.getBackendCebes = this.getBackendCebes.bind(this);
        this.getBackendDnrpaSeccionales = this.getBackendDnrpaSeccionales.bind(this);
        this.getBackendCentrosCostos = this.getBackendCentrosCostos.bind(this);
        this.getBackendBases = this.getBackendBases.bind(this);
        this.handleChangeAtributoDinamico = this.handleChangeAtributoDinamico.bind(this);
        this.validateDomainChange = this.validateDomainChange.bind(this);
        this.handleChangeTarjetaCombustible = this.handleChangeTarjetaCombustible.bind(this);
        this.getMaxTime = this.getMaxTime.bind(this);
        this.getGerenciadorValue = this.getGerenciadorValue.bind(this);
        this.getResponsableBaseValue = this.getResponsableBaseValue.bind(this);
        this.getVehiculoReservaValue = this.getVehiculoReservaValue.bind(this);
        this.handleChangeRentadora = this.handleChangeRentadora.bind(this);
        this.handleChangeContrato = this.handleChangeContrato.bind(this);
        this.handleAgregarRentadora = this.handleAgregarRentadora.bind(this);
        this.handleModalCloseCambioEstado = this.handleModalCloseCambioEstado.bind(this);
        this.handleSubmitCambioEstado = this.handleSubmitCambioEstado.bind(this);
        this.handleTransportadoraChange = this.handleTransportadoraChange.bind(this);

        this.initFileUpload();
        this.verificarPermisoTransportadora = this.verificarPermisoTransportadora.bind(this);
    }

  componentWillMount() {
    if(
      (Security.hasPermission('MOVILES_CREAR') && this.state.props.action === 'ADD')
      || (Security.hasPermission('MOVILES_MODIFICAR') && this.state.props.action === 'EDIT')
      || (Security.hasPermission('MOVILES_VISUALIZAR') && this.state.props.action === 'VIEW')
    ) {
      this.ajaxHandler.subscribe(this);
      this.initForm();
    } else {
      this.setState({
        redirectTo: '/error'
      });
    }
  }

  componentWillUnmount() {
    this.ajaxHandler.unsubscribe();
  }

	initForm() {
    let component = this;
    let viewColor = ConfigBusiness.get('moviles.color.habilitado') === 'true' ? true : false;
    let viewYpfRuta = ConfigBusiness.get('moviles.ypfRuta.habilitado') === 'true' ? true : false;
    let viewPoliza = ConfigBusiness.get('moviles.poliza.habilitado') === 'true' ? true : false;
    let viewLugarGuarda = ConfigBusiness.get('moviles.lugarGuarda.habilitado') === 'true' ? true : false;
    let viewCebe = ConfigBusiness.get('moviles.cebe.habilitado') === 'true' ? true : false;
    let viewCentroCostos = ConfigBusiness.get('moviles.centroCostos.habilitado') === 'true' ? true : false;
    let viewDivisiones = ConfigBusiness.get('moviles.trabajaConDivisiones.habilitado') === 'true';
    let labelTitular = ConfigBusiness.get('moviles.titular.label') ? ConfigBusiness.get('moviles.titular.label') : '';
    let validaPatentes = ConfigBusiness.get('moviles.patente.validaPatentes') == 'true' ? true : false;
    let regex = new RegExp(ConfigBusiness.get('moviles.patente.patentesValidas'));
    let validaChasis = ConfigBusiness.get('moviles.chasis.validaChasis') == 'true' ? true : false;
    let regexChasis = new RegExp(ConfigBusiness.get('moviles.chasis.chasisValida'));
    let datoRequerido = this.props.intl.formatMessage({ id: 'validation.required', defaultMessage: 'Dato requerido' });
    let invalidNumber = this.props.intl.formatMessage({ id: 'validation.invalid_number', defaultMessage: 'Número inválido' });
    let invalidDate = this.props.intl.formatMessage({ id: 'validation.invalid_date', defaultMessage: 'Fecha inválida' })

    Yup.addMethod(Yup.string, 'numberEmptyNullable', function(invalidNumber){
      return this.matches(/^([-+]?[0-9]*\.?[0-9]+)?$/, invalidNumber).nullable();
    });

    Yup.addMethod(Yup.string, 'numberEmpty', function(invalidNumber){
      return this.matches(/^([-+]?[0-9]*\.?[0-9]+)?$/, invalidNumber);
    });

    Yup.addMethod(Yup.string, 'numberRequired', function(invalidNumber){
      return this.matches(/^[-+]?[0-9]*\.?[0-9]+$/, invalidNumber).required(datoRequerido).nullable()
    });

    Yup.addMethod(Yup.string, 'numberEmptyNullableNotNegative', function (invalidNumber) {
    return this.matches(/^([0-9]*\.?[0-9]+)?$/, invalidNumber).nullable();
    });

    let dominio = (validaPatentes && regex !== '') ? {
      dominio : Yup.string()
        .required(this.props.intl.formatMessage({ id: 'validation.required', defaultMessage: 'Dato requerido' }))
        .transform(value => { if(!regex.test(value) && value !== '' ) {
            throw new Yup.ValidationError(
              new Yup.ValidationError(this.props.intl.formatMessage({ id: 'validation.dominio_invalid', defaultMessage: 'Patente inválida' }), value, 'dominio', 'is-valid')
            );
          } else { return value }
        })
    } : {
      dominio: Yup.string().required(datoRequerido)
    };

    let chasis = (ConfigBusiness.get('moviles.chasis.obligatorio') === 'true') ? 
      (
        (validaChasis && regexChasis !== '') ? 
          {
            chasis : Yup.string()
              .required(this.props.intl.formatMessage({ id: 'validation.required', defaultMessage: 'Dato requerido' }))
              .transform(value => { if(!regexChasis.test(value) && value !== '' ) {
                  throw new Yup.ValidationError(
                    new Yup.ValidationError(
                      this.props.intl.formatMessage({
                        id: 'validation.chasis_invalid',
                        defaultMessage: 'El VIN debe contener 17 caracteres | El VIN no cumple con un formato válido | El VIN posee caracteres alfabéticos en minúscula'
                      }),
                      value,
                      'chasis',
                      'is-valid'
                    )
                  );
                } else { return value }
              })
          }
        :
          {
            chasis: Yup.string().required(datoRequerido)
          }
      )
    : (
        (validaChasis && regexChasis !== '') ? 
          {
            chasis : Yup.string()
              .transform(value => { if(!regexChasis.test(value) && value !== '' ) {
                  throw new Yup.ValidationError(
                    new Yup.ValidationError(
                      this.props.intl.formatMessage(
                        { id: 'validation.chasis_invalid',
                          defaultMessage: 'El VIN debe contener 17 caracteres | El VIN no cumple con un formato válido | El VIN posee caracteres alfabéticos en minúscula'
                        }),
                      value,
                      'chasis',
                      'is-valid'
                  )
                  );
                } else { return value }
              })
          }
        : {}
      );

    let estado = ConfigBusiness.get('moviles.estado.habilitado') === 'true' ? {
      estado: Yup.string().required(datoRequerido).nullable() } : {};

    let base = ConfigBusiness.get('moviles.base.habilitado') === 'true' ? {
      base: Yup.object().required(datoRequerido).nullable() } : {};

    let marca = ConfigBusiness.get('moviles.marca.obligatorio') === 'true' ? {
      marca: Yup.object().required(datoRequerido).nullable() } : {};

    let modelo = ConfigBusiness.get('moviles.modelo.obligatorio') === 'true' ? {
      modelo: Yup.object().required(datoRequerido).nullable() } : {};

    let motor = ConfigBusiness.get('moviles.motor.obligatorio') === 'true' ? {
      motor: Yup.string().nullable().required(datoRequerido) } : {};

    let anio = ConfigBusiness.get('moviles.anio.obligatorio') === 'true' ? {
      anio: Yup.string()
      .matches(/^[0-9]+$/, this.props.intl.formatMessage({ id: 'validation.numeric', defaultMessage: 'Solo números' }))
      .min(4, this.props.intl.formatMessage({ id: 'validation.year_yyyy', defaultMessage: 'Ingrese 4 dígitos' }))
      .max(4, this.props.intl.formatMessage({ id: 'validation.year_yyyy', defaultMessage: 'Ingrese 4 dígitos' }))
      .required(datoRequerido)
    } : {
      anio: Yup.string()
      .matches(/^(\s*|\d+)$/, this.props.intl.formatMessage({ id: 'validation.numeric', defaultMessage: 'Solo números' }))
      .min(4, this.props.intl.formatMessage({ id: 'validation.year_yyyy', defaultMessage: 'Ingrese 4 dígitos' }))
      .max(4, this.props.intl.formatMessage({ id: 'validation.year_yyyy', defaultMessage: 'Ingrese 4 dígitos' }))
      .nullable()
    }

    let traccion = ConfigBusiness.get('moviles.traccion.obligatorio') === 'true' ? {
      traccion: Yup.string().required(datoRequerido) } : {};

    let planPreventivo = ConfigBusiness.get('moviles.planMantPreventivo.obligatorio') === 'true' ? {
      planPreventivo: Yup.object().required(datoRequerido).nullable() } : {};

    let movilCombustibleTipo = ConfigBusiness.get('moviles.movilCombustibleTipo.obligatorio') === 'true' ? {
      movilCombustibleTipo: Yup.object().required(datoRequerido).nullable() } : {};

    let dnrpaSeccional = ConfigBusiness.get('moviles.dnrpaSeccional.obligatorio') === 'true' ? {
      dnrpaSeccional: Yup.object().required(datoRequerido).nullable() } : {};

    let titular = (ConfigBusiness.get('moviles.titular.habilitado') === 'true' && ConfigBusiness.get('moviles.titular.obligatorio') === 'true') ? {
      titular: Yup.object().required(datoRequerido).nullable() } : {};

    let companiaOrigen = (ConfigBusiness.get('moviles.companiaOrigen.habilitado') === 'true' && ConfigBusiness.get('moviles.companiaOrigen.obligatorio') === 'true') ? {
      companiaOrigen: Yup.string().required(datoRequerido).nullable() } : {};

    let fechaAlta = ConfigBusiness.get('moviles.fechaAlta.obligatorio') === 'true' ? {
      fechaAlta: Yup.date().max(moment(), invalidDate).required(datoRequerido).nullable() } : {};

    let fechaFinGarantia = ConfigBusiness.get('moviles.fechaFinGarantia.obligatorio') === 'true' ? {
      fechaFinGarantia: Yup.date().min(Yup.ref('fechaAlta'), invalidDate).required(datoRequerido).nullable() } : {};

    let centroCostos = (viewCentroCostos && ConfigBusiness.get('moviles.centroCostos.obligatorio') === 'true') ? {
      centroCostos: Yup.object().required(datoRequerido).nullable() } : {};

    let cebe = (viewCebe && ConfigBusiness.get('moviles.cebe.obligatorio') === 'true') ? {
      cebe: Yup.object().required(datoRequerido).nullable() } : {};

    let valorAdquisicion = ConfigBusiness.get('moviles.valorAdquisicion.obligatorio') === 'true' ? {
      valorAdquisicion: Yup.string().numberRequired(invalidNumber) } : { valorAdquisicion: Yup.string().numberEmpty(invalidNumber) };

    let valorAmortizacion = ConfigBusiness.get('moviles.valorAmortizacion.obligatorio') === 'true' ? {
      valorAmortizacion: Yup.string().numberRequired(invalidNumber) } : { valorAmortizacion: Yup.string().numberEmpty(invalidNumber) };

    let valorContable = ConfigBusiness.get('moviles.valorContable.obligatorio') === 'true' ? {
      valorContable: Yup.string().numberRequired(invalidNumber) } : { valorContable: Yup.string().numberEmpty(invalidNumber) };

    let valorAlquiler = ConfigBusiness.get('moviles.valorAlquiler.obligatorio') === 'true' ? {
      valorAlquiler: Yup.string().numberRequired(invalidNumber) } : { valorAlquiler: Yup.string().numberEmpty(invalidNumber) };

    let rentadora = ConfigBusiness.get('moviles.rentadora.obligatorio') === 'true' ? {
      rentadora: Yup.object().required(datoRequerido).nullable() } : {};

    let pesoCargaTotalAutorizado = ConfigBusiness.get('moviles.pesoCargaTotalAutorizado.obligatorio') === 'true' ? {
      pesoCargaTotalAutorizado: Yup.string().numberRequired(invalidNumber) } : { pesoCargaTotalAutorizado: Yup.string().numberEmptyNullable(invalidNumber) };

    let pesoCargaMaxima = ConfigBusiness.get('moviles.pesoCargaMaxima.obligatorio') === 'true' ? {
      pesoCargaMaxima: Yup.string().numberRequired(invalidNumber) } : { pesoCargaMaxima: Yup.string().numberEmptyNullable(invalidNumber) };

    let volumenAreaCarga = ConfigBusiness.get('moviles.volumenAreaCarga.obligatorio') === 'true' ? {
      volumenAreaCarga: Yup.string().numberRequired(invalidNumber) } : { volumenAreaCarga: Yup.string().numberEmptyNullable(invalidNumber) };

    let cantidadCompartimentos = ConfigBusiness.get('moviles.cantidadCompartimentos.obligatorio') === 'true' ? {
      cantidadCompartimentos: Yup.string().numberRequired(invalidNumber) } : { cantidadCompartimentos: Yup.string().numberEmptyNullable(invalidNumber) };

    let alturaEspacioCarga = ConfigBusiness.get('moviles.alturaEspacioCarga.obligatorio') === 'true' ? {
      alturaEspacioCarga: Yup.string().numberRequired(invalidNumber) } : { alturaEspacioCarga: Yup.string().numberEmptyNullable(invalidNumber) };

    let anchoEspacioCarga = ConfigBusiness.get('moviles.anchoEspacioCarga.obligatorio') === 'true' ? {
      anchoEspacioCarga: Yup.string().numberRequired(invalidNumber) } : { anchoEspacioCarga: Yup.string().numberEmptyNullable(invalidNumber) };

    let longitudEspacioCarga = ConfigBusiness.get('moviles.longitudEspacioCarga.obligatorio') === 'true' ? {
      longitudEspacioCarga: Yup.string().numberRequired(invalidNumber) } : { longitudEspacioCarga: Yup.string().numberEmptyNullable(invalidNumber) };

    let kmActual = ConfigBusiness.get('moviles.kmActual.obligatorio') === 'true' ? {
      kmActual: Yup.string().numberRequired(invalidNumber) } : { kmActual: Yup.string().numberEmptyNullable(invalidNumber) };

    let transportadora = ConfigBusiness.get('moviles.transportadora.obligatorio') === 'true' ? {
      transportadoras: Yup.array().min(1, datoRequerido) } : {};

    let schema = Yup.object().shape( {
      ...dominio,
      ...estado,
      ...base,
      ...marca,
      ...modelo,
      ...chasis,
      ...motor,
      ...anio,
      ...traccion,
      ...planPreventivo,
      ...movilCombustibleTipo,
      ...dnrpaSeccional,
      ...titular,
      ...companiaOrigen,
      ...fechaAlta,
      ...fechaFinGarantia,
      ...centroCostos,
      ...cebe,
      ...valorAdquisicion,
      ...valorAmortizacion,
      ...valorContable,
      ...valorAlquiler,
      ...rentadora,
      ...pesoCargaTotalAutorizado,
      ...pesoCargaMaxima,
      ...volumenAreaCarga,
      ...cantidadCompartimentos,
      ...alturaEspacioCarga,
      ...anchoEspacioCarga,
      ...longitudEspacioCarga,
      ...kmActual,
      ...transportadora,
      valorPoliza: Yup.string().numberEmptyNullable(invalidNumber),
      valorFranquicia: Yup.string().numberEmptyNullable(invalidNumber),
      unidadMedidorId: Yup.string().required(datoRequerido),
      rendimientoPropio: Yup.boolean().notRequired(),
      rendimientoEsperado: Yup.number().when('rendimientoPropio', {
        is: true,
        then: Yup.number().transform(value => (isNaN(value) ? undefined : value)).positive(invalidNumber).required(datoRequerido),
        otherwise: Yup.number().transform(value => (isNaN(value) ? undefined : value)).nullable()
      }),
      tanquePropio: Yup.boolean().notRequired(),
      capacidadTanque: Yup.number().when('tanquePropio', {
        is: true,
        then: Yup.number().transform(value => (isNaN(value) ? undefined : value)).positive(invalidNumber).required(datoRequerido),
        otherwise: Yup.number().transform(value => (isNaN(value) ? undefined : value)).nullable()
      }),
      nro_cuotas_leasing: Yup.string().numberEmptyNullableNotNegative(invalidNumber),
      odometro_limite_contrato: Yup.string().numberEmptyNullableNotNegative(invalidNumber),
      tasa_impuestos: Yup.string().numberEmptyNullableNotNegative(invalidNumber),
      porcentaje_alerta_utilizacion: Yup.string().numberEmptyNullableNotNegative(invalidNumber),
      valor_cuota_depreciacion: Yup.string().numberEmptyNullableNotNegative(invalidNumber),
      kms_excedente: Yup.string().numberEmptyNullableNotNegative(invalidNumber),
      valor_cuota_leasing: Yup.string().numberEmptyNullableNotNegative(invalidNumber),
      nro_cuotas_depreciacion: Yup.string().numberEmptyNullableNotNegative(invalidNumber),
      valor_interes_mensual: Yup.string().numberEmptyNullableNotNegative(invalidNumber),
    });

		this.setState({
      viewCebe: viewCebe,
      viewColor: viewColor,
      viewYpfRuta: viewYpfRuta,
      viewPoliza: viewPoliza,
      viewLugarGuarda: viewLugarGuarda,
      viewCentroCostos: viewCentroCostos,
      labelTitular: labelTitular,
      schema: schema,
    });

    if(ConfigBusiness.get('moviles.clasificador.habilitado') === "true"){
      let disponible = ConfigBusiness.get('moviles.clasificador.disponible');
      disponible = disponible ? disponible.split(',') : [];

      let nodisponible = ConfigBusiness.get('moviles.clasificador.nodisponible');
      nodisponible = nodisponible ? nodisponible.split(',') : null;
      this.setState({
        arrayDisponibles: disponible,
        arrayNodisponibles: nodisponible
      });
    }

    if(this.state.props.action === 'VIEW' || this.state.props.action === 'EDIT') this.loadFormData();
    if(this.state.props.action === 'EDIT') this.loadTicketsData();

    if(this.state.props.action === 'ADD' || this.state.props.action === 'EDIT') {
      this.setState({
        basesLoading: false,
        sedesExternasLoading: true,
        marcasLoading: true,
        centrosCostosLoading: true,
        cebesLoading: false,
        divisionesLoading: viewDivisiones,
        estadosLoading: true,
        combustiblesLoading: true,
        loading: this.state.props.action === 'EDIT',
        unidadMedidorIdLoading: true,
        planesPreventivosLoading: true,
        planesVencimientosLoading: true,
        companiasLoading: true,
        titularesLoading: true,
        proveedoresGpsLoading: true,
        movilesReservaLoading: true,
        rentadorasLoading: true
      });

      const movilesEstados = ConfigBusiness.get('moviles.estados');
      const movilesEstadosActivos = ConfigBusiness.get('moviles.estadosActivos');
      const movilesEstadosInactivos = ConfigBusiness.get('moviles.estadosInactivos');
      const companiaOrigenInputType = ConfigBusiness.get('moviles.companiaOrigen.inputType');

      // Estado sincrónico (no depende de requests): se setea de inmediato
      let disableAvlFields = false;
      if (ConfigBusiness.get('avl_service.service') === 'pointer') {
        disableAvlFields = ConfigBusiness.get('pointer.disableFields') === 'true';
      }
      if (ConfigBusiness.get('avl_service.service') === 'geotab') {
        disableAvlFields = ConfigBusiness.get('geotab.disableFields') === 'true';
      }
      component.setState({
        disableAvlFields,
        estadosLoading: false,
        unidadMedidorIdLoading: false,
        estados: movilesEstados ? movilesEstados.split(',').map(function(e) { return { value: e, label: e }; }) : [],
        estadosActivos: movilesEstadosActivos ? movilesEstadosActivos.split(',') : [],
        estadosInactivos: movilesEstadosInactivos ? movilesEstadosInactivos.split(',') : [],
        companiaOrigenInputType: companiaOrigenInputType || '',
      });

      // Helper: dispara un request y setea state al llegar, sin esperar a los demás
      var self = this;
      function fetchSelect(promise, stateUpdater, errorUpdater) {
        if (!promise) return;
        promise.then(function(data) { stateUpdater(data); })
               .catch(function(error) {
                 component.ajaxHandler.handleError(error);
                 if (errorUpdater) errorUpdater();
               });
      }

      fetchSelect(
        self.ajaxHandler.getJson('/sede-externa/select'),
        function(sedesExternas) { component.setState({ sedesExternas: sedesExternas, sedesExternasLoading: false }); },
        function() { component.setState({ sedesExternasLoading: false }); }
      );
      fetchSelect(
        _cachedSelect(self.ajaxHandler, '/marcas/select', 'marcas'),
        function(marcas) { component.setState({ marcas: marcas, marcasLoading: false }); },
        function() { component.setState({ marcasLoading: false }); }
      );
      fetchSelect(
        self.state.asignacionManualGerenciador ? self.ajaxHandler.getJson('/gerenciadores/tipo/1/select') : null,
        function(gerenciadores) { component.setState({ gerenciadores: gerenciadores }); }
      );
      fetchSelect(
        self.ajaxHandler.getJson('/plan-mantenimiento-preventivos/PREVENTIVO/select'),
        function(planesPreventivo) { component.setState({ planesPreventivo: planesPreventivo, planesPreventivosLoading: false }); },
        function() { component.setState({ planesPreventivosLoading: false }); }
      );
      fetchSelect(
        _cachedSelect(self.ajaxHandler, '/companias-origen/select', 'companiasOrigen'),
        function(companiasOrigen) { component.setState({ companiasOrigen: companiasOrigen, companiasLoading: false }); },
        function() { component.setState({ companiasLoading: false }); }
      );
      fetchSelect(
        _cachedSelect(self.ajaxHandler, '/movil-titulares/select', 'movilTitulares'),
        function(titulares) { component.setState({ titulares: titulares, titularesLoading: false }); },
        function() { component.setState({ titularesLoading: false }); }
      );
      fetchSelect(
        self.ajaxHandler.getJson('/plan-mantenimiento-preventivos/VENCIMIENTO/select'),
        function(planesVencimiento) { component.setState({ planesVencimiento: planesVencimiento, planesVencimientosLoading: false }); },
        function() { component.setState({ planesVencimientosLoading: false }); }
      );
      fetchSelect(
        _cachedSelect(self.ajaxHandler, '/moviles/moviles/tipologias', 'tipologias'),
        function(tipologias) { component.setState({ tipologias: tipologias }); }
      );
      fetchSelect(
        _cachedSelect(self.ajaxHandler, '/funciones', 'funciones'),
        function(funciones) { component.setState({ funciones: funciones }); }
      );
      fetchSelect(
        (Security.hasPermission('LLANTAS_MODELOS_VISUALIZAR') || Security.hasPermission('LLANTAS_MODELOS_LISTAR'))
          ? _cachedSelect(self.ajaxHandler, '/llanta-modelo-clases', 'llantaModeloClases') : null,
        function(clases) { component.setState({ clases: clases }); }
      );
      fetchSelect(
        self.ajaxHandler.getJson('/gerenciadores/tipo/4/select'),
        function(proveedoresGps) { component.setState({ proveedoresGps: proveedoresGps, proveedoresGpsLoading: false }); },
        function() { component.setState({ proveedoresGpsLoading: false }); }
      );
      fetchSelect(
        _cachedSelect(self.ajaxHandler, '/movil-combustible-tipos/select', 'movilCombustibleTipos'),
        function(movilCombustibleTipos) { component.setState({ movilCombustibleTipos: movilCombustibleTipos, combustiblesLoading: false }); },
        function() { component.setState({ combustiblesLoading: false }); }
      );
      fetchSelect(
        viewDivisiones ? self.ajaxHandler.getJson('/divisiones/select') : null,
        function(divisiones) { component.setState({ divisiones: divisiones, divisionesLoading: false }); }
      );
      fetchSelect(
        self.state.rentingHabilitado ? self.ajaxHandler.getJson('/rentadoras/select') : null,
        function(rentadoras) { component.setState({ rentadoras: rentadoras, rentadorasLoading: false }); },
        function() { component.setState({ rentadorasLoading: false }); }
      );
      fetchSelect(
        self.ajaxHandler.getJson('/transportadoras/select'),
        function(transportadoras) { component.setState({ transportadoras: transportadoras }); }
      );
      fetchSelect(
        _cachedSelect(self.ajaxHandler, '/catalogos?tipo=ayudante', 'catalogoAyudante'),
        function(catalogoAyudantes) { component.setState({ catalogoAyudantes: catalogoAyudantes }); }
      );
      fetchSelect(
        _cachedSelect(self.ajaxHandler, '/catalogos?tipo=ploteado', 'catalogoPloteado'),
        function(catalogoPloteados) { component.setState({ catalogoPloteados: catalogoPloteados }); }
      );
      fetchSelect(
        _cachedSelect(self.ajaxHandler, '/catalogos?tipo=tipo_ploteo', 'catalogoTipoPloteo'),
        function(catalogoTipoPloteos) { component.setState({ catalogoTipoPloteos: catalogoTipoPloteos }); }
      );

      // equipamientos: además de setear state, inicializa el duallistbox
      fetchSelect(
        _cachedSelect(self.ajaxHandler, '/equipamiento', 'equipamiento'),
        function(equipamientosDisponibles) {
          component.setState({ equipamientosDisponibles: equipamientosDisponibles }, function() {
            $(component.refs.duallistboxequipamientos).bootstrapDualListbox({
              moveOnSelect: false,
              moveAllLabel: component.props.intl.formatMessage({ id: 'movilesAbm.associated_equipment.title_mover_todos', defaultMessage: 'Mover todos' }),
              removeAllLabel: component.props.intl.formatMessage({ id: 'movilesAbm.associated_equipment.title_remover_todos', defaultMessage: 'Remover todos' }),
              moveSelectedLabel: component.props.intl.formatMessage({ id: 'movilesAbm.associated_equipment.title_mover_seleccionados', defaultMessage: 'Mover seleccionados' }),
              removeSelectedLabel: component.props.intl.formatMessage({ id: 'movilesAbm.associated_equipment.title_remover_seleccionados', defaultMessage: 'Remover seleccionados' }),
              infoText: false,
              filterPlaceHolder: 'Filtro',
              nonSelectedListLabel: component.props.intl.formatMessage({ id: 'movilesAbm.associated_equipment.label_remover_seleccionados', defaultMessage: 'Equipamientos Disponibles:' }),
              selectedListLabel: component.props.intl.formatMessage({ id: 'movilesAbm.associated_equipment.label_equipamientos_asignados:', defaultMessage: 'Equipamientos Asignados:' }),
            });
            $(component.refs.duallistboxequipamientos).change(function() {
              const equipamientos = $(component.refs.duallistboxequipamientos).val();
              component.setState((prevState) => ({
                formData: {
                  ...prevState.formData,
                  equipamientos: equipamientos
                }
              }), function() {
                $(component.refs.duallistboxequipamientos).bootstrapDualListbox('refresh', true);
              });
            });
          });
        }
      );

      // activos vinculables: además de setear state, inicializa su duallistbox en ADD
      if (ConfigBusiness.get('moviles.vinculacionActivos.habilitado') === 'true' && this.props.action === 'ADD') {
        fetchSelect(
          self.ajaxHandler.getJson('/moviles/vinculables-select?movil_id=0'),
          function(activosVinculables) {
            component.setState({ activosVinculables: activosVinculables || [] }, function() {
              if (component.refs.duallistboxactivos) {
                $(component.refs.duallistboxactivos).bootstrapDualListbox({
                  moveOnSelect: false,
                  moveAllLabel: 'Mover todos',
                  removeAllLabel: 'Remover todos',
                  moveSelectedLabel: 'Mover seleccionados',
                  removeSelectedLabel: 'Remover seleccionados',
                  infoText: false,
                  filterPlaceHolder: 'Filtro',
                  nonSelectedListLabel: 'Activos Disponibles:',
                  selectedListLabel: 'Activos Asociados:',
                });
                $(component.refs.duallistboxactivos).change(function() {
                  var ids = $(component.refs.duallistboxactivos).val();
                  var formData = {
                    ...component.state.formData,
                    activos_asociados_ids: ids ? ids.map(Number) : []
                  };
                  component.setState({ formData: formData }, function() {
                    $(component.refs.duallistboxactivos).bootstrapDualListbox('refresh', true);
                  });
                });
              }
            });
          }
        );
      }
    }

    window.scrollTo(0, 0);
    $('#dominio').focus();
	}

  getMovilesReservaOptions(id, movilReservaId) {
    this.ajaxHandler.getJson(`/moviles/reserva-select?movilId=${id}&movilReservaId=${movilReservaId}`)
    .then(res => {
      this.setState({
        movilesReserva: res,
        movilesReservaLoading: false
      });
    }).catch(function(error) {
      this.ajaxHandler.handleError(error);
    });
  }

  getBackendPersonasPorBase (searchTerm) {
    // Normalizar el término de búsqueda
    const normalizedSearchTerm = (searchTerm || '').toLowerCase().trim();
    
    // 1. Verificar si ya está en cache
    if (this.personasCache.has(normalizedSearchTerm)) {
      // Retornar resultado cacheado inmediatamente
      return Promise.resolve(this.personasCache.get(normalizedSearchTerm));
    }
    
    // 2. Verificar si ya hay una llamada en progreso para este término
    if (this.personasCachePromises.has(normalizedSearchTerm)) {
      // Retornar la misma promesa para evitar llamadas duplicadas
      return this.personasCachePromises.get(normalizedSearchTerm);
    }
    
    // 3. Hacer la llamada al backend y guardar la promesa
    const promise = this.ajaxHandler
      .getJson('/personas/simple-search?active=1&filterNotInternal=true&search=' + searchTerm)
      .then(res => {
        const result = {
          options: res,
          complete: true
        };
        
        // Guardar en cache
        this.personasCache.set(normalizedSearchTerm, result);
        
        // Limpiar la promesa del tracking
        this.personasCachePromises.delete(normalizedSearchTerm);
        
        return result;
      })
      .catch(error => {
        // En caso de error, limpiar la promesa del tracking
        this.personasCachePromises.delete(normalizedSearchTerm);
        throw error;
      });
    
    // Guardar la promesa en progreso
    this.personasCachePromises.set(normalizedSearchTerm, promise);
    
    return promise;
  }

  getBackendCebes(searchTerm) {
    return this.ajaxHandler
      .getJson('/cebes/simple-search?search=' + encodeURIComponent(searchTerm || ''))
      .then(function(res) { return { options: res, complete: true }; });
  }

  getBackendDnrpaSeccionales(searchTerm) {
    return this.ajaxHandler
      .getJson('/dnrpa-seccionales/competencia/AUTOMOTOR/simple-search?search=' + encodeURIComponent(searchTerm || ''))
      .then(function(res) { return { options: res, complete: true }; });
  }

  getBackendCentrosCostos(searchTerm) {
    return this.ajaxHandler
      .getJson('/centros-costos/simple-search?search=' + encodeURIComponent(searchTerm || ''))
      .then(function(res) { return { options: res, complete: true }; });
  }

  getBackendBasesUrl(searchTerm) {
    const queryParams = ['search=' + encodeURIComponent(searchTerm || '')];

    if (typeof Security.hasPermission === 'function' && Security.hasPermission('MOVILES_CREAR_FILTRO_BASES_POR_CC')) {
      queryParams.push('filtroBasesPorCc=1');
    }

    return '/bases/simple-search-by-name?' + queryParams.join('&');
  }

  getBackendBases(searchTerm) {
    return this.ajaxHandler
      .getJson(this.getBackendBasesUrl(searchTerm))
      .then(function(res) { return { options: res, complete: true }; });
  }

  getPlanPreventivos (descripcion) {
    this.setState({ loading: true });
    let tipo = 'PREVENTIVO'
    let unidadMedidorId = this.state.formData.unidadMedidorId ? this.state.formData.unidadMedidorId : null;
    let url = '/plan-mantenimiento-preventivos/simple-search?'
      + 'descripcion=' + descripcion
      + '&tipo=' + tipo
      + '&unidad_medidor_id=' + unidadMedidorId
      + '&limit=10'
      + '&activo=true'
    if (!this.component)
      this.ajaxHandler.subscribe(this);
    return this.ajaxHandler.getJson(url).then(res => {
      return {
        options: res,
        complete: true
      }
    }).finally(() => {
      this.setState({ loading: false });
    });
  }


  loadFormData() {
    let component = this;
    const movilId = this.state.props.match.params.id;
    this.setState({ loading: true });
    this.ajaxHandler.getJson(`/moviles/${movilId}`)
    .then(data => {
      if(data) {
        if(data.kmActual !== null && data.kmActual !== undefined){
          let kmDisplay = data.unidadMedidorId === ID__UM_ODOMETRO ? UnitSystem.toDisplay(data.kmActual, 'distance') : data.kmActual;
          component.setState({
            kmTemporal: Math.floor(kmDisplay).toLocaleString(LocaleFormat.getNumberLocale()),
            kmActualDb: data.kmActual
          });
          data.kmActual = Math.floor(kmDisplay);
        }
        let estadoClasificadorText = "";
        if(data.estado){
          if(component.state.arrayDisponibles && component.state.arrayDisponibles.includes(data.estado)){
            estadoClasificadorText = component.props.intl.formatMessage({ id: 'Disponible', defaultMessage: 'Disponible' });
          }else if(component.state.arrayNodisponibles && component.state.arrayNodisponibles.includes(data.estado)){
            estadoClasificadorText = component.props.intl.formatMessage({ id: 'No_disponible', defaultMessage: 'No disponible' })
          }
        }

				component.setState({
          direccionForm: {
						latitud: data.guardaLatitud,
						longitud: data.guardaLongitud,
						calle: data.guardaDireccion,
						numero: data.guardaAltura,
						pais: data.guardaPais,
						provincia: data.guardaProvincia,
						localidad: data.guardaLocalidad,
					},
          unidadMedidorIdOriginal: data.unidadMedidorId,
          estadoClasificadorText: estadoClasificadorText
        });
				if(this.state.props.action === 'EDIT'){
          this.ajaxHandler.getJson('/llantas/llantasdemovil/' + data.id)
          .then(llantas => {
            if(llantas){
              component.setState({
                llantasDeMovil: llantas
              })
            }
          });
          if(Security.hasPermission('MOVILES_MODIFICAR_EQUIPAMIENTO')){
            data.equipamientos = data.equipamientos.map( equipamiento => equipamiento.id)
          }
          const permiteVinculacionEdit = !!(data.tipo && data.tipo.permite_vinculacion);
          if (ConfigBusiness.get('moviles.vinculacionActivos.habilitado') === 'true') Promise.all([
            this.ajaxHandler.getJson('/moviles/vinculables-select?movil_id=' + data.id),
            this.ajaxHandler.getJson('/movil-relaciones/activa?movil_id=' + data.id),
          ]).then(([vinculables, activa]) => {
            const relacionesPrincipal = (activa && activa.como_principal) ? activa.como_principal : [];
            const relacionComoAsociado = (activa && activa.como_asociado) ? activa.como_asociado : null;
            const asociadosActivos = relacionesPrincipal.map(r => r.activo_asociado_id);
            let formDataCopy = component.state.formData;
            formDataCopy.activos_asociados_ids = asociadosActivos;
            component.setState({
              activosVinculables: vinculables || [],
              activosAsociadosLabels: relacionesPrincipal.map(r => r.movil_asociado ? r.movil_asociado.dominio : r.activo_asociado_id),
              relacionComoAsociado: relacionComoAsociado,
              modeloTipoPermiteVinculacion: permiteVinculacionEdit,
              formData: formDataCopy,
            }, () => {
              const preselected = formDataCopy.activos_asociados_ids || [];
              $(component.refs.duallistboxactivos).find('option').each(function() {
                $(this).prop('selected', preselected.includes(parseInt($(this).val())));
              });
              $(component.refs.duallistboxactivos).bootstrapDualListbox({
                moveOnSelect: false,
                moveAllLabel: 'Mover todos',
                removeAllLabel: 'Remover todos',
                moveSelectedLabel: 'Mover seleccionados',
                removeSelectedLabel: 'Remover seleccionados',
                infoText: false,
                filterPlaceHolder: 'Filtro',
                nonSelectedListLabel: 'Activos Disponibles:',
                selectedListLabel: 'Activos Asociados:',
              });
              $(component.refs.duallistboxactivos).change(() => {
                let ids = $(component.refs.duallistboxactivos).val();
                let fd = component.state.formData;
                fd.activos_asociados_ids = ids ? ids.map(Number) : [];
                component.setState({ formData: fd }, () => {
                  $(component.refs.duallistboxactivos).bootstrapDualListbox('refresh', true);
                });
              });
            });
          });
        }
        data.tipologia_posicion = data.tipologiaPosicion;
        validateForm(this, "chasis", data);
        data.es_reserva = data.es_reserva !== null ? this.state.esReservaOpcion.find(opt => opt.value === data.es_reserva) : null;
      
			  component.setState({
          formData: Object.assign(this.state.formData, data),
          labelTitular: ConfigBusiness.get('moviles.titular.label'),
          tipologiaOriginal: data.tipologia_posicion,
          dominioGuardado: data.dominio,
          unidadGuardada: data.unidad,
          tarjetaCombustibleOrig: data.ypf_ruta != null ? data.ypf_ruta : ''
        }, () => {
					$(this.refs.duallistboxequipamientos).bootstrapDualListbox('refresh', true);
          if(ConfigBusiness.get('moviles.vinculacionActivos.habilitado') === 'true' && this.state.props.action === 'VIEW') {
            const permiteVinculacionView = !!(data.tipo && data.tipo.permite_vinculacion);
            component.setState({ modeloTipoPermiteVinculacion: permiteVinculacionView });
            this.ajaxHandler.getJson('/movil-relaciones/activa?movil_id=' + data.id)
              .then(activa => {
                const relacionesPrincipal = (activa && activa.como_principal) ? activa.como_principal : [];
                const relacionComoAsociado = (activa && activa.como_asociado) ? activa.como_asociado : null;
                component.setState({
                  activosAsociadosLabels: relacionesPrincipal.map(r => r.movil_asociado ? r.movil_asociado.dominio : r.activo_asociado_id),
                  relacionComoAsociado: relacionComoAsociado,
                });
              });
          }
          if(this.state.props.action === 'EDIT' || this.state.props.action==='VIEW') {
            component.setState({ basellantas: data.base ? {label: data.base.descripcion, value: data.base.id} : null});
            if(data.titular) this.handleFormChangeSelectTitular({ value: data.titular.id, label: data.titular.nombre });
            if(data.marca) {
              // Iniciar marca en formData (equivalente a lo que hace handleMarcaChange antes del fetch)
              let formDataMarca = JSON.parse(JSON.stringify(this.state.formData));
              formDataMarca.marca = { id: data.marca.id, label: data.marca.nombre };
              formDataMarca.modelo = null;
              validateForm(this, 'marca', formDataMarca);
              this.setState({ formData: formDataMarca, modelos: [], modelosLoading: true });

              // Disparar modelos y modelo-tipos en paralelo (ambos IDs ya conocidos)
              const modelosReq = this.ajaxHandler.getJson('/modelos/marca/' + data.marca.id + '/select');
              const modeloTiposReq = (data.modelo && data.modelo.tipo)
                ? this.ajaxHandler.getJson('/modelo-tipos/' + data.modelo.tipo.id)
                : Promise.resolve(null);

              Promise.all([modelosReq, modeloTiposReq])
              .then(function(results) {
                var modelos = results[0];
                var modeloTipoData = results[1];
                component.setState({ modelos: modelos });
                if(data.modelo) {
                  let formDataModelo = JSON.parse(JSON.stringify(component.state.formData));
                  formDataModelo.rendimientoEsperadoModelo = data.modelo.rendimientoEsperado ? data.modelo.rendimientoEsperado : '';
                  formDataModelo.capacidadTanqueModelo = data.modelo.capacidadTanque ? data.modelo.capacidadTanque : '';
                  formDataModelo.modelo = { id: data.modelo.id, label: data.modelo.nombre };
                  component.setState({ formData: formDataModelo }, function() { component.getPlanPreventivos(); });
                  if(modeloTipoData) {
                    let valores_dinamicos = castValoresDinamicos(modeloTipoData.atributos_dinamicos, component.state.formData.valores_dinamicos);
                    component.setState({ valores_dinamicos: valores_dinamicos });
                  }
                }
              })
              .catch(function(error) {
                component.ajaxHandler.handleError(error);
              })
              .finally(function() {
                component.setState({ modelosLoading: false });
              });
            }
            if(this.state.formData.es_reserva_asignada){
              this.ajaxHandler.getJson('/moviles/movil-asignado/' + this.state.formData.id)
              .then(data => {
                if(data){
                  component.setState({
                    asignadoA: data[0].movil_asignado
                  })
                }
              });
            }
          }

          if(component.props.action !== 'ADD') {
            this.verificarPermisoTransportadora();
            if(component.state.formData.adjuntos) {
              let adjuntos = component.state.formData.adjuntos;
              for(let i in adjuntos) {
                let fileUrl = '/moviles/adjunto/' + adjuntos[i].adjunto;
                let responseContentType;
                component.ajaxHandler.fetch(fileUrl, {
                  method: 'GET',
                  headers: {
                    'Authorization-Token': localStorage.getItem("token")
                  }
                }).then(response => {
                  if (response.status === 200) {
                    responseContentType = response.headers.get('Content-Type');
                    return response.blob();
                  }
                }).then(imgBlob => {
                  let imgUrl = URL.createObjectURL(imgBlob);
                  var mockFile = {
                    adjunto: adjuntos[i].adjunto,
                    name: adjuntos[i].archivoNombre
                  };
                  this.adjuntosDropzone.emit("addedfile", mockFile);
                  this.adjuntosDropzone.files.push(mockFile);
                  this.adjuntosDropzone.emit("thumbnail", mockFile, responseContentType.includes('image') ? imgUrl : '/images/file.png');
                  this.adjuntosDropzone.emit("complete", mockFile);
                }).catch(() => {
                });
              }
            }
            
            if(this.state.utilizaMovilesReserva) {
              this.getMovilesReservaOptions(movilId, this.state.formData.movil_reserva_id);
            }
          }
        });
      }
    }).finally(() => {
      this.setState({ loading: false });
    });
  }


  loadTicketsData() {
    if(Security.hasPermission('TICKETS_MOVIL_LISTAR')) {
      let component = this;
      this.ajaxHandler.getJson('/tickets/gestoriaAbiertos/movil/' + this.state.props.match.params.id)
      .then(data => {
        if(data)
          component.setState({
            tickets: data
          })
      });
    }
  }

  initFileUpload() {
    let component = this;

    this.fileUploadConfig = {
      showFiletypeIcon: this.props.action === 'ADD' ? true : false,
      postUrl: Config.get('apiUrlBase') + '/moviles/adjunto'
    };

    this.fileUploadDjsConfig = {
      addRemoveLinks: false,
      thumbnailMethod: 'crop',
      dictDefaultMessage: component.state.props.action !== 'VIEW' ? "Haga click aquí o <br> arrastre sus archivos a este área." : '',
      uploadMultiple: true,
      parallelUploads: 1,
      headers: {
        "Authorization-Token": localStorage.getItem("token")
      },
      previewTemplate: `
        <div class="dz-preview dz-image-preview">
          <div class="dz-image">
            <img data-dz-thumbnail src="/images/file.png" />
          </div>
          <div class="dz-progress"><span class="dz-upload" data-dz-uploadprogress="" style="width: 0%;"></span></div>
          <div class="dz-success-mark">
            <svg width="54px" height="54px" viewBox="0 0 54 54" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:sketch="http://www.bohemiancoding.com/sketch/ns">      <title>Check</title>      <defs></defs>      <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" sketch:type="MSPage">        <path d="M23.5,31.8431458 L17.5852419,25.9283877 C16.0248253,24.3679711 13.4910294,24.366835 11.9289322,25.9289322 C10.3700136,27.4878508 10.3665912,30.0234455 11.9283877,31.5852419 L20.4147581,40.0716123 C20.5133999,40.1702541 20.6159315,40.2626649 20.7218615,40.3488435 C22.2835669,41.8725651 24.794234,41.8626202 26.3461564,40.3106978 L43.3106978,23.3461564 C44.8771021,21.7797521 44.8758057,19.2483887 43.3137085,17.6862915 C41.7547899,16.1273729 39.2176035,16.1255422 37.6538436,17.6893022 L23.5,31.8431458 Z M27,53 C41.3594035,53 53,41.3594035 53,27 C53,12.6405965 41.3594035,1 27,1 C12.6405965,1 1,12.6405965 1,27 C1,41.3594035 12.6405965,53 27,53 Z" id="Oval-2" stroke-opacity="0.198794158" stroke="#747474" fill-opacity="0.816519475" fill="#FFFFFF" sketch:type="MSShapeGroup"></path>      </g>    </svg>
          </div>
          <div class="dz-error-mark">
            <svg width="54px" height="54px" viewBox="0 0 54 54" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:sketch="http://www.bohemiancoding.com/sketch/ns">      <title>Error</title>      <defs></defs>      <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" sketch:type="MSPage">        <g id="Check-+-Oval-2" sketch:type="MSLayerGroup" stroke="#747474" stroke-opacity="0.198794158" fill="#FFFFFF" fill-opacity="0.816519475">          <path d="M32.6568542,29 L38.3106978,23.3461564 C39.8771021,21.7797521 39.8758057,19.2483887 38.3137085,17.6862915 C36.7547899,16.1273729 34.2176035,16.1255422 32.6538436,17.6893022 L27,23.3431458 L21.3461564,17.6893022 C19.7823965,16.1255422 17.2452101,16.1273729 15.6862915,17.6862915 C14.1241943,19.2483887 14.1228979,21.7797521 15.6893022,23.3461564 L21.3431458,29 L15.6893022,34.6538436 C14.1228979,36.2202479 14.1241943,38.7516113 15.6862915,40.3137085 C17.2452101,41.8726271 19.7823965,41.8744578 21.3461564,40.3106978 L27,34.6568542 L32.6538436,40.3106978 C34.2176035,41.8744578 36.7547899,41.8726271 38.3137085,40.3137085 C39.8758057,38.7516113 39.8771021,36.2202479 38.3106978,34.6538436 L32.6568542,29 Z M27,53 C41.3594035,53 53,41.3594035 53,27 C53,12.6405965 41.3594035,1 27,1 C12.6405965,1 1,12.6405965 1,27 C1,41.3594035 12.6405965,53 27,53 Z" id="Oval-2" sketch:type="MSShapeGroup"></path>        </g>      </g>    </svg>
          </div>
          <div class="dz-error-message"><span data-dz-errormessage></span></div>
          <div class="dz-filename" style="width: 120px;"><span data-dz-name title="data-dz-name"></span></div>
          <div class="dz-view"><a href="" target="_blank">VER</a></div>
          ${component.state.props.action !== 'VIEW' ? '<div class="dz-remove"><a href="" data-dz-remove>ELIMINAR</a></div>' : ''}
        </div>
      `,

      init: function () {
        let dropzone = this;

        this.on('success', (file, response) => {
          file.adjunto = response.archivo;
          let formDataCopy = JSON.parse(JSON.stringify(component.state.formData));
          formDataCopy.adjuntos.push({adjunto: response.archivo});
          component.setState({
            formData: formDataCopy
          });
        });

        this.on('removedfile', (file) => {
          let formDataCopy = JSON.parse(JSON.stringify(component.state.formData));
          formDataCopy.adjuntos = formDataCopy.adjuntos.filter(a => a.adjunto !== file.adjunto);
          component.setState({
            formData: formDataCopy
          });

          component.ajaxHandler.fetch('/moviles/adjunto/' + file.adjunto, {
            method: 'DELETE'
          })
          .then(response => {
            if(response.status !== 204) {
              Dialog.alert(component.props.intl ,{
                title: component.props.intl.formatMessage({ id: 'movilesAbm.erros.delete_file.error_eliminar_archivo', defaultMessage: 'Error al eliminar el archivo.' })
              });
            }
          }).catch((error) => {
            component.ajaxHandler.handleError(error);
          });
        });

        this.on('error', (file, errormessage, response) => {
          dropzone.removeFile(file);
          Dialog.alert(component.props.intl ,{
            title: component.props.intl.formatMessage({ id: 'movilesAbm.erros.save_file.error_cargar_archivo', defaultMessage: 'Error al cargar el archivo.' })
          });
        });

        this.on('addedfile', function(file) {
          $(file.previewElement).find('.dz-view > a').on('click', (e) => {
            component.ajaxHandler.fetch('/moviles/adjunto/' + file.adjunto, {
              method: 'GET',
              headers: {
                'Authorization-Token': localStorage.getItem("token")
              }
            }).then(response => {
              if (response.status === 200) {
                return response.blob();
              }
            }).then(fileBlob => {
              let fileUrl = URL.createObjectURL(fileBlob);
              window.open(fileUrl);
            }).catch(() => {
            });

            e.preventDefault();
          });
        });

        if(component.state.props.action === 'VIEW') {
          dropzone.disable();
        }
      }
    };

    this.fileUploadHandlers = {
      init: dz => {
        this.adjuntosDropzone = dz;
      }
    };
  }
	handleChangeDireccion(dataDireccion, valueDireccion, direccionValid){
		let formDataCopy = JSON.parse(JSON.stringify(this.state.formData));
    let mapeo = {
			latitud: 'guardaLatitud',
			longitud: 'guardaLongitud',
			calle: 'guardaDireccion',
			numero: 'guardaAltura',
			pais: 'guardaPais',
			provincia: 'guardaProvincia',
			localidad: 'guardaLocalidad',
		}

	  formDataCopy[mapeo[dataDireccion]] = valueDireccion;
    formDataCopy['direccionValid'] = direccionValid;
    this.setState({
      formData: formDataCopy
    });

	}

  handleMarcaChange(object) {
    return new Promise((resolve, reject) => {
      if(object) {
        let formDataCopy = JSON.parse(JSON.stringify(this.state.formData));
        formDataCopy.marca = { id: object.value, label: object.label };
        formDataCopy.modelo = null;

        validateForm(this, 'marca', formDataCopy);

        this.setState({
          formData: formDataCopy,
          modelos: []
        }, () => {
          this.setState({ modelosLoading: true });
          this.ajaxHandler.getJson('/modelos/marca/' + object.value + '/select')
          .then((data) => {
            this.setState({
              modelos: data
            }, () => resolve());
          }).finally(() => {
            this.setState({ modelosLoading: false });
          });
        });
      } else {
        let formDataCopy = JSON.parse(JSON.stringify(this.state.formData));
        formDataCopy.marca = null;
        formDataCopy.modelo = null;

        validateForm(this, 'marca', formDataCopy);

        this.setState({
          formData: formDataCopy,
          provincias: []
        }, () => resolve());
      }
    });
  }
	handleGuardaPersonalizada(guardaEnBase){
		let formDataCopy = JSON.parse(JSON.stringify(this.state.formData));
		formDataCopy['guardaEnBase'] = guardaEnBase;
		this.setState({
				formData: formDataCopy
		});
	}

  handleModeloChange(object) {
    return new Promise((resolve, reject) => {
      if(object) {
        let formDataCopy = JSON.parse(JSON.stringify(this.state.formData));
        formDataCopy.modelo = { id: object.value, label: object.label};

        validateForm(this, 'modelo', formDataCopy);

        this.setState({
          formData: formDataCopy
        }, () => {
            this.setState({unidadMedidorIdLoading: true, planesPreventivosLoading: true, planesVencimientosLoading: true});
            this.ajaxHandler.getJson('/modelos/' + object.value)
            .then((data) => {
              formDataCopy.tipologia_posicion = data.tipologiaPosicion
              this.setState({ formData: formDataCopy });
              this.ajaxHandler.getJson('/modelo-tipos/' + data['tipo']['id'])
              .then((data) => {
                let valores_dinamicos = castValoresDinamicos(data.atributos_dinamicos, this.state.formData.valores_dinamicos)
                this.setState({
                  unidadMedidorId: data['unidadMedidorId'],
                  planPreventivo: data['planPreventivo'],
                  planVencimiento: data['planVencimiento'],
                  valores_dinamicos: valores_dinamicos,
                  modeloTipoPermiteVinculacion: data['permite_vinculacion'] === true
                }, () => {
                  // Fuerzo al default para prevenir asignacion de plan y unidad medidora que no corresponda al tipo de modelo
                  this.state.formData.planPreventivo = this.state.planPreventivo;
                  this.state.formData.unidadMedidorId = this.state.unidadMedidorId;

                  if(!formDataCopy.planVencimiento)
                  {
                    this.state.formData.planVencimiento = this.state.planVencimiento;
                  }
                this.setState({unidadMedidorIdLoading: false, planesPreventivosLoading: false, planesVencimientosLoading: false});
              });
              });
            }).finally(() => resolve());
        });
      } else {
        let formDataCopy = JSON.parse(JSON.stringify(this.state.formData));
        formDataCopy.modelo = null;

        validateForm(this, 'modelo', formDataCopy);

        this.setState({
          formData: formDataCopy
        }, () => resolve());
      }
    });
  }

  handleKmActualChange(event) {
    let maxKm = ConfigBusiness.get('moviles.editaKm.habilitado') === 'true' ? ConfigBusiness.get('moviles.editaKm.maximo') : 0;
    let kmOriginal = this.state.kmTemporal !== null ? parseInt(this.state.kmTemporal.toString().replace(/\D/g,'')) : 0;
    let inputValue = event.target.value == '' ? 0 : event.target.value;
    if (Math.abs(inputValue - kmOriginal) > maxKm) {
      swal({
        title: this.props.intl.formatMessage({ id: 'movilesAbm.modal_updateKm.confirm_diferencia_de_km_mayor_a', defaultMessage: 'Diferencia de Km mayor a ' }) + maxKm + this.props.intl.formatMessage({ id: 'movilesAbm.modal_updateKm.confirm_km_esta_seguro_que_desea_actualizar?', defaultMessage: ' Km. Esta seguro que desea actualizar?' }),
        text: "",
        icon: "warning",
        showCancelButton: true,
        buttons: {
          confirm: {
            text: this.props.intl.formatMessage({ id: 'movilesAbm.modal_updateKm.confirm_aceptar', defaultMessage: 'Aceptar' }),
            value: true,
            visible: true,
            className: "btn btn-success",
            closeModal: true
          },
          cancel: {
            text: this.props.intl.formatMessage({ id: 'movilesAbm.modal_updateKm.confirm_cancelar', defaultMessage: 'Cancelar' }),
            value: null,
            visible: true,
            className: "btn btn-danger",
            closeModal: true,
          }
        }
      }).then(isConfirm => {
        let formDataCopy = JSON.parse(JSON.stringify(this.state.formData));
        formDataCopy["kmActual"] = inputValue;
        if (isConfirm) {
          this.setState({ 
            kmActual: inputValue,
            formData: formDataCopy
          });
        } else {
          formDataCopy["kmUpdateEditAbm"] = false;
          formDataCopy["kmActual"] = kmOriginal;
          this.setState({ cambiokmActual: false, formData: formDataCopy});
          $('#kmActual').val(kmOriginal);
        }
        swal.close();
      });
    };
  }

  validateUnidadDuplicada = async () => {
    const id = this.state.formData.id;
    const unidad = this.state.formData.unidad;
    const movilesUnidadUnico = ConfigBusiness.get('moviles.unidad.unico') === 'true';

    if (!unidad) return;

    this.ajaxHandler.fetch('/moviles/validate/unidad', {
      method: 'POST',
      body: JSON.stringify({
        movil_id: id,
        unidad: unidad
      }),
    })
      .then(response => response.json())
      .then(data => {
        if (
          data
          && data.duplicate === true
          && data.count > 0
        ) {
          if (movilesUnidadUnico) {
            swal2.fire({
              title: this.props.intl.formatMessage({ id: 'movilesAbm.modal_validateUnidad.unidad_duplicada', defaultMessage: 'Unidad duplicada.<br>Ingresá un valor único.' }),
              icon: "warning",
              confirmButtonText: this.props.intl.formatMessage({ id: 'OK', defaultMessage: 'OK' }),
              showCancelButton: false,
            }).then(() => {
              let formDataCopy = JSON.parse(JSON.stringify(this.state.formData));
              formDataCopy.unidad = this.state.unidadGuardada;
              this.setState({ formData: formDataCopy });
            });
          } else {
            swal2.fire({
              title: this.props.intl.formatMessage({ id: 'movilesAbm.modal_validateUnidad.unidad_duplicada', defaultMessage: 'Unidad duplicada.<br>Ingresá un valor único.' }),
              text: this.props.intl.formatMessage({ id: 'movilesAbm.modal_validateUnidad.confirm_cancelar', defaultMessage: '¿Desea continuar o cancelar?' }),
              icon: "warning",
              showCancelButton: true,
              confirmButtonText: this.props.intl.formatMessage({ id: 'movilesAbm.modal_validateUnidad.continuar', defaultMessage: 'Continuar' }),
              cancelButtonText: this.props.intl.formatMessage({ id: 'movilesAbm.modal_validateUnidad.cancelar', defaultMessage: 'Cancelar' }),
            }).then(result => {
              if (!result.value) {
                let formDataCopy = JSON.parse(JSON.stringify(this.state.formData));
                formDataCopy.unidad = this.state.unidadGuardada;
                this.setState({ formData: formDataCopy });
              }
            });
          }
        }
      });
  }

  handleInputFormChange(event) {
		const target = event.target;
		const name = target.name;
		const value = target.type === 'checkbox' ? target.checked : target.value;

		let formDataCopy = JSON.parse(JSON.stringify(this.state.formData));
		formDataCopy[name] = value;

    validateForm(this, name, formDataCopy);

		this.setState({
			formData: formDataCopy
		});
  }

  handleChangeAtributoDinamico(index, key, value) {
    this.state.valores_dinamicos[index][key] = value;
    this.setState({
      valores_dinamicos: this.state.valores_dinamicos
    });
  }

  handleInputSeparadoFormChange(event){

    let val = event.target.value.replace('.','');
    val = val.replace(',','.');
    let formDataCopy = JSON.parse(JSON.stringify(this.state.formData));
    formDataCopy[event.target.name] = val;
    this.setState({
    formData: formDataCopy,
    kmTemporal: event.target.value
    });

  }

  handleFormChangeSelectString(name, object) {
    return new Promise((resolve, reject) => {
      let formDataCopy = JSON.parse(JSON.stringify(this.state.formData));
      if ((name === "traccion" && object !== null) || name === "unidadMedidorId") {
        formDataCopy[name] = object.id;
        if  (name === "unidadMedidorId") {
          formDataCopy['planPreventivo'] = null;
          if (this.state.unidadMedidorIdOriginal && (this.state.unidadMedidorIdOriginal !== object.id)) {
            swal2.fire({
              title: "Tipo de Medidor Diferente!",
              text: "Se actualizara el tipo de medidor y reiniciaran los datos historicos del movil y de las llantas asociadas.",
              icon: "warning",
              confirmButtonText: "Continuar",
            })
          }
        }
        validateForm(this, name, formDataCopy);
        this.setState({
          formData: formDataCopy
        }, () => resolve());
      } else if (name === "estado") {
          this.setEstadoActivo(object ? object.value : null,formDataCopy);
          let estadoClasificadorText = "";
          if(object && object.value){
            if(this.state.arrayDisponibles && this.state.arrayDisponibles.includes(object.value)){
              estadoClasificadorText = this.props.intl.formatMessage({ id: 'Disponible', defaultMessage: 'Disponible' });
            }else if(this.state.arrayNodisponibles && this.state.arrayNodisponibles.includes(object.value)){
              estadoClasificadorText = this.props.intl.formatMessage({ id: 'No_disponible', defaultMessage: 'No disponible' })
            }
          }
          this.setState({
            estadoClasificadorText: estadoClasificadorText
          });
      }  else if (name === "companiaOrigen") {
        formDataCopy[name] = object === null ? '' : object.label
        formDataCopy['compania_origen_id'] = object === null ? '' : object.value
        this.setState({
          formData: formDataCopy
        }, () => resolve());
      } else {
          formDataCopy[name] = object === null ? '' : object.value
          validateForm(this, name, formDataCopy);
          this.setState({
            formData: formDataCopy
          }, () => resolve());
      }

    });
  }

  handleFormChangeSelectTitular(titular) {
    return new Promise((resolve, reject) => {
      let formDataCopy = JSON.parse(JSON.stringify(this.state.formData));
      formDataCopy['titular'] = titular ? {id: titular.value, nombre: titular.label} : null;
      let titularesCopy = JSON.parse(JSON.stringify(this.state.titulares));
      if (titularesCopy.length < 1) {
        titularesCopy = [titular];
      }

      validateForm(this, 'titular', formDataCopy);

      this.setState({
        formData: formDataCopy,
        titulares: titularesCopy
      }, () => resolve());
    });
  }

  handleFormChangeSelectObject(name, object) {
    if (name === 'tipologia_posicion') {
      return new Promise((resolve, reject) => {
        let formDataCopy = JSON.parse(JSON.stringify(this.state.formData));
        formDataCopy[name] = object ? object : null;

        validateForm(this, name, formDataCopy);

        this.setState({
          formData: formDataCopy
        }, () => resolve());
      });
    } else if (name === 'claseEloquent') {
      let formDataCopy = JSON.parse(JSON.stringify(this.state.formData));
      formDataCopy[name] = object ? object : null;

      validateForm(this, name, formDataCopy);

      this.setState({formData: formDataCopy})
    } else if (name === 'basellantas') {
      this.setState({basellantas: object ? object : null})
    } else if (name === 'movilReserva') {
      let formDataCopy = JSON.parse(JSON.stringify(this.state.formData));
      formDataCopy['movil_reserva_id'] = object ? object.value : null;
      this.setState({formData: formDataCopy})
    } else if (name === 'sedeExterna'){
      let formDataCopy = JSON.parse(JSON.stringify(this.state.formData));
      formDataCopy[name] = object ? { id: object.value } : null;

      this.setState({ formData: formDataCopy });
    } else if (name === 'cebe') {
      let formDataCopy = JSON.parse(JSON.stringify(this.state.formData));
      formDataCopy.cebe = object ? { id: object.value, nombre: object.label } : null;
      validateForm(this, name, formDataCopy);
      return new Promise((resolve) => {
        this.setState({ formData: formDataCopy }, () => resolve());
      });
    } else if (name === 'dnrpaSeccional') {
      let formDataCopy = JSON.parse(JSON.stringify(this.state.formData));
      formDataCopy.dnrpaSeccional = object ? { id: object.value, label: object.label } : null;
      validateForm(this, name, formDataCopy);
      return new Promise((resolve) => {
        this.setState({ formData: formDataCopy }, () => resolve());
      });
    } else if (name === 'centroCostos') {
      let formDataCopy = JSON.parse(JSON.stringify(this.state.formData));
      formDataCopy.centroCostos = object ? { id: object.value, nombre: object.label } : null;
      validateForm(this, name, formDataCopy);
      return new Promise((resolve) => {
        this.setState({ formData: formDataCopy }, () => resolve());
      });
    } else if (name === 'base') {
      return new Promise((resolve, reject) => {
        let formDataCopy = JSON.parse(JSON.stringify(this.state.formData));
        formDataCopy.base = object ? { id: object.value, descripcion: object.label } : null;
        validateForm(this, name, formDataCopy);
        this.setState({ formData: formDataCopy }, () => resolve());
      });
    } else {
      return new Promise((resolve, reject) => {
        let formDataCopy = JSON.parse(JSON.stringify(this.state.formData));
        formDataCopy[name] = object ? { id: object.value } : null;
        validateForm(this, name, formDataCopy);

        this.setState({
          formData: formDataCopy
        }, () => resolve());
      });
    }
  }
  
  handleFormChangeTipologia(name, object){
    if(this.state.props.action === 'EDIT' 
      && this.state.tipologiaOriginal 
      && object 
      && this.state.tipologiaOriginal.id !== object.id
      && this.state.llantasDeMovil.length > 0){
      this.setState({
        showModalTipologiaLlanta: true,
        tipologiaSelect: object,
      });

    } else {
      return new Promise((resolve, reject) => {
        let formDataCopy = JSON.parse(JSON.stringify(this.state.formData));
        formDataCopy[name] = object ? object : null;

        validateForm(this, name, formDataCopy);

        this.setState({
          formData: formDataCopy
        }, () => resolve());
      });
    }
  }

  closeModalTipologiaLlanta(){
    this.setState({showModalTipologiaLlanta: false});
  }

  updateTipologiaLlanta(){
    let formDataCopy = JSON.parse(JSON.stringify(this.state.formData));
    formDataCopy['tipologia_posicion'] = this.state.tipologiaSelect;
    this.setState({
      showModalTipologiaLlanta: false,
      formData: formDataCopy,
      tipologiaSelect: null
    });
  }

  handleChangeCentroCosto(name, object){
      const MySwal = withReactContent(Swal);
      if(!this.state.formData.centroCostos || object.value != this.state.formData.centroCostos.id){
        MySwal.fire({
          title: 'Cambio de Centro de Costo',
          html: <CambioCentroCostoMovil
            intl={this.props.intl}
            id={object.value}
            CECOs = {this.state.centrosCostos}
            dominio = {this.state.formData.dominio}
            success={(message) => {
              MySwal.clickConfirm()
              return new Promise((resolve, reject) => {
                let formDataCopy = JSON.parse(JSON.stringify(this.state.formData));
                formDataCopy[name] = object ? { id: object.value, nombre: object.label } : null;

                validateForm(this, 'centroCostos', formDataCopy);

                this.setState({
                  formData: formDataCopy
                }, () => resolve());
              });
            }}
            failure={(message) => {
              Swal.fire(message)
            }}
            dismiss={() => MySwal.clickCancel()}
          />,
          showConfirmButton: false
        })
      }
  }

  handleFormChangeSelectFuncion(funcion) {
    let formDataCopy = JSON.parse(JSON.stringify(this.state.formData));
    formDataCopy['funcion'] = funcion;
    let funcionesCopy = JSON.parse(JSON.stringify(this.state.funciones));
    if (funcionesCopy.length < 1) {
      funcionesCopy = [funcion];
    }
    this.setState({
      formData: formDataCopy,
      funciones: funcionesCopy
    });
  }

  handleFormChangeSelectTransportadora(transportadora) {
    let formDataCopy = JSON.parse(JSON.stringify(this.state.formData));
    formDataCopy['transportadora'] = transportadora;
    let transportadorasCopy = JSON.parse(JSON.stringify(this.state.transportadoras));
    if (transportadorasCopy.length < 1) {
      transportadorasCopy = [transportadora];
    }
    this.setState({
      formData: formDataCopy,
      transportadoras: transportadorasCopy
    });
  }

  handleFormChangeSelectAyudante(ayudante) {
    let formDataCopy = JSON.parse(JSON.stringify(this.state.formData));
    formDataCopy['catalogoAyudante'] = ayudante;
    let catlaogoAyudantesCopy = JSON.parse(JSON.stringify(this.state.catalogoAyudantes));
    if (catlaogoAyudantesCopy.length < 1) {
      catlaogoAyudantesCopy = [ayudante];
    }
    this.setState({
      formData: formDataCopy,
      catalogoAyudantes: catlaogoAyudantesCopy
    });
  }

  handleFormChangeSelectPloteado(ploteado) {
    let formDataCopy = JSON.parse(JSON.stringify(this.state.formData));
    formDataCopy['catalogoPloteado'] = ploteado;
    let catalogoPloteadosCopy = JSON.parse(JSON.stringify(this.state.catalogoPloteados));
    if (catalogoPloteadosCopy.length < 1) {
      catalogoPloteadosCopy = [ploteado];
    }
    this.setState({
      formData: formDataCopy,
      catalogoPloteados: catalogoPloteadosCopy
    });
  }

  handleFormChangeSelectTipoPloteo(tipoPloteo) {
    let formDataCopy = JSON.parse(JSON.stringify(this.state.formData));
    formDataCopy['catalogoTipoPloteo'] = tipoPloteo;
    let catalogoTipoPloteosCopy = JSON.parse(JSON.stringify(this.state.catalogoTipoPloteos));
    if (catalogoTipoPloteosCopy.length < 1) {
      catalogoTipoPloteosCopy = [tipoPloteo];
    }
    this.setState({
      formData: formDataCopy,
      catalogoTipoPloteos: catalogoTipoPloteosCopy
    });
  }

  handleChange(name, object) {
    return new Promise((resolve, reject) => {
      let formDataCopy = JSON.parse(JSON.stringify(this.state.formData));
      formDataCopy[name] = object;
      if(name === "kmActual"){
        if(object){
          object = Number(object)
        }
        let cambiokmActual = false;
        let kmActualDisplay = this.state.formData.unidadMedidorId === ID__UM_ODOMETRO ? Math.floor(UnitSystem.toDisplay(this.state.kmActualDb, 'distance')) : this.state.kmActualDb;
        if(object !== kmActualDisplay){
          formDataCopy["kmUpdateEditAbm"] = true;
          cambiokmActual = true;
        }else{
          formDataCopy["kmUpdateEditAbm"] = false;
          cambiokmActual = false;
        }
        formDataCopy["kmUpdate"] = moment().format('YYYY-MM-DD HH:mm:ss');
        this.setState({ cambiokmActual: cambiokmActual});
      }
      validateForm(this, name, formDataCopy);
      this.setState({
        formData: formDataCopy
      }, () => resolve());
    });
  }

  handleDatePickerFormChange(name, event) {
    let date = null;
    if(name === "kmUpdate"){
      date = event ? event.format('YYYY-MM-DD HH:mm:ss'): '';
    }else{
      date = event ? event.format('YYYY-MM-DD'): null;
    }
    let formDataCopy = JSON.parse(JSON.stringify(this.state.formData));
		formDataCopy[name] = date;

    validateForm(this, name, formDataCopy);

		this.setState({
			formData: formDataCopy
		});
  }

  getJefeBase() {
    if(this.state.formData.base) {
      this.ajaxHandler.getJson('/bases/' + this.state.formData.base.id)
      .then((data) => {
        let formDataCopy = JSON.parse(JSON.stringify(this.state.formData));
        formDataCopy.base.jefe = data.jefe;
        formDataCopy.base.responsable = data.responsable;
        formDataCopy.base.gerenciador = data.gerenciador;
        this.setState({
          formData: formDataCopy
        });
      });
    }
  }

  handleAgregarTitular(){
    let ajaxHandler = this.ajaxHandler;
    swal2.fire({
      title: this.props.intl.formatMessage({ id: 'movilesAbm.modal_add_holder.ingresa_el_nombre_del_titular', defaultMessage: 'Ingresa el nombre del titular' }),
      input: 'text',
      showCancelButton: true,
      inputValidator: (value) => {
        if (!value) {
          return this.props.intl.formatMessage({ id: 'movilesAbm.modal_add_holder.errors_no_puede_estar_vacio_el_nombre', defaultMessage: 'No puede estar vacío el nombre' });
        }
        for (let i = 0; i < this.state.titulares.length; i++) {
          if (this.state.titulares[i].label.toLowerCase() == value.toLowerCase()) {
            return this.props.intl.formatMessage({ id: 'movilesAbm.modal_add_holder.errors_el_titular_ya_existe', defaultMessage: 'El titular ya existe' });
          }
        }
      }
    }).then((result) => {
      if (result.value) {
        ajaxHandler.fetch('/movil-titulares', {
          method: 'POST',
          body: JSON.stringify({
            nombre: result.value
          }),
        }).then(response => response.json()
        .then(nuevoTitular => {
          let formDataCopy = JSON.parse(JSON.stringify(this.state.formData));
          formDataCopy['titular'] = nuevoTitular ? nuevoTitular.id : null;
          let titularesCopy = JSON.parse(JSON.stringify(this.state.titulares));
          if (nuevoTitular) {
            titularesCopy.push({ value: nuevoTitular.id, label: nuevoTitular.nombre });
          }
          this.setState({
            formData: formDataCopy,
            titulares: titularesCopy,
          });
        })).catch((error) => {
          let formDataCopy = JSON.parse(JSON.stringify(this.state.formData));
          formDataCopy['titular'] = null;
          this.setState({
            formData: formDataCopy
          });
        })
      }
    })
  }

  handleAgregarFuncion(){
    let ajaxHandler = this.ajaxHandler;
    swal2.fire({
      title: this.props.intl.formatMessage({ id: 'movilesAbm.modal_add_funcion.nombre', defaultMessage: 'Ingresa el nombre de la funcion' }),
      input: 'text',
      showCancelButton: true,
      inputValidator: (value) => {
        if (!value) {
          return this.props.intl.formatMessage({ id: 'movilesAbm.modal_add_funcion.errors_no_puede_estar_vacio_el_nombre', defaultMessage: 'No puede estar vacío el nombre' });
        }
        for (let i = 0; i < this.state.funciones.length; i++) {
          if (this.state.funciones[i].nombre.toLowerCase() == value.toLowerCase()) {
            return this.props.intl.formatMessage({ id: 'movilesAbm.modal_add_funcion.errors_la_funcion_ya_existe', defaultMessage: 'La funcion ya existe' });
          }
        }
      }
    }).then((result) => {
      if (result.value) {
        ajaxHandler.fetch('/funciones', {
          method: 'POST',
          body: JSON.stringify({
            nombre: result.value
          }),
        }).then(response => response.json()
        .then(nuevaFuncion => {
          let formDataCopy = JSON.parse(JSON.stringify(this.state.formData));
          formDataCopy['funcion'] = nuevaFuncion ? nuevaFuncion : null;
          let funcionesCopy = JSON.parse(JSON.stringify(this.state.funciones));
          if (nuevaFuncion) {
            funcionesCopy.push({ id: nuevaFuncion.id, nombre: nuevaFuncion.nombre });
          }
          this.setState({
            formData: formDataCopy,
            funciones: funcionesCopy,
          });
        })).catch((error) => {
          let formDataCopy = JSON.parse(JSON.stringify(this.state.formData));
          formDataCopy['funcion'] = null;
          this.setState({
            formData: formDataCopy
          });
        })
      }
    })
  }

  handleTransportadoraChange(transportadora) {
    let formDataCopy = JSON.parse(JSON.stringify(this.state.formData));
    formDataCopy['transportadoras'] = Array.isArray(transportadora) ? transportadora : [transportadora];
    this.setState({
      formData: formDataCopy
    });
  }

  handleAgregarTransportadora(){
    let ajaxHandler = this.ajaxHandler;
    swal2.fire({
      title: this.props.intl.formatMessage({ id: 'movilesAbm.modal_add_transportadora.nombre', defaultMessage: 'Ingresa el nombre de la transportadora' }),
      input: 'text',
      showCancelButton: true,
      inputValidator: (value) => {
        if (!value) {
          return this.props.intl.formatMessage({ id: 'movilesAbm.modal_add_transportadora.errors_no_puede_estar_vacio_el_nombre', defaultMessage: 'No puede estar vacío el nombre' });
        }
        for (let i = 0; i < this.state.transportadoras.length; i++) {
          if (this.state.transportadoras[i].nombre.toLowerCase() == value.toLowerCase()) {
            return this.props.intl.formatMessage({ id: 'movilesAbm.modal_add_transportadora.errors_la_transportadora_ya_existe', defaultMessage: 'La transportadora ya existe' });
          }
        }
      }
    }).then((result) => {
      if (result.value) {
        ajaxHandler.fetch('/transportadoras', {
          method: 'POST',
          body: JSON.stringify({
            nombre: result.value
          }),
        }).then(response => response.json()
        .then(nuevaTransportadora => {
          let formDataCopy = JSON.parse(JSON.stringify(this.state.formData));
          formDataCopy['transportadora'] = nuevaTransportadora ? nuevaTransportadora : null;
          let transportadorasCopy = JSON.parse(JSON.stringify(this.state.transportadoras));
          if (nuevaTransportadora) {
            transportadorasCopy.push({ id: nuevaTransportadora.id, nombre: nuevaTransportadora.nombre });
          }
          this.setState({
            formData: formDataCopy,
            transportadoras: transportadorasCopy,
          });
        })).catch((error) => {
          let formDataCopy = JSON.parse(JSON.stringify(this.state.formData));
          formDataCopy['transportadora'] = null;
          this.setState({
            formData: formDataCopy
          });
        })
      }
    })
  }

  handleAgregarAyudante(){
    let ajaxHandler = this.ajaxHandler;
    swal2.fire({
      title: this.props.intl.formatMessage({ id: 'movilesAbm.modal_add_ayudante.nombre', defaultMessage: 'Ingresa el nombre del ayudante' }),
      input: 'text',
      showCancelButton: true,
      inputValidator: (value) => {
        if (!value) {
          return this.props.intl.formatMessage({ id: 'movilesAbm.modal_add_ayudante.errors_no_puede_estar_vacio_el_nombre', defaultMessage: 'No puede estar vacío el nombre' });
        }
        for (let i = 0; i < this.state.catalogoAyudantes.length; i++) {
          if (this.state.catalogoAyudantes[i].valor.toLowerCase() == value.toLowerCase()) {
            return this.props.intl.formatMessage({ id: 'movilesAbm.modal_add_ayudante.errors_el_ayudante_ya_existe', defaultMessage: 'El ayudante ya existe' });
          }
        }
      }
    }).then((result) => {
      if (result.value) {
        ajaxHandler.fetch('/catalogos', {
          method: 'POST',
          body: JSON.stringify({
            valor: result.value,
            tipo: 'ayudante'
          }),
        }).then(response => response.json()
        .then(nuevoAyudante => {
          let formDataCopy = JSON.parse(JSON.stringify(this.state.formData));
          formDataCopy['catalogoAyudante'] = nuevoAyudante ? nuevoAyudante : null;
          let catalogoAyudantesCopy = JSON.parse(JSON.stringify(this.state.catalogoAyudantes));
          if (nuevoAyudante) {
            catalogoAyudantesCopy.push({ id: nuevoAyudante.id, valor: nuevoAyudante.valor, tipo: nuevoAyudante.tipo });
          }
          this.setState({
            formData: formDataCopy,
            catalogoAyudantes: catalogoAyudantesCopy,
          });
        })).catch((error) => {
          let formDataCopy = JSON.parse(JSON.stringify(this.state.formData));
          formDataCopy['catalogoAyudante'] = null;
          this.setState({
            formData: formDataCopy
          });
        })
      }
    })
  }

  handleAgregarPloteado(){
    let ajaxHandler = this.ajaxHandler;
    swal2.fire({
      title: this.props.intl.formatMessage({ id: 'movilesAbm.modal_add_ploteado.nombre', defaultMessage: 'Ingresa el nombre del ploteado' }),
      input: 'text',
      showCancelButton: true,
      inputValidator: (value) => {
        if (!value) {
          return this.props.intl.formatMessage({ id: 'movilesAbm.modal_add_ploteado.errors_no_puede_estar_vacio_el_nombre', defaultMessage: 'No puede estar vacío el nombre' });
        }
        for (let i = 0; i < this.state.catalogoPloteados.length; i++) {
          if (this.state.catalogoPloteados[i].valor.toLowerCase() == value.toLowerCase()) {
            return this.props.intl.formatMessage({ id: 'movilesAbm.modal_add_ploteado.errors_el_ploteado_ya_existe', defaultMessage: 'El Ploteado ya existe' });
          }
        }
      }
    }).then((result) => {
      if (result.value) {
        ajaxHandler.fetch('/catalogos', {
          method: 'POST',
          body: JSON.stringify({
            valor: result.value,
            tipo: 'ploteado'
          }),
        }).then(response => response.json()
        .then(nuevoPloteado => {
          let formDataCopy = JSON.parse(JSON.stringify(this.state.formData));
          formDataCopy['catalogoPloteado'] = nuevoPloteado ? nuevoPloteado : null;
          let catalogoPloteadosCopy = JSON.parse(JSON.stringify(this.state.catalogoPloteados));
          if (nuevoPloteado) {
            catalogoPloteadosCopy.push({ id: nuevoPloteado.id, valor: nuevoPloteado.valor, tipo: nuevoPloteado.tipo });
          }
          this.setState({
            formData: formDataCopy,
            catalogoPloteados: catalogoPloteadosCopy,
          });
        })).catch((error) => {
          let formDataCopy = JSON.parse(JSON.stringify(this.state.formData));
          formDataCopy['catalogoPloteado'] = null;
          this.setState({
            formData: formDataCopy
          });
        })
      }
    })
  }

  handleAgregarTipoPloteo(){
    let ajaxHandler = this.ajaxHandler;
    swal2.fire({
      title: this.props.intl.formatMessage({ id: 'movilesAbm.modal_add_tipo_ploteo.nombre', defaultMessage: 'Ingresa el nombre del tipo de ploteo' }),
      input: 'text',
      showCancelButton: true,
      inputValidator: (value) => {
        if (!value) {
          return this.props.intl.formatMessage({ id: 'movilesAbm.modal_add_tipo_ploteo.errors_no_puede_estar_vacio_el_nombre', defaultMessage: 'No puede estar vacío el nombre' });
        }
        for (let i = 0; i < this.state.catalogoTipoPloteos.length; i++) {
          if (this.state.catalogoTipoPloteos[i].valor.toLowerCase() == value.toLowerCase()) {
            return this.props.intl.formatMessage({ id: 'movilesAbm.modal_add_tipo_ploteo.errors_el_tipo_de_ploteo_ya_existe', defaultMessage: 'El tipo de ploteo ya existe' });
          }
        }
      }
    }).then((result) => {
      if (result.value) {
        ajaxHandler.fetch('/catalogos', {
          method: 'POST',
          body: JSON.stringify({
            valor: result.value,
            tipo: 'tipo_ploteo'
          }),
        }).then(response => response.json()
        .then(nuevoTipoPloteo => {
          let formDataCopy = JSON.parse(JSON.stringify(this.state.formData));
          formDataCopy['catalogoTipoPloteo'] = nuevoTipoPloteo ? nuevoTipoPloteo : null;
          let catalogoTipoPloteosCopy = JSON.parse(JSON.stringify(this.state.catalogoTipoPloteos));
          if (nuevoTipoPloteo) {
            catalogoTipoPloteosCopy.push({ id: nuevoTipoPloteo.id, valor: nuevoTipoPloteo.valor, tipo: nuevoTipoPloteo.tipo });
          }
          this.setState({
            formData: formDataCopy,
            catalogoTipoPloteos: catalogoTipoPloteosCopy,
          });
        })).catch((error) => {
          let formDataCopy = JSON.parse(JSON.stringify(this.state.formData));
          formDataCopy['catalogoTipoPloteo'] = null;
          this.setState({
            formData: formDataCopy
          });
        })
      }
    })
  }

  handlePlanPreventivoChange(planPreventivo){
    let formDataCopy = JSON.parse(JSON.stringify(this.state.formData));
    formDataCopy["planPreventivo"] = planPreventivo;

    validateForm(this, 'planPreventivo', formDataCopy);

    this.setState({
      formData: formDataCopy,
    });
  }

  aplicarCambioEstado(formDataCopy) {
      var cancelacionAutomaticaHabilitada = ConfigBusiness.get('moviles.cancelacionTicketsAlInactivar.habilitado') === 'true';
      if (!formDataCopy['activo'] && this.state.tickets.length && Security.hasPermission('TICKETS_CANCELAR_GESTORIA') && !cancelacionAutomaticaHabilitada) {
          swal({
            title: "Este móvil tiene " + this.state.tickets.length + " tickets de gestoría asociados. ¿Desea cancelarlos?",
            text: "",
            icon: "warning",
            buttons: {
              confirm: {
                text: "Cancelar Tickets",
                value: true,
                visible: true,
                className: "btn btn-danger",
                closeModal: true
              },
              cancel: {
                text: "Continuar, sin cancelaciones",
                value: null,
                visible: true,
                className: "btn",
                closeModal: true,
              }
            }
          }).then(isConfirm => {
            if(isConfirm) {
              this.state.tickets.forEach((ticket, i) => {
                this.ajaxHandler.fetch('/tickets/cancelar/' + ticket.id, {
                  method: 'POST',
                  body: JSON.stringify({
                    comentario: 'Inhabilito Móvil'
                  }),
                })
                .then(() => {
                  if(formDataCopy['id'] && formDataCopy['estado'] !== this.state.formData['estado'] && ConfigBusiness.get('moviles.motivo.cambioestado') === 'true') {
                    this.setState({ showModalCambioEstado: true });
                  } else {
                    this.setState({ formData: formDataCopy });
                  }
                })
              });
            } else {
              if(formDataCopy['id'] && formDataCopy['estado'] !== this.state.formData['estado'] && ConfigBusiness.get('moviles.motivo.cambioestado') === 'true') {
                this.setState({ showModalCambioEstado: true });
              } else {
                this.setState({ formData: formDataCopy });
              }
            }
          })
      } else if(!formDataCopy['activo'] && this.state.tickets.length && !cancelacionAutomaticaHabilitada) {
        swal({
            title: "Este móvil tiene " + this.state.tickets.length + " tickets de gestoría asociados, cancele el ticket.",
            text: "",
            icon: "warning",
            buttons: {
              confirm: {
                text: "Aceptar",
                value: true,
                visible: true,
                className: "btn btn-success",
                closeModal: true
              }
            }
          })
      } else {
        if(formDataCopy['id'] && formDataCopy['estado'] !== this.state.formData['estado'] && ConfigBusiness.get('moviles.motivo.cambioestado') === 'true') {
          this.setState({ showModalCambioEstado: true });
        } else {
          this.setState({ formData: formDataCopy });
        }
      }
  }

  setEstadoActivo(estado, formDataCopy) {
      let activo = this.state.estadosActivos.findIndex(e => e === estado) !== -1 ? true : false;
      formDataCopy['activo'] = activo;
      formDataCopy['estado'] = estado;
      this.setState({ formDataCopy: formDataCopy });

      if (!activo && formDataCopy.id && ConfigBusiness.get('moviles.cancelacionTicketsAlInactivar.habilitado') === 'true') {
        this.ajaxHandler.getJson('/moviles/' + formDataCopy.id + '/tickets-activos')
          .then(data => {
            var cantidad = data && data.cantidad ? data.cantidad : 0;
            if (cantidad > 0) {
              swal({
                title: this.props.intl.formatMessage({ id: 'movilesAbm.setEstadoActivo.confirm_cancelacion_tickets.title', defaultMessage: 'Este vehículo tiene {cantidad} ticket(s) activo(s). Al inactivarlo, se cancelarán automáticamente. ¿Confirma?' }, { cantidad: cantidad }),
                text: '',
                icon: 'warning',
                buttons: {
                  confirm: { text: this.props.intl.formatMessage({ id: 'movilesAbm.setEstadoActivo.confirm_cancelacion_tickets.button_confirmar', defaultMessage: 'Confirmar' }), value: true, visible: true, className: 'btn btn-primary', closeModal: true },
                  cancel: { text: 'Cancelar', value: null, visible: true, className: 'btn btn-danger', closeModal: true }
                }
              }).then(isConfirm => {
                if (isConfirm) {
                  this.aplicarCambioEstado(formDataCopy);
                }
              });
            } else {
              this.aplicarCambioEstado(formDataCopy);
            }
          })
          .catch(() => {
            swal({
              title: this.props.intl.formatMessage({ id: 'movilesAbm.setEstadoActivo.confirm_cancelacion_tickets.error_conteo.title', defaultMessage: 'No se pudo verificar la cantidad de tickets activos. ¿Desea continuar con la inactivación de todas formas?' }),
              text: '',
              icon: 'warning',
              buttons: {
                confirm: { text: this.props.intl.formatMessage({ id: 'movilesAbm.setEstadoActivo.confirm_cancelacion_tickets.button_confirmar', defaultMessage: 'Confirmar' }), value: true, visible: true, className: 'btn btn-success', closeModal: true },
                cancel: { text: 'Cancelar', value: null, visible: true, className: 'btn btn-danger', closeModal: true }
              }
            }).then(isConfirm => {
              if (isConfirm) {
                this.aplicarCambioEstado(formDataCopy);
              }
            });
          });
      } else {
        this.aplicarCambioEstado(formDataCopy);
      }
  }

  handleSubmitCambioEstado(nuevoEstado, motivo) {
    let formDataCopy = JSON.parse(JSON.stringify(this.state.formDataCopy));
    formDataCopy['motivoCambioEstado'] = motivo;
    this.setState({
        formData: formDataCopy,
        showModalCambioEstado: false
    });
  }

  validateDomainChange(){
    if(this.state.props.action === 'EDIT' && this.state.dominioGuardado !== this.state.formData.dominio && 
      !this.state.validationErrors.dominio){
        let MySwal = withReactContent(Swal);
        let dominioBack = this.state.dominioGuardado;
        let dominio = this.state.formData.dominio
        MySwal.fire({
          title: this.props.intl.formatMessage({ id: 'Cambio_de_vehículo', defaultMessage: 'Cambio de vehículo' }),
          html: <CambioDominioMovil
            id={this.state.formData.id}
            CECOs = {this.state.centrosCostos}
            dominio = {this.state.formData.dominio}
            intl={this.props.intl}
            success={(message) => {
              MySwal.clickConfirm()
              return new Promise((resolve, reject) => {
                let formDataCopy = JSON.parse(JSON.stringify(this.state.formData));
                validateForm(this, 'dominio', formDataCopy);
                dominioBack = dominio;
                this.setState({
                  formData: formDataCopy,
                  dominioGuardado: dominio
                }, () => {
                  Swal.fire(message);
                  resolve()
                });
              });
            }}
            failure={(message) => {
              Swal.fire(message)
            }}
            dismiss={() => {
              MySwal.clickCancel()
            }}
          />,
          showConfirmButton: false,
          onAfterClose: () =>  {
            if(dominioBack !== dominio){
              let formDataCopy = JSON.parse(JSON.stringify(this.state.formData));
              formDataCopy.dominio = dominioBack;
              this.setState({formData: formDataCopy});
            }
          }
        })
    }
  }

  validateUnidadChange(){
    if(this.state.props.action === 'EDIT' && this.state.unidadGuardada !== this.state.formData.unidad && 
      !this.state.validationErrors.unidad){
        let MySwal = withReactContent(Swal);
        let unidadBack = this.state.unidadGuardada;
        let unidad = this.state.formData.unidad
        MySwal.fire({
          title: this.props.intl.formatMessage({ id: 'Cambio_de_vehículo', defaultMessage: 'Cambio de vehículo' }),
          html: <CambioUnidadMovil
            id={this.state.formData.id}
            CECOs = {this.state.centrosCostos}
            unidad = {this.state.formData.unidad}
            intl={this.props.intl}
            success={(message) => {
              MySwal.clickConfirm()
              return new Promise((resolve, reject) => {
                let formDataCopy = JSON.parse(JSON.stringify(this.state.formData));
                validateForm(this, 'unidad', formDataCopy);
                unidadBack = unidad;
                this.setState({
                  formData: formDataCopy,
                  unidadGuardada: unidad
                }, () => {
                  Swal.fire(message);
                  resolve()
                });
              });
            }}
            failure={(message) => {
              Swal.fire(message)
            }}
            dismiss={() => {
              MySwal.clickCancel()
            }}
          />,
          showConfirmButton: false,
          onAfterClose: () =>  {
            if(unidadBack !== unidad){
              let formDataCopy = JSON.parse(JSON.stringify(this.state.formData));
              formDataCopy.unidad = unidadBack;
              this.setState({formData: formDataCopy});
            }
          }
        })
    }
  }

	handleSubmit(event) {
    // TODO: Para los casos de modificacion de un movil, donde el dato modificado es dominio o unidad,
    // solo se esta realizando el insert en la tabla log y de la modifiación de dichos campos,
    // y se esta obviando el resto de los campos, eventualmente modificados
    if(
        (this.state.formData.dominio === this.state.dominioGuardado &&
          this.state.formData.unidad === this.state.unidadGuardada) ||
        this.props.action === 'ADD'
    ) {
      if(this.state.formData.kmUpdate){
        let kmUpdate = moment(this.state.formData.kmUpdate);
        if(this.state.formData.kmUpdateEditAbm && !kmUpdate.isSameOrBefore(moment())){
          swal({
            title: this.props.intl.formatMessage({ id: 'Fecha de Lectura', defaultMessage: 'Fecha de Lectura' }),
            text: this.props.intl.formatMessage({ id: 'La_Fecha_de_Lectura_debe_ser_anterior_a_la_fecha_y_hora_actual', defaultMessage: 'La Fecha de Lectura debe ser anterior a la fecha y hora actual' }) ,
            icon: "error",
            button: this.props.intl.formatMessage({ id: 'Continuar', defaultMessage: 'Continuar' }),
          })
          event.preventDefault();
          return;
        }
      }
      this.setState({ loading: true });
		  let component = this;
      this.state.formData.valores_dinamicos = this.state.valores_dinamicos;
      let equipamientos = this.props.action === 'EDIT' && !Security.hasPermission('MOVILES_MODIFICAR_EQUIPAMIENTO') ? this.state.formData.equipamientos.map( equipamiento => equipamiento.id) : this.state.formData.equipamientos;
      let formDataCopy = JSON.parse(JSON.stringify(this.state.formData));
      if (formDataCopy.kmActual !== null && formDataCopy.kmActual !== undefined && formDataCopy.kmActual !== '' && formDataCopy.unidadMedidorId === ID__UM_ODOMETRO) {
        if (this.state.cambiokmActual) {
          formDataCopy.kmActual = UnitSystem.toStorage(formDataCopy.kmActual, 'distance');
        } else {
          formDataCopy.kmActual = this.state.kmActualDb;
        }
      }
      formDataCopy.es_reserva = this.state.formData.es_reserva !== null
                                ? this.state.formData.es_reserva.value
                                : (
                                    (Security.hasPermission('MOVILES_RESERVA_LECTURA')) 
                                    && this.props.action === 'ADD'
                                  )
                                  ? true
                                  : null;
      this.ajaxHandler.fetch('/moviles' + (this.props.action === 'ADD' ? '' : '/' + this.state.formData.id), {
        method: this.props.action === 'ADD' ? 'POST' : 'PUT',
        body: JSON.stringify({
          ...formDataCopy,
          equipamientos: equipamientos,
        }),
      }).then(response => {
        if(response.status !== 400) {
          component.exit();
        } else {
          response.json()
          .then(data => {
            if(data.detalle.indexOf("movilController.errors.no_puede_cambiar_tipologia_posicion_tiene_llantas") >= 0){
                swal({
                    title: this.props.intl.formatMessage({ id: 'movilesAbm.modal_error_cambio_tipologia_posicion.titulo', defaultMessage: 'Vehículo tiene llantas asignadas' }),
                    text: this.props.intl.formatMessage({ id: 'movilesAbm.modal_error_cambio_tipologia_posicion.texto', defaultMessage: 'Este vehículo cuenta con llantas asignadas, debe desasignarlas para poder cambiar el diagrama de Posicion.' }) ,
                    icon: "error",
                    button: this.props.intl.formatMessage({ id: 'movilesAbm.modal_error_cambio_tipologia_posicion.button_continuar', defaultMessage: 'Continuar' }),
                  })
            }
            else{
                this.setState({
                  errors: data.detalle
                });
            }
          });
        }
        window.scrollTo(0,0);
      }).catch((error) => {
        this.ajaxHandler.handleError(error);
      }).finally(() => {
        this.setState({ loading: false });
      });
    } else {
      if(this.state.formData.dominio !== this.state.dominioGuardado){
        this.validateDomainChange();
      }
      if(this.state.formData.unidad !== this.state.unidadGuardada){
        this.validateUnidadChange();
      }
    }
		event.preventDefault();
	}

	handleCancel(event) {
		this.exit();
	}

  handleBuscarInfracciones(buscar_infracciones){
		let formDataCopy = JSON.parse(JSON.stringify(this.state.formData));
		formDataCopy['buscar_infracciones'] = buscar_infracciones;
		this.setState({
				formData: formDataCopy
		});
	}

  handleChangePropio(name, value){
		let formDataCopy = JSON.parse(JSON.stringify(this.state.formData));
    if(name == 'rendimientoPropio'){
      formDataCopy['rendimientoPropio'] = value;
      formDataCopy['rendimientoEsperado'] = value ? '' : this.state.formData.rendimientoEsperadoModelo;
    }
    if(name == 'tanquePropio'){
      formDataCopy['tanquePropio'] = value;
      formDataCopy['capacidadTanque'] = value ? '' : this.state.formData.capacidadTanqueModelo;
    }

    validateForm(this, name, formDataCopy);

		this.setState({
				formData: formDataCopy
		});
	}

	exit() {
		this.setState({
			redirectTo: '/moviles'
    });
	}

    handleGpsChange(gps, force, sync_avl) {
        let formDataCopy = JSON.parse(JSON.stringify(this.state.formData));

        formDataCopy['gps_model'] = gps
        formDataCopy['gps_model_id'] = (gps) ? gps.id : null
        formDataCopy['force_avl_odometer'] = force
        formDataCopy['sync_avl'] = sync_avl

        this.setState({
            formData: formDataCopy
        })
    }

  handleSetTipo(tipo) {
      this.setState({
          tipoModal: tipo
      })
  }



  handleAdjuntosChange(adjuntosCategorias) {
    let arrayAdjuntos = []
    adjuntosCategorias.map((adjuntoCategoria)=>{
      adjuntoCategoria.adjuntos.map((adjunto)=>{
        adjunto.categoria = {
          id: adjuntoCategoria.id,
          nombre:adjuntoCategoria.nombre
        }
        arrayAdjuntos.push(adjunto)
      })
    })
    let formDataCopy = JSON.parse(JSON.stringify(this.state.formData));
    formDataCopy.adjuntos = arrayAdjuntos;
    this.setState({
      formData: formDataCopy
    });
  }

verificarPermisoTransportadora() {
  if (Security.hasPermission('USUARIO_TRABAJAR_TRANSPORTADORA')) {
    Promise.all([
      Utils.getData(`/transportadoras/verTransportadorasAsignadas`),
    ]).then((data) => {
      const filteredTransportadoras = this.state.formData.transportadoras.filter((transportadora) =>
        data[0].includes(transportadora.id)
      );
      this.setState((prevState) => ({
        formData: {
          ...prevState.formData,
          transportadoras: filteredTransportadoras,
        },
      }));
    });
  } else {
    this.setState((prevState) => ({
      formData: {
        ...prevState.formData,
        transportadoras: this.state.formData.transportadoras,
      },
    }));
  }
}

handleChangeTarjetaCombustible(){
  if(this.state.props.action === 'EDIT' ){
    let MySwal = withReactContent(Swal);
    const tjtComOrig = this.state.tarjetaCombustibleOrig.split(/[,;]/);
    const tjtCom = this.state.formData.ypfRuta.split(/[,;]/);

    // si no cambio el contenido no hago nada
    if (tjtComOrig.length === tjtCom.length && tjtComOrig.every((e, i) => e === tjtCom[i])) return;
    
    const eliminados = tjtComOrig.filter(item =>!tjtCom.includes(item) && item !== '');
    //si solo hay datos nuevos no se registra historial
    if (eliminados.length > 0) {
      MySwal.fire({
        title: "Cambio de " + this.props.intl.formatMessage({
          id: "movilesAbm.render.administracion.label_YPF_ruta", defaultMessage: "YPF Ruta"
        }),
        html: <CambioTarjetaCombustible
          id={this.state.formData.id}
          tarjetaCombustible = { tjtCom.join() }
          dominio = {this.state.formData.dominio}
          intl={this.props.intl}
          success={(message) => {
            MySwal.clickConfirm()
            return new Promise((resolve, reject) => {
              let formDataCopy = JSON.parse(JSON.stringify(this.state.formData));
              validateForm(this, 'ypfRuta', formDataCopy);
              this.setState({
                formData: formDataCopy,
              }, () => {
                Swal.fire({
                  title: "Se ha actualizado exitosamente la " + this.props.intl.formatMessage({
                    id: "movilesAbm.render.administracion.label_YPF_ruta", defaultMessage: "YPF Ruta"
                  })
                });
                this.setState({
                  tarjetaCombustibleOrig: this.state.formData.ypfRuta
                }); 
                resolve()
              });
            });
          }}
          failure={(message) => {
            Swal.fire(message)
          }}
          dismiss={() => {
            MySwal.clickCancel()
          }}
        />,
        showConfirmButton: false,
        onAfterClose: () =>  {
          let formDataCopy = this.state.formData;
          formDataCopy.ypfRuta = this.state.tarjetaCombustibleOrig
          this.setState({
            formData: formDataCopy
          });
        }
      })
    } else {
      const data = {
        id: this.state.formData.id,
        dominio: this.state.formData.dominio,
        tarjeta_combustible: this.state.formData.ypfRuta,
        esActualizacion: false
      }
      this.ajaxHandler.fetch("/moviles/actualizar/tarjeta_combustible",
        {
          method: 'POST',
          body: JSON.stringify(data)
        }
      )
      .then(() => {
        Swal.fire({
          title: "Se ha actualizado exitosamente la " + this.props.intl.formatMessage({
            id: "movilesAbm.render.administracion.label_YPF_ruta", defaultMessage: "YPF Ruta"
          })
        });
        this.setState({
          tarjetaCombustibleOrig: this.state.formData.ypfRuta
        });
      })
      .catch((error) => {
        let formDataCopy = this.state.formData;
        formDataCopy.ypfRuta = this.state.tarjetaCombustibleOrig
        this.setState({
          formData: formDataCopy
        });
      });
    }

  }
}
handleSelectChange = (selectedOption) => {
    this.setState((prevState) => ({
        formData: {
            ...prevState.formData,
            base: selectedOption ? { 
                id: selectedOption.value, 
                descripcion: selectedOption.label 
            } : null 
        }
    }));
};

  getMaxTime(data){
    if(data){
      let selectedDate = moment(data)
      let today = moment().startOf("day");
      return selectedDate.isSame(today, 'day') ? moment().hours(moment().hours()).minutes(moment().minutes()) : moment().hours(23).minutes(59);
    }else{
      return moment().hours(23).minutes(59)
    }
  };

  getGerenciadorValue() {
    const { formData, asignacionManualGerenciador, basesLoading } = this.state;
    if(basesLoading) return null;

    if (asignacionManualGerenciador && formData.gerenciador) {
      return {
        value: formData.gerenciador.id,
        label: formData.gerenciador.razonSocial
      };
    } else if (formData.base && formData.base.gerenciador) {
      return { 
        value: formData.base.gerenciador.id,
        label: formData.base.gerenciador.razonSocial
      }
    } else { 
      return null 
    }
  }

  handleGerenciadorChange(e) {
    const formDataCopy = JSON.parse(JSON.stringify(this.state.formData));
  
    formDataCopy.gerenciador = e 
      ? { id: e.value, razonSocial: e.label }
      : null;
  
    this.setState({ formData: formDataCopy });
  }

  getResponsableBaseValue() {
    const { formData, asignacionManualResponsableBase, basesLoading } = this.state;
    if (basesLoading) return null;

    if (asignacionManualResponsableBase && formData.responsable_base) {
      return {
        id: formData.responsable_base.id,
        label: formData.responsable_base.label
      };
    } else if (formData.base && formData.base.responsable) {
      const resp = formData.base.responsable;
      return {
        id: resp.id,
        label: resp.apellido + ' ' + resp.nombre + ' (DNI: ' + resp.documentoNumero + ')'
      }
    } else {
      return null
    }
  }

  handleResponsablesBaseChange(e) {
    const formDataCopy = JSON.parse(JSON.stringify(this.state.formData));
    formDataCopy.responsable_base = e
      ? { id: e.id, label: e.label }
      : null;

    this.setState({ formData: formDataCopy });
  }

  getVehiculoReservaValue(action = null) {
    const { formData, utilizaMovilesReserva, movilesReservaLoading, movilesReserva, count } = this.state;
    if(movilesReservaLoading) return null;
    
    if (utilizaMovilesReserva && formData.movil_reserva_id) {
      const movil = movilesReserva.find(m => m.value === formData.movil_reserva_id);
      return action === 'view' ? movil.label : movil; 
    }
  }

  handleChangeRentadora(rentadora) {
    const formDataCopy = JSON.parse(JSON.stringify(this.state.formData));
    formDataCopy.rentadora = rentadora;
    formDataCopy.contrato = {
                id: "",
                movil_id: formDataCopy.id,
                rentadora_id: rentadora ? rentadora.id : "",
                odometro_limite_contrato: "",
                porcentaje_alerta_utilizacion: "",
                kms_excedente: "",
                nro_cuotas_depreciacion: "",
                nro_cuotas_leasing: "",
                tasa_impuestos: "",
                valor_cuota_depreciacion: "",
                valor_cuota_leasing: "",
                valor_interes_mensual: "",
            };
    
    this.setState({
      formData: formDataCopy
    }, () => {
      validateForm(this, 'rentadora', this.state.formData);
    });
  }

  handleChangeContrato(input, value) {
    const formDataCopy = JSON.parse(JSON.stringify(this.state.formData));
    formDataCopy.contrato[input] = value

    validateForm(this, input, formDataCopy.contrato );

    this.setState({
      formData: formDataCopy
    });
  }

  handleAgregarRentadora(value){
    swal2.fire({
      title: this.props.intl.formatMessage({ id: 'movilesAbm.modal_add_rentadora.placeholder.ingresar', defaultMessage: 'Ingresa el nombre de la rentadora' }),
      input: 'text',
      showCancelButton: true,
      inputValidator: (value) => {
        if (!value) {
          return this.props.intl.formatMessage({ id: 'movilesAbm.modal_add_rentadora.errors_no_puede_estar_vacio_el_nombre', defaultMessage: 'No puede estar vacío el nombre' });
        }
        for (let i = 0; i < this.state.rentadoras.length; i++) {
          if (this.state.rentadoras[i].descripcion.toLowerCase() === value.toLowerCase()) {
            return this.props.intl.formatMessage({ id: 'movilesAbm.modal_add_rentadora.errors_rentadora_ya_existe', defaultMessage: 'La Rentadora ya existe' });
          }
        }
      }
    }).then(result => {
      if (result.value) {
        this.ajaxHandler.fetch('/rentadoras', {
          method: 'POST',
          body: JSON.stringify({
            descripcion: result.value
          }),
        }).then(response => response.json()
        .then(nuevaRentadora => {
          const formDataCopy = JSON.parse(JSON.stringify(this.state.formData));
          formDataCopy.rentadora = nuevaRentadora ? nuevaRentadora : null;
          formDataCopy.contrato = {
                id: "",
                movil_id: formDataCopy.id,
                rentadora_id: nuevaRentadora ? nuevaRentadora.id : null,
                odometro_limite_contrato: "",
                porcentaje_alerta_utilizacion: "",
                kms_excedente: "",
                nro_cuotas_depreciacion: "",
                nro_cuotas_leasing: "",
                tasa_impuestos: "",
                valor_cuota_depreciacion: "",
                valor_cuota_leasing: "",
                valor_interes_mensual: "",
            };
          let rentadorasCopy = JSON.parse(JSON.stringify(this.state.rentadoras));
          rentadorasCopy.push(nuevaRentadora);
          this.setState({
            formData: formDataCopy,
            rentadoras: rentadorasCopy,
          });
          this.limpiarValidadorContrato();
        })).catch((error) => {
        })
      }
    })
  }

  handleModalCloseCambioEstado(){
    this.setState({
      showModalCambioEstado: false
    });
  }

  limpiarValidadorContrato() {
    const contrato = this.state.formData.contrato;
    validateForm(this, 'odometro_limite_contrato', contrato);
    validateForm(this, 'porcentaje_alerta_utilizacion', contrato);
    validateForm(this, 'kms_excedente', contrato);
    validateForm(this, 'nro_cuotas_depreciacion', contrato);
    validateForm(this, 'nro_cuotas_leasing', contrato);
    validateForm(this, 'tasa_impuestos', contrato);
    validateForm(this, 'valor_cuota_depreciacion', contrato);
    validateForm(this, 'valor_cuota_leasing', contrato);
    validateForm(this, 'valor_interes_mensual', contrato);
  }


	render() {
		let state = this.state;
    let formData = state.formData;
    let validationState = state.schema ? state.schema.isValidSync(formData) : null;

    let base = formData.base ? formData.base : null;
    let sedeExterna = formData.sedeExterna ? state.sedesExternas.find(e => e.value === formData.sedeExterna.id) : null;
    let marca = formData.marca ? state.marcas.find(e => e.value === formData.marca.id) : null;
    let modelo = formData.modelo ? state.modelos.find(e => e.value === formData.modelo.id) : null;
  
    let planVencimiento = formData.planVencimiento ? state.planesVencimiento.find(e => e.value === formData.planVencimiento.id) : null;
    let centroCostos = state.viewCentroCostos && formData.centroCostos ? formData.centroCostos : null;
    let cebe = state.viewCebe && formData.cebe ? formData.cebe : null;
    let tipologia = formData.tipologia_posicion_id && !formData.tipologia_posicion ? state.tipologias.find(e => e.id === formData.tipologia_posicion_id) : null;
    let estado = formData.estado !== '' ? state.estados.find(e => e.value === formData.estado) : null;
    let companiaOrigen = formData.companiaOrigen !== '' ? state.companiasOrigen.find(e => e.value === formData.compania_origen_id) : null;
    let titular = formData.titular ? state.titulares.find(e => e.value === formData.titular || e.value == formData.titular["id"]) : null;
    let movilCombustibleTipo = formData.movilCombustibleTipo ? state.movilCombustibleTipos.find(e => e.value === formData.movilCombustibleTipo.id) : null;
    let dnrpaSeccional = formData.dnrpaSeccional ? formData.dnrpaSeccional : null;
    let proveedorGps = formData.proveedorGps ? state.proveedoresGps.find(e => e.value === formData.proveedorGps.id) : null;
    let division = formData.division ? state.divisiones.find(e => e.value === formData.division.id) : null;
    let requiredSymbol = this.state.props.action !== 'VIEW' ? ' *' : '';
    //validaciones para boton guardar
    const validacionInvalida = !validationState;
    const baseODireccionInvalida = !this.state.formData.guardaEnBase && !this.state.formData.direccionValid;
    const divisionHabilitada = ConfigBusiness.get('moviles.trabajaConDivisiones.habilitado') === 'true';
    const divisionFaltante = divisionHabilitada ? !this.state.formData.division : false;
    const permisoMovilesModificarBase=Security.hasPermission('MOVILES_MODIFICAR_BASE');
    const modificarRentadora = Security.hasPermission('MOVILES_MODIFICAR_DATOS_RENTADORA') && this.state.props.action !== 'VIEW';
    
    const guardarDeshabilitado = validacionInvalida || baseODireccionInvalida || divisionFaltante

    const hasPermisoReserva = Security.hasPermission('MOVILES_RESERVA_LECTURA');

    const modificaEstadoAmplio = Security.hasPermission('MOVILES_MODIFICAR_DATOS_GENERALES') && Security.hasPermission('MOVILES_MODIFICAR_ESTADO');
    const modificaEstadoActivos = Security.hasPermission('MOVILES_MODIFICAR_DATOS_GENERALES') && Security.hasPermission('MOVILES_MODIFICAR_ESTADO_ACTIVOS');
    const modificaEstado = modificaEstadoAmplio || modificaEstadoActivos;
    const restringidoAEstadosActivos = !modificaEstadoAmplio && modificaEstadoActivos;
    const estadoOptions = restringidoAEstadosActivos
      ? state.estados.map((e) => ({ ...e, disabled: state.estadosActivos.indexOf(e.value) === -1 }))
      : state.estados;

		return (
			<React.Fragment>
        {this.state.redirectTo && <Redirect push to={this.state.redirectTo} />}
				{this.state.loading && <Loading />}
        <Modal
          open={this.state.showModalCambioEstado}
          onClose={this.handleModalCloseCambioEstado}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            borderRadius: "15px"
          }}
          BackdropComponent={Backdrop}
        >
          <Fade in={this.state.showModalCambioEstado}>
            <div style={{
              backgroundColor: "#fff", // o theme.palette.background.paper si no usás theme
              border: "0px solid #000",
              boxShadow: "0px 3px 6px rgba(0,0,0,0.16)",
              padding: "16px 32px 24px", // equivalente a theme.spacing(2, 4, 3)
              borderRadius: "15px"
            }}>
              <MovilesCambioEstado
                intl={this.props.intl}
                movil={this.state.formData}
                modeloNombre={this.state.formData.modelo ? this.state.formData.modelo.label : null}
                handleModalCloseCambioEstado={this.handleModalCloseCambioEstado}
                handleSubmitCambioEstado={this.handleSubmitCambioEstado}
                nuevoEstado={this.state.formDataCopy ? this.state.formDataCopy.estado : null}
              />
            </div>
          </Fade>
        </Modal>
			  <div className="row">
          <div className="col-md-12">
            <div className="alert alert-danger" role="alert" hidden={this.state.errors.length===0}>
							{this.state.errors.map((e, i) => <li key={i}><FormattedMessage {...(backendStrings[e] ? backendStrings[e] : backendStrings['errors.default'])}/></li>)}
						</div>
            <form className="form form-horizontal" ref="form" onSubmit={this.handleSubmit}>
              <div className="form-body">
                <div className="card pull-up">
                  <div className="card-content">
                    <div className="card-body">
                      <h4 className="form-section">
                        <i className="la la-info-circle"></i> <FormattedMessage id="movilesAbm.render.general_data.header_datos_generales" defaultMessage="Datos Generales"/> <div className="float-right" style={{fontSize:'14px'}}>* <FormattedMessage id="movilesAbm.render.general_data.campos requeridos" defaultMessage="campos requeridos"/></div>
                      </h4>                        
                      <div className="row">
                        {/* DOMINIO */}
                        <div className="col-md-6">
                          <div className="form-group row">
                            <label className="col-md-3 label-control col-form-label" htmlFor="dominio">
                              <FormattedMessage id="movilesAbm.render.general_data.label_dominio" defaultMessage="Dominio"/>{requiredSymbol}:
                            </label>
                            <div className="col-md-9">
                              {(this.state.disableAvlFields && this.props.action === 'EDIT' )|| this.props.action === 'VIEW' || (this.props.action === 'EDIT' && !Security.hasPermission('MOVILES_MODIFICAR_DATOS_GENERALES')) ? (
                              <div className="form-control-static col-form-label form-value">{formData.dominio ? formData.dominio : ''}</div>
                              ) : (
                              <div>
                                <input
                                  type="text"
                                  id="dominio"
                                  name="dominio"
                                  placeholder={"("+this.props.intl.formatMessage({ id: 'movilesAbm.render.general_data.placeholder_dominio', defaultMessage: 'Requerido' })+")"} value={formData.dominio ? formData.dominio : ''}
                                  onChange={this.handleInputFormChange}
                                  className={this.state.validationErrors.dominio ? 'form-control is-invalid' : 'form-control'}
                                  onBlur={this.validateDomainChange}
                                  data-db-column="dominio"
                                />
                                <small className="text-danger">{this.state.validationErrors.dominio}</small>
                              </div>
                              )}
                            </div>
                          </div>
                        </div>
                        {/* ESTADO */}
                        { ConfigBusiness.get('moviles.estado.habilitado') === 'true' ? (
                        <div className="col-md-6">
                          <div className="form-group row">
                            <label className="col-md-3 label-control col-form-label" htmlFor="estado">
                              <FormattedMessage id="movilesAbm.render.general_data.label_estado" defaultMessage="Estado"/>{requiredSymbol}:
                            </label>
                            <div className="col-md-9">
                              {
                                this.props.action === 'VIEW'
                                || (
                                  this.props.action === 'EDIT'
                                  && !modificaEstado
                                ) ? (
                              <div className="form-control-static col-form-label form-value">{this.state.formData.estado ? this.state.formData.estado : ''}</div>
                              ) : (
                              <div data-db-column="id_estado">
                                <Select
                                  id="estado"
                                  name="estado"
                                  placeholder={!state.estadosLoading ? this.props.intl.formatMessage({ id: 'movilesAbm.render.general_data.placeholder_estado', defaultMessage: 'Seleccione' }) : ''}
                                  options={estadoOptions}
                                  valueKey='value'
                                  labelKey='label'
                                  value={estado ? { value: estado.id, label: estado.label } : null}
                                  onChange={(e) => this.handleFormChangeSelectString("estado", e)}
                                  isLoading={state.estadosLoading}
                                  disabled={state.estadosLoading}
                                  className={this.state.validationErrors.estado ? 'is-invalid' : ''}
                                />
                                <small className="text-danger">{this.state.validationErrors.estado}</small>
                              </div>
                              )}
                            </div>
                          </div>
                        </div>
                        ):null}
                      </div>
                      <div className="row">
                        {/* BASE */}
                        { ConfigBusiness.get('moviles.base.habilitado') === 'true' && ConfigBusiness.get('moviles.base.mostrarEnDatosGenerales') === 'true'? (
                        <div className="col-md-6">
                          <div className="form-group row">
                            <label className="col-md-3 label-control col-form-label" htmlFor="base">
                              <FormattedMessage id="movilesAbm.render.general_data.label_base" defaultMessage="Base"/>{requiredSymbol}:
                            </label>
                            <div className="col-md-9">
                              {(
                                this.state.disableAvlFields && this.props.action === 'EDIT' ) || 
                                this.props.action === 'VIEW' || (this.props.action === 'EDIT' && 
                                    !Security.hasPermission('MOVILES_MODIFICAR_DATOS_GENERALES') &&
                                !permisoMovilesModificarBase) ? (
                              <div className="form-control-static col-form-label form-value">{formData.base && formData.base.descripcion ? formData.base.descripcion : ''}</div>
                              ) : (
                              <div data-db-column="id_base">
                                <Select.Async
                                  id="base"
                                  name="base"
                                  placeholder={this.props.intl.formatMessage({ id: 'movilesAbm.render.general_data.placeholder_base', defaultMessage: 'Seleccione' })}
                                  valueKey='value'
                                  labelKey='label'
                                  value={base ? { value: base.id, label: base.descripcion || base.label } : null}
                                  loadOptions={this.getBackendBases}
                                  onChange={(e) => this.handleFormChangeSelectObject("base", e).then(() => { this.getJefeBase() })}
                                  className={this.state.validationErrors.base ? 'is-invalid' : ''}
                                />
                                <small className="text-danger">{this.state.validationErrors.base}</small>
                              </div>
                              )}
                            </div>
                          </div>
                        </div>
                        ):null}
                        { ConfigBusiness.get('moviles.clasificador.habilitado') === "true" ? 
                          <div className="col-md-6">
                            <div className="form-group row" style={{display: formData.estado ? '' : 'none' }}>
                              <label className="col-md-3 label-control col-form-label" htmlFor="Disponibilidad">
                                <FormattedMessage id="Disponibilidad" defaultMessage="Disponibilidad"/> :
                              </label>
                              <div className="col-md-9">
                                <div className="form-control-static col-form-label form-value">{state.estadoClasificadorText}</div>
                              </div>
                            </div>
                          </div>

                        : null}
                      </div>
                      {/* SEDE EXTERNA */}
                      { ConfigBusiness.get('sedeExterna.habilitado') === 'true' ? (
                        <div className="row">
                          <div className="col-md-6">
                            <div className="form-group row">
                                <label className="col-md-3 label-control col-form-label" htmlFor="sede-externa">
                                  <FormattedMessage id="movilesAbm.render.general_data.sede_externa" defaultMessage="Sede Externa"/> :
                                </label>
                                {this.props.action !== 'VIEW' ?
                                  <div data-db-column="id_sedeExterna" className="col-md-9">
                                  <Select
                                    id="sedeExterna"
                                    name="sedeExterna"
                                    placeholder={!state.sedesExternasLoading ? this.props.intl.formatMessage({ id: 'movilesAbm.render.general_data.placeholder_sede_externa', defaultMessage: 'Seleccione' }) : ''}
                                    isLoading={state.sedesExternasLoading}
                                    disabled={state.sedesExternasLoading}
                                    options={this.state.sedesExternas}
                                    valueKey='value'
                                    labelKey='label'
                                    value={sedeExterna ? { value: sedeExterna.id, label: sedeExterna.label } : null}
                                    onChange={(e) => this.handleFormChangeSelectObject("sedeExterna", e)}
                                  />
                                </div>
                                  :
                                  <div className="col-md-9">
                                    <div className="form-control-static col-form-label form-value">{formData.sedeExterna && formData.sedeExterna.nombre ? formData.sedeExterna.nombre : ''
                                    }</div>
                                </div>
                                }
                            </div>
                          </div>
                        </div>

                      ): null}
                      <div className="row">
                        {/* Responsable Base */}
                        <div className="col-md-6">
                          <div className="form-group row" style={{display: formData.base ? '' : 'none' }}>
                            <label className="col-md-3 label-control col-form-label" htmlFor="responsable_base">
                              <FormattedMessage id="movilesAbm.render.general_data.responsable_base" defaultMessage="Responsable Base"/> :
                            </label>
                            {this.state.asignacionManualResponsableBase && this.props.action !== 'VIEW' && Security.hasPermission('MOVILES_MODIFICAR_RESPONSABLE_BASE') ?
                              <div data-db-column="id_responsableBase" className="col-md-9">
                              <Select.Async
                                id="responsable_base"
                                name="responsable_base"
                                valueKey='id'
                                labelKey='label'
                                value={this.getResponsableBaseValue()}
                                loadOptions={this.getBackendPersonasPorBase}
                                onChange={(e) => this.handleResponsablesBaseChange(e)}
                              />
                            </div>
                              :
                              <div className="col-md-9">
                                <div className="form-control-static col-form-label form-value">{this.state.asignacionManualResponsableBase && formData.responsable_base
                                  ? (formData.responsable_base ? formData.responsable_base.nombre + ' ' + formData.responsable_base.apellido : '')
                                  : (formData.base && formData.base.responsable ? formData.base.responsable.nombre + ' ' + formData.base.responsable.apellido : '')
                                }</div>
                            </div>
                            }
                          </div>
                        </div>
                        {/* Jefe BASE */}
                        <div className="col-md-6">
                          <div className="form-group row" style={{display: formData.base ? '' : 'none' }}>
                            <label className="col-md-3 label-control col-form-label" htmlFor="jefeBase">
                              <FormattedMessage id="movilesAbm.render.general_data.label_jefe_de_base" defaultMessage="Jefe de Base"/> :
                            </label>
                            <div className="col-md-9">
                              <div className="form-control-static col-form-label form-value">{formData.base ? (formData.base.jefe ? formData.base.jefe.nombre + ' ' + formData.base.jefe.apellido : '') : ''}</div>
                            </div>
                          </div>
                        </div>
                      </div>
                      {ConfigBusiness.get('moviles.estadosErp.habilitado') === 'true' ?
                        <div className="row">
                          {/* Estado SAP */}
                          <div className="col-md-6">
                            <div className="form-group row">
                              <label className="col-md-3 label-control col-form-label" htmlFor="EstadoErp">
                                <FormattedMessage id="movilesAbm.render.general_data.estado_erp" defaultMessage="Estado SAP"/> :
                              </label>
                              <div className="col-md-9">
                                <div className="form-control-static col-form-label form-value">{formData.estadoErp ? formData.estadoErp : ''}</div>
                              </div>
                            </div>
                          </div>
                        </div>
                      : null}
                      <div className="row">
                        {/* Unidad */}
                        <div className="col-md-6">
                          <div className="form-group row">
                            <label className="col-md-3 label-control col-form-label" htmlFor="unidad">
                              <FormattedMessage id="movilesAbm.render.general_data.label_unidad" defaultMessage="Unidad"/> :
                            </label>
                            <div className="col-md-9">
                              {(this.state.disableAvlFields && this.props.action === 'EDIT' ) || this.props.action === 'VIEW' || (this.props.action === 'EDIT' && !Security.hasPermission('MOVILES_MODIFICAR_DATOS_GENERALES')) ? (
                              <div className="form-control-static col-form-label form-value">{formData.unidad ? formData.unidad : ''}</div>
                              ) : (
                              <div>
                                <input
                                  type="text"
                                  className="form-control"
                                  id="unidad"
                                  name="unidad"
                                  placeholder=""
                                  value={formData.unidad ? formData.unidad : ''}
                                  onChange={this.handleInputFormChange}
                                  onBlur={this.validateUnidadDuplicada}
                                  data-db-column="unidad"
                                />
                              </div>
                              )}
                            </div>
                          </div>
                        </div>
                        {/* Gerenciador */}
                        <div className="col-md-6">
                          <div className="form-group row">
                            <label className="col-md-3 label-control col-form-label" htmlFor="gerenciador">
                              <FormattedMessage id="movilesAbm.render.general_data.label_gerenciador" defaultMessage="Gerenciador"/> :
                            </label>
                            {this.state.asignacionManualGerenciador && this.props.action !== 'VIEW' && Security.hasPermission('MOVILES_MODIFICAR_GERENCIADOR') ? 
                              <div data-db-column="id_gerenciador" className="col-md-9">
                              <Select
                                id="gerenciador"
                                name="gerenciador"
                                options={this.state.gerenciadores}
                                valueKey='value'
                                labelKey='label'
                                value={this.getGerenciadorValue()}
                                onChange={(e) => this.handleGerenciadorChange(e)}
                              />
                            </div> 
                              :
                              <div className="col-md-9">
                                <div className="form-control-static col-form-label form-value">{this.state.asignacionManualGerenciador && formData.gerenciador
                                  ? (formData.gerenciador ? formData.gerenciador.razonSocial : '')
                                  : (formData.base && formData.base.gerenciador ? formData.base.gerenciador.razonSocial : '')
                                }</div>
                            </div>
                            }
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        {/* MARCA */}
                        <div className="col-md-6">
                          <div className="form-group row">
                            <label className="col-md-3 label-control col-form-label text-nowrap" htmlFor="marca">
                              <FormattedMessage id="movilesAbm.render.general_data.label_marca" defaultMessage="Marca"/>{ConfigBusiness.get('moviles.marca.obligatorio') === 'true' ? requiredSymbol : ' ' }:
                            </label>
                            <div className="col-md-9">
                              {this.props.action === 'VIEW' || (this.props.action === 'EDIT' && (!Security.hasPermission('MOVILES_MODIFICAR_DATOS_GENERALES') )) ? (
                              <div className="form-control-static col-form-label form-value">{formData.marca && formData.marca.label ? formData.marca.label : ''}</div>
                              ) : (
                              <div data-db-column="id_marca">
                                <Select
                                  id="marca"
                                  name="marca"
                                  placeholder={!state.marcasLoading ? this.props.intl.formatMessage({ id: 'movilesAbm.render.general_data.placeholder_marca', defaultMessage: 'Seleccione' }) : ''}
                                  options={this.state.marcas}
                                  valueKey='value'
                                  labelKey='label'
                                  value={marca ? { value: marca.id, label: marca.label } : null}
                                  onChange={(e) => this.handleMarcaChange(e)}
                                  isLoading={state.marcasLoading}
                                  disabled={this.state.modelosLoading || state.selectDisable}
                                  className={this.state.validationErrors.marca ? 'is-invalid' : ''}
                                />
                                <small className="text-danger">{this.state.validationErrors.marca}</small>
                              </div>
                              )}
                            </div>
                          </div>
                        </div>
                        {/* MODELO */}
                        <div className="col-md-6">
                          <div className="form-group row">
                            <label className="col-md-3 label-control col-form-label text-nowrap" htmlFor="modelo">
                              <FormattedMessage id="movilesAbm.render.general_data.label_modelo" defaultMessage="Modelo"/>{ConfigBusiness.get('moviles.modelo.obligatorio') === 'true' ? requiredSymbol : ' ' }:
                            </label>
                            <div className="col-md-9">
                              {this.props.action === 'VIEW' || (this.props.action === 'EDIT' && (!Security.hasPermission('MOVILES_MODIFICAR_DATOS_GENERALES') )) ? (
                              <div className="form-control-static col-form-label form-value">{formData.modelo && formData.modelo.label ? formData.modelo.label : ''}</div>
                              ) : (
                              <div data-db-column="id_modelo">
                                <Select
                                  id="modelo"
                                  name="modelo"
                                  placeholder={formData.marca && !state.modelosLoading ? this.props.intl.formatMessage({ id: 'movilesAbm.render.general_data.placeholder_modelo', defaultMessage: 'Seleccione' }) : ''}
                                  options={this.state.modelos}
                                  valueKey='value'
                                  labelKey='label'
                                  value={modelo ? { value: modelo.id, label: modelo.label } : null}
                                  onChange={(e) => this.handleModeloChange(e)}
                                  disabled={!formData.marca || this.state.modelosLoading || state.selectDisable}
                                  isLoading={state.modelosLoading}
                                  className={this.state.validationErrors.modelo ? 'is-invalid' : ''}
                                  />
                                  <small className="text-danger">{this.state.validationErrors.modelo}</small>
                              </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        {/* CHASIS */}
                        <div className="col-md-6">
                          <div className="form-group row">
                            <label className="col-md-3 label-control col-form-label" htmlFor="chasis">
                              <FormattedMessage id="movilesAbm.render.general_data.label_chasis" defaultMessage="Chasis"/>{ConfigBusiness.get('moviles.chasis.obligatorio') === 'true' ? requiredSymbol : ' ' }:
                            </label>
                            <div className="col-md-9">
                              {this.props.action === 'VIEW' || (this.props.action === 'EDIT' && (!Security.hasPermission('MOVILES_MODIFICAR_DATOS_GENERALES') )) ? (
                              <div className="form-control-static col-form-label form-value">{formData.chasis ? formData.chasis : ''}</div>
                              ) : (
                              <div>
                                <input 
                                  type="text"
                                  id="chasis"
                                  name="chasis"
                                  placeholder=""
                                  onChange={this.handleInputFormChange}
                                  className={this.state.validationErrors.chasis ? 'form-control is-invalid' : 'form-control'}
                                  value={formData.chasis ? formData.chasis : ''}
                                  data-db-column="chasis"
                                />
                                <small className="text-danger">{this.state.validationErrors.chasis}</small>
                              </div>
                              )}
                            </div>
                          </div>
                        </div>
                        {/* MOTOR */}
                        <div className="col-md-6">
                          <div className="form-group row">
                            <label className="col-md-3 label-control col-form-label" htmlFor="motor">
                              <FormattedMessage id="movilesAbm.render.general_data.label_motor" defaultMessage="Motor"/>{ConfigBusiness.get('moviles.motor.obligatorio') === 'true' ? requiredSymbol : ' ' }:
                            </label>
                            <div className="col-md-9">
                              {this.props.action === 'VIEW' || (this.props.action === 'EDIT' && (!Security.hasPermission('MOVILES_MODIFICAR_DATOS_GENERALES') )) ? (
                              <div className="form-control-static col-form-label form-value">{formData.motor ? formData.motor : ''}</div>
                              ) : (
                              <div>
                                <input type="text" className={this.state.validationErrors.motor ? 'form-control is-invalid' : 'form-control'} id="motor" name="motor" placeholder="" value={formData.motor ? formData.motor : ''} onChange={this.handleInputFormChange} data-db-column="motor" />
                                <small className="text-danger">{this.state.validationErrors.motor}</small>
                              </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        {/* COLOR */}
                        {this.state.viewColor ? (
                        <div className="col-md-6">
                          <div className="form-group row">
                            <label className="col-md-3 label-control col-form-label" htmlFor="color">
                              <FormattedMessage id="movilesAbm.render.general_data.label_color" defaultMessage="Color"/> :
                            </label>
                            <div className="col-md-9">
                              {this.props.action === 'VIEW' || (this.props.action === 'EDIT' && (!Security.hasPermission('MOVILES_MODIFICAR_DATOS_GENERALES') )) ? (
                              <div className="form-control-static col-form-label form-value">{formData.color ? formData.color : ''}</div>
                              ) : (
                              <div>
                                <input type="text" className="form-control" id="color" name="color" placeholder="" value={formData.color ? formData.color : ''} onChange={this.handleInputFormChange} data-db-column="color" />
                              </div>
                              )}
                            </div>
                          </div>
                        </div>
                        ) : null}
                        {/* AÑO */}
                        <div className="col-md-6">
                          <div className="form-group row">
                            <label className="col-md-3 label-control col-form-label" htmlFor="anio">
                              <FormattedMessage id="movilesAbm.render.general_data.label_anio" defaultMessage="Año"/>{ConfigBusiness.get('moviles.anio.obligatorio') === 'true' ? requiredSymbol : ' ' }:
                            </label>
                            <div className="col-md-9">
                              {this.props.action === 'VIEW' || (this.props.action === 'EDIT' && (!Security.hasPermission('MOVILES_MODIFICAR_DATOS_GENERALES') )) ? (
                              <div className="form-control-static col-form-label form-value">{formData.anio === 0 ? null : formData.anio}</div>
                              ) : (
                              <div>
                                <input type="text" className={this.state.validationErrors.anio ? 'form-control is-invalid' : 'form-control'} id="anio" name="anio" placeholder="" value={formData.anio === 0 ? '' : formData.anio} onChange={this.handleInputFormChange} data-db-column="anio" />
                                <small className="text-danger">{this.state.validationErrors.anio}</small>
                              </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        {/* UNIDAD MEDIDOR */}
                        <div className="col-md-6">
                          <div className="form-group row">
                            <label className="col-md-3 label-control col-form-label" htmlFor="unidadMedidor">
                              <FormattedMessage id="movilesAbm.render.general_data.label_unidad_medidor" defaultMessage="Unidad medidor "/> *:
                            </label>
                            <div className="col-md-9">
                              {(this.state.disableAvlFields && this.props.action === 'EDIT' ) || this.props.action === 'VIEW' || (this.props.action === 'EDIT' && !Security.hasPermission('MOVILES_MODIFICAR_DATOS_GENERALES')) ? (
                              <div className="form-control-static col-form-label form-value">{formData.unidadMedidorId ? UNIDAD_MEDIDOR[formData.unidadMedidorId]['label'] : ''}</div>
                              ) : (
                              <div data-db-column="id_unidadMedidor">
                                <SelectWithIcons
                                  placeholder="Tipo"
                                  valueKey="id"
                                  labelKey="label"
                                  disabled={this.state.props.action === 'VIEW'}
                                  clearable={false}
                                  onChange={(e) => this.handleFormChangeSelectString('unidadMedidorId', e)}
                                  value={formData.unidadMedidorId}
                                  options={Object.values(UNIDAD_MEDIDOR)}
                                  isLoading={state.unidadMedidorIdLoading}
                                />
                              </div>
                              )}
                            </div>
                          </div>
                        </div>
                        {/* TRACCION */}
                        <div className="col-md-6">
                          <div className="form-group row">
                            <label className="col-md-3 label-control col-form-label" htmlFor="traccion">
                              <FormattedMessage id="movilesAbm.render.general_data.label_traccion" defaultMessage="Tracción"/>{ConfigBusiness.get('moviles.traccion.obligatorio') === 'true' ? requiredSymbol : ' ' }:
                            </label>
                            <div className="col-md-9">
                              {this.props.action === 'VIEW' || (this.props.action === 'EDIT' && (!Security.hasPermission('MOVILES_MODIFICAR_DATOS_GENERALES') )) ? (
                              <div className="form-control-static col-form-label form-value">{formData.traccion ? TIPOS_TRACCION[formData.traccion]['label'] : ''}</div>
                              ) : (
                              <div data-db-column="id_traccion">
                                <Select
                                  id="traccion"
                                  name="traccion"
                                  placeholder={!state.traccionLoading ? this.props.intl.formatMessage({ id: 'movilesAbm.render.general_data.placeholder_combustible', defaultMessage: 'Seleccione' }) : ''}
                                  options={Object.values(TIPOS_TRACCION)}
                                  valueKey='id'
                                  labelKey='label'
                                  value={formData.traccion}
                                  onChange={(e) => this.handleFormChangeSelectString("traccion", e)}
                                  isLoading={state.traccionLoading}
                                  disabled={state.traccionLoading}
                                  className={this.state.validationErrors.traccion ? 'is-invalid' : ''}
                                  />
                                  <small className="text-danger">{this.state.validationErrors.traccion}</small>
                              </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        {/* PLAN DE MANTENIMIENTO PREVENTIVO */}
                        <div className="col-md-6">
                          <div className="form-group row" >
                            <label className="col-md-3 label-control col-form-label" htmlFor="planPreventivo">
                              <FormattedMessage id="movilesAbm.render.general_data.label_plan_mant_preventivo" defaultMessage="Plan Mant. Preventivo"/>{ConfigBusiness.get('moviles.planMantPreventivo.obligatorio') === 'true' ? requiredSymbol : ' ' }:
                            </label>
                            <div className="col-md-9">
                              {this.props.action === 'VIEW' || (this.props.action === 'EDIT' && (!Security.hasPermission('MOVILES_MODIFICAR_DATOS_GENERALES') )) ? (
                              <div className="form-control-static col-form-label form-value">{this.state.formData.planPreventivo ? this.state.formData.planPreventivo.descripcion : ''}</div>
                              ) : (
                              <div data-db-column="id_planPreventivo">
                                <Select.Async
                                    name="planPreventivo"
                                    id="planPreventivo"
                                    placeholder={this.props.intl.formatMessage({ id: 'movilesAbm.render.general_data.placeholder_plan_mant_preventivo', defaultMessage: 'Seleccione' })}
                                    value={this.state.formData.planPreventivo}
                                    valueKey="id"
                                    labelKey="descripcion"
                                    cacheOptions={false}
                                    loadOptions={this.getPlanPreventivos}
                                    onChange={this.handlePlanPreventivoChange}
                                    isLoading={state.planesPreventivosLoading}
                                    disabled={this.props.action === "VIEW" || !this.state.formData.unidadMedidorId}
                                    key={this.state.formData.unidadMedidorId}
                                    className={this.state.validationErrors.planPreventivo ? 'is-invalid' : ''}
                                  />
                                  <small className="text-danger">{this.state.validationErrors.planPreventivo}</small>
                              </div>
                              )}
                            </div>
                          </div>
                        </div>
                        {/* PLAN DE MANTENIMIETO VENCIMIENTO */}
                        <div className="col-md-6">
                          <div className="form-group row" style={{display: ConfigBusiness.get('planesMantenimiento.vencimiento.habilitado') === 'true' ? '' : 'none' }}>
                            <label className="col-md-3 label-control col-form-label" htmlFor="planVencimiento">
                              <FormattedMessage id="movilesAbm.render.general_data.label_plan_mant_vencimiento" defaultMessage="Plan Mant. Vencimiento"/>:
                            </label>
                            <div className="col-md-9">
                            {this.props.action === 'VIEW' || (this.props.action === 'EDIT' && (!Security.hasPermission('MOVILES_MODIFICAR_DATOS_GENERALES') )) ? (
                              <div className="form-control-static col-form-label form-value">{this.state.formData.planVencimiento ? this.state.formData.planVencimiento.descripcion : ''}</div>
                              ) : (
                              <div data-db-column="id_planVencimiento">
                                <Select
                                  id="planVencimiento"
                                  name="planVencimiento"
                                  placeholder={this.props.intl.formatMessage({ id: 'movilesAbm.render.general_data.placeholder_plan_mant_vencimiento"', defaultMessage: 'Seleccione' })}
                                  options={this.state.planesVencimiento}
                                  valueKey='value'
                                  labelKey='label'
                                  value={planVencimiento ? { value: planVencimiento.id, label: planVencimiento.label } : null}
                                  onChange={(e) => this.handleFormChangeSelectObject("planVencimiento", e)}
                                  isLoading={state.planesVencimientosLoading}
                                  disable={state.planesVencimientosLoading}
                                />
                              </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        {/* COMBUSTIBLE */}
                        <div className="col-md-6">
                          <div className="form-group row">
                            <label className="col-md-3 label-control col-form-label" htmlFor="combustible">
                              <FormattedMessage id="movilesAbm.render.general_data.label_combustible" defaultMessage="Combustible"/>{ConfigBusiness.get('moviles.movilCombustibleTipo.obligatorio') === 'true' ? requiredSymbol : ' ' }:
                            </label>
                            <div className="col-md-9">
                              {this.props.action === 'VIEW' || (this.props.action === 'EDIT' && (!Security.hasPermission('MOVILES_MODIFICAR_DATOS_GENERALES') )) ? (
                              <div className="form-control-static col-form-label form-value">{formData.movilCombustibleTipo ? formData.movilCombustibleTipo.descripcion : ''}</div>
                              ) : (
                              <div data-db-column="id_movilCombustibleTipo">
                                <Select
                                  id="moviles_combustible_tipo_id"
                                  name="moviles_combustible_tipo_id"
                                  placeholder={!state.combustiblesLoading ? this.props.intl.formatMessage({ id: 'movilesAbm.render.general_data.placeholder_combustible', defaultMessage: 'Seleccione' }) : ''}
                                  options={state.movilCombustibleTipos}
                                  valueKey='value'
                                  labelKey='label'
                                  value={movilCombustibleTipo ? { value: movilCombustibleTipo.id, label: movilCombustibleTipo.label } : null}
                                  onChange={(e) => this.handleFormChangeSelectObject("movilCombustibleTipo", e)}
                                  isLoading={state.combustiblesLoading}
                                  disabled={state.combustiblesLoading}
                                  className={this.state.validationErrors.movilCombustibleTipo ? 'is-invalid' : ''}
                                />
                                <small className="text-danger">{this.state.validationErrors.movilCombustibleTipo}</small>
                              </div>
                              )}
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6">
                           {/* RENDIMIENTO PROPIO */}
                        <div className="form-group row">
                            <label className="col-md-3 label-control col-form-label text-break overflow-wrap-normal">
                              <FormattedMessage id="movilesAbm.render.rendimientoPropio_movil.label_rendimientoPropio" defaultMessage="Rendimiento Propio"/>:
                            </label>
                            <div data-db-column="rendimientoPropio" className="col-md-2 mt-1">
                              <Switch
                                onChange={ ()=>this.handleChangePropio('rendimientoPropio',!formData.rendimientoPropio) }
                                checked={formData.rendimientoPropio ? formData.rendimientoPropio : false}
                                id="rendimientoPropio"
                                name="rendimientoPropio"
                                disabled={(this.state.props.action === 'VIEW' || (!Security.hasPermission('MOVILES_MODIFICAR_DATOS_GENERALES')) )}
                                offColor="#FF4961"
                                onColor="#28D094"
                              />
                            </div>
                            {/* RENDIMIENTO ESPERADO */}
                            <label className="col-md-2 label-control col-form-label text-break overflow-wrap-normal">
                              <FormattedMessage id="movilesAbm.render.rendimientoEsperado_movil.label_rendimientoEsperado" defaultMessage="Rendimiento Esperado"/>:
                            </label>
                            <div className="col-md-5 mt-auto">
                            {(this.props.action === 'VIEW' || (this.props.action === 'EDIT' && (!Security.hasPermission('MOVILES_MODIFICAR_DATOS_GENERALES') ))) ? (
                              <div className="form-control-static col-form-label form-value">{formData.rendimientoEsperado ? formData.rendimientoEsperado : formData.rendimientoEsperadoModelo}</div>
                              ) : (
                              <div>
                                <input type="text" className={this.state.validationErrors.rendimientoEsperado ? "form-control is-invalid" : "form-control"} id="rendimientoEsperado" name="rendimientoEsperado" placeholder="" value={formData.rendimientoPropio ? formData.rendimientoEsperado : formData.rendimientoEsperadoModelo} onChange={this.handleInputFormChange} disabled={formData.rendimientoPropio == false} data-db-column="rendimientoEsperado"/>
                                <small className="text-danger">{this.state.validationErrors.rendimientoEsperado}</small>
                              </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                        <div className="row">
                          <div className="col-md-6">
                          { (Security.hasPermission('LLANTAS_MODELOS_VISUALIZAR') || Security.hasPermission('LLANTAS_MODELOS_LISTAR')) ?
                            <div className="form-group row">
                            {/* CLASE */}
                              <label className="col-md-3 label-control col-form-label" htmlFor="clase">
                                <FormattedMessage id="movilesAbm.render.general_data.label_clase" defaultMessage="Clase"/>:
                              </label>
                              <div className="col-md-9">
                                {this.props.action === 'VIEW' || (this.props.action === 'EDIT' && (!Security.hasPermission('MOVILES_MODIFICAR_DATOS_GENERALES') )) ? (
                                <div className="form-control-static col-form-label form-value">{this.state.formData.claseEloquent ? this.state.formData.claseEloquent.nombre : ''}</div>
                                ) : (
                                <div data-db-column="id_clase">
                                  <Select
                                    id="clase"
                                    name="clase"
                                    placeholder={!state.combustiblesLoading ? this.props.intl.formatMessage({ id: 'movilesAbm.render.general_data.placeholder_combustible', defaultMessage: 'Seleccione' }) : ''}
                                    options={this.state.clases}
                                    valueKey='value'
                                    labelKey='nombre'
                                    value={this.state.formData.claseEloquent ? this.state.formData.claseEloquent : null}
                                    onChange={(e) => this.handleFormChangeSelectObject("claseEloquent", e)}
                                    isLoading={state.combustiblesLoading}
                                    disabled={state.combustiblesLoading}
                                    className={this.state.validationErrors.claseEloquent ? 'is-invalid' : ''}
                                  />
                                  <small className="text-danger">{this.state.validationErrors.claseEloquent}</small>
                                </div>
                                )}
                              </div>
                            </div>
                          : ''}
                          </div>
                          <div className="col-md-6">
                           {/* TANQUE PROPIO */}
                        <div className="form-group row">
                            <label className="col-md-3 label-control col-form-label text-break overflow-wrap-normal">
                              <FormattedMessage id="movilesAbm.render.tanquePropio_movil.label_tanquePropio" defaultMessage="Tanque Propio"/>:
                            </label>
                            <div data-db-column="tanquePropio" className="col-md-2 mt-1">
                              <Switch
                                onChange={ ()=>this.handleChangePropio('tanquePropio',!formData.tanquePropio) }
                                checked={formData.tanquePropio ? formData.tanquePropio : false}
                                id="tanquePropio"
                                name="tanquePropio"
                                disabled={this.state.props.action === 'VIEW' || (this.props.action === 'EDIT' && ( !Security.hasPermission('MOVILES_MODIFICAR_DATOS_GENERALES') ))}
                                offColor="#FF4961"
                                onColor="#28D094"
                              />
                            </div>
                            {/* CAPACIDAD TANQUE */}
                            <label className="col-md-2 label-control col-form-label text-break overflow-wrap-normal">
                              <FormattedMessage id="movilesAbm.render.capacidadTanque_movil.label_capacidadTanque" defaultMessage="Capacidad Tanque"/>:
                            </label>
                            <div className="col-md-5 mt-auto">      
                            {(this.props.action === 'VIEW' || (this.props.action === 'EDIT' && (!Security.hasPermission('MOVILES_MODIFICAR_DATOS_GENERALES') ))) ? (
                              <div className="form-control-static col-form-label form-value">{formData.tanquePropio ? formData.capacidadTanque : formData.capacidadTanqueModelo}</div>
                              ) : (
                              <div>
                                <input type="text" className={this.state.validationErrors.capacidadTanque ? "form-control is-invalid" : "form-control"} id="capacidadTanque" name="capacidadTanque" placeholder="" value={formData.tanquePropio ? formData.capacidadTanque : formData.capacidadTanqueModelo} onChange={this.handleInputFormChange} disabled={formData.tanquePropio == false} data-db-column="capacidadTanque"/>
                                <small className="text-danger">{this.state.validationErrors.capacidadTanque}</small>
                              </div>
                              )}
                            </div>
                          </div>
                        </div>
                        </div>
                      <div className="row">
                        {/* NRO. REGISTRO (DNRPA) */}
                        <div className="col-md-6">
                          <div className="form-group row">
                            <label className="col-md-3 label-control col-form-label" htmlFor="dnrpaSeccional">
                              <FormattedMessage id="movilesAbm.render.general_data.label_nro_registro" defaultMessage="Nro. Registro (DNRPA)"/>{ConfigBusiness.get('moviles.dnrpaSeccional.obligatorio') === 'true' ? requiredSymbol : ' ' }:
                            </label>
                            <div className="col-md-9">
                              {this.props.action === 'VIEW' || (this.props.action === 'EDIT' && (!Security.hasPermission('MOVILES_MODIFICAR_DATOS_GENERALES') )) ? (
                              <div className="form-control-static col-form-label form-value">{this.state.formData.dnrpaSeccional ? this.state.formData.dnrpaSeccional.codigoAutomotor + ' - ' + this.state.formData.dnrpaSeccional.denominacion : ''}</div>
                              ) : (
                              <div data-db-column="id_dnrpaSeccional">
                                <Select.Async
                                  id="dnrpaSeccional"
                                  name="dnrpaSeccional"
                                  placeholder={this.props.intl.formatMessage({ id: 'movilesAbm.render.general_data.placeholder_nro_registro', defaultMessage: 'Seleccione' })}
                                  valueKey='value'
                                  labelKey='label'
                                  value={dnrpaSeccional ? { value: dnrpaSeccional.id, label: dnrpaSeccional.label || (dnrpaSeccional.codigoAutomotor + ' - ' + dnrpaSeccional.denominacion) } : null}
                                  loadOptions={this.getBackendDnrpaSeccionales}
                                  onChange={(e) => this.handleFormChangeSelectObject("dnrpaSeccional", e)}
                                  disabled={this.state.selectDisable}
                                  className={this.state.validationErrors.dnrpaSeccional ? 'is-invalid' : ''}
                                />
                                <small className="text-danger">{this.state.validationErrors.dnrpaSeccional}</small>
                              </div>
                              )}
                            </div>
                          </div>
                        </div>

                        {/* TITULAR */}
                        { ConfigBusiness.get('moviles.titular.habilitado') === 'true' ? (
                        <div className="col-md-6">
                          <div className="form-group row">
                            <label className="col-md-3 label-control col-form-label" htmlFor="titular">
                              {this.state.labelTitular ? this.state.labelTitular : '' }{ConfigBusiness.get('moviles.titular.obligatorio') === 'true' ? requiredSymbol : ' '}:
                            </label>
                            <div className="col-md-9">
                              {this.props.action === 'VIEW' || (this.props.action === 'EDIT' && (!Security.hasPermission('MOVILES_MODIFICAR_DATOS_GENERALES') )) ? (
                              <div className="form-control-static col-form-label form-value">{titular ? titular.label : ''}</div>
                              ) : (
                                  <div >
                                    <div data-db-column="id_titular" className="col-md-10" style = {{display: "inline-table", padding: 0 + "px"}}>
                                      <Select
                                        id="titular"
                                        name="titular"
                                        placeholder={!state.titularesLoading ? this.props.intl.formatMessage({ id: 'movilesAbm.render.general_data.placeholder_titular', defaultMessage: 'Seleccione' }) : ''}
                                        options={state.titulares}
                                        valueKey='value'
                                        labelKey='label'
                                        value={titular ? titular : null}
                                        onChange={(e) => this.handleFormChangeSelectTitular(e)}
                                        isLoading={state.titularesLoading}
                                        disabled={state.titularesLoading}
                                        className={this.state.validationErrors.titular ? 'is-invalid' : ''}
                                      />
                                      <small className="text-danger">{this.state.validationErrors.titular}</small>
                                    </div>
                                    <div className="col-md-1" style = {{display: "inline-table",  'paddingRight': 0 + "px"}}>
                                      <button type="button" className="btn btn-primary" onClick={()=>this.handleAgregarTitular()}>+</button>
                                    </div>
                                  </div>
                              )}
                            </div>
                          </div>
                        </div>
                        ):null}
                      </div>
                      <div className="form-group row">
                        {/* COMPAÑÍA ORIGEN */}
                        { ConfigBusiness.get('moviles.companiaOrigen.habilitado') === 'true' ? (
                        <div className="col-md-6">
                          <div className="form-group row">
                            <label className="col-md-3 label-control col-form-label" htmlFor="companiaOrigen">
                              <FormattedMessage id="movilesAbm.render.general_data.label_cia_origen" defaultMessage="Cía. Origen"/>{ConfigBusiness.get('moviles.companiaOrigen.obligatorio') === 'true' ? requiredSymbol : ' ' }:
                            </label>
                            <div className="col-md-9">
                              {this.props.action === 'VIEW' || (this.props.action === 'EDIT' && (!Security.hasPermission('MOVILES_MODIFICAR_DATOS_GENERALES') )) ? (
                              <div className="form-control-static col-form-label form-value">
                                {ConfigBusiness.get('moviles.companiaOrigen.inputType') === 'text' ? 
                                  ( formData.companiaOrigen ? formData.companiaOrigen : '')
                                  : ( formData.companiaOrigenEloquent ? formData.companiaOrigenEloquent.nombre : '')
                                }
                              </div>
                              ) : (
                                this.state.companiaOrigenInputType === 'text' ? (
                                <div>
                                  <input type="text" className={this.state.validationErrors.companiaOrigen ? "form-control is-invalid" : "form-control"} id="companiaOrigen" name="companiaOrigen" placeholder="" value={formData.companiaOrigen} onChange={this.handleInputFormChange} data-db-column="companiaOrigen"/>
                                </div>
                                ) : (
                                <div data-db-column="id_companiaOrigen">
                                  <Select
                                    id="companiaOrigen"
                                    name="companiaOrigen"
                                    placeholder={!state.companiasLoading ? this.props.intl.formatMessage({ id: 'movilesAbm.render.general_data.placeholder_cia_origen', defaultMessage: 'Seleccione' }) : ''}
                                    options={this.state.companiasOrigen}
                                    valueKey='value'
                                    labelKey='label'
                                    value={companiaOrigen ? { value: companiaOrigen.value, label: companiaOrigen.label } : null}
                                    onChange={(e) => this.handleFormChangeSelectString("companiaOrigen", e)}
                                    isLoading={state.companiasLoading}
                                    disabled={state.companiasLoading}
                                    className={this.state.validationErrors.companiaOrigen ? 'is-invalid' : ''}
                                  />
                                </div>
                                )
                                )}
                                <small className="text-danger">{this.state.validationErrors.companiaOrigen}</small>
                            </div>
                          </div>
                        </div>
                        ) : null}
                        {/* ACTIVO FIJO */}
                        <div className="col-md-6" >
                          <div className="form-group row">
                            <label className="col-md-3 label-control col-form-label" htmlFor="activoFijo">
                              <FormattedMessage id="movilesAbm.render.general_data.label_activo_fijo" defaultMessage="Activo Fijo"/>:
                            </label>
                            <div className="col-md-9">
                              {this.props.action === 'VIEW' || (this.props.action === 'EDIT' && (!Security.hasPermission('MOVILES_MODIFICAR_DATOS_GENERALES') )) ? (
                              <div className="form-control-static col-form-label form-value">{formData.activoFijo ? formData.activoFijo : ''}</div>
                              ) : (
                              <div>
                                <input type="text" className={this.state.validationErrors.activoFijo ? "form-control is-invalid" : "form-control"} id="activoFijo" name="activoFijo" placeholder="" value={formData.activoFijo} onChange={this.handleInputFormChange} data-db-column="activoFijo" />
                                <small className="text-danger">{this.state.validationErrors.activoFijo}</small>
                              </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        {/* NRO TITULO */}
                        <div className="col-md-6">
                          <div className="form-group row">
                            <label className="col-md-3 label-control col-form-label" htmlFor="nroTitulo">
                              <FormattedMessage id="movilesAbm.render.general_data.label_nro_de_titulo" defaultMessage="Nro. de Título"/>:
                            </label>
                            <div className="col-md-9">
                              {this.props.action === 'VIEW' || (this.props.action === 'EDIT' && (!Security.hasPermission('MOVILES_MODIFICAR_DATOS_GENERALES') )) ? (
                              <div className="form-control-static col-form-label form-value">{formData.nroTitulo ? formData.nroTitulo : ''}</div>
                              ) : (
                              <div>
                                <input type="text" className="form-control" id="nroTitulo" name="nroTitulo" placeholder="" value={formData.nroTitulo ? formData.nroTitulo : ''} onChange={this.handleInputFormChange} data-db-column="nroTitulo" />
                              </div>
                              )}
                            </div>
                          </div>
                        </div>
                        {/* VALOR POLIZA */}
                        <div className="col-md-6">
                          <div className="form-group row">
                            <label className="col-md-3 label-control col-form-label" htmlFor="valorPoliza">
                              <FormattedMessage id="movilesAbm.render.general_data.label_valor_poliza" defaultMessage="Valor de Poliza"/>:
                            </label>
                            <div className="col-md-9">
                              {this.props.action === 'VIEW' || (this.props.action === 'EDIT' && (!Security.hasPermission('MOVILES_MODIFICAR_DATOS_GENERALES') )) ? (
                              <div className="form-control-static col-form-label form-value">{formData.valorPoliza ? formData.valorPoliza : null}</div>
                              ) : (
                              <div>
                                <input className={this.state.validationErrors.valorPoliza ? "form-control is-invalid" : "form-control"} id="valorPoliza" name="valorPoliza" placeholder="" value={formData.valorPoliza} onChange={this.handleInputFormChange} data-db-column="valorPoliza" />
                              </div>
                              )}
                              <small className="text-danger">{this.state.validationErrors.valorPoliza}</small>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        {/* FUNCION */}
                        <div className="col-md-6">
                        <div className="form-group row" style={{display: ConfigBusiness.get('moviles.funcion.habilitado') === 'true' ? '' : 'none' }}>
                            <label className="col-md-3 label-control col-form-label" htmlFor="funcion">
                            <FormattedMessage id="movilesAbm.render.general_data.label_funcion" defaultMessage="Funcion "/>:
                            </label>
                            <div className="col-md-9">
                              {this.props.action === 'VIEW' || (this.props.action === 'EDIT' && (!Security.hasPermission('MOVILES_MODIFICAR_DATOS_GENERALES') )) ? (
                              <div className="form-control-static col-form-label form-value">{this.state.formData.funcion ? this.state.formData.funcion.nombre : ''}</div>
                              ) : (
                                  <div >
                                    <div data-db-column="id_funcion" className="col-md-10" style = {{display: "inline-table", padding: 0 + "px"}}>
                                      <Select
                                        id="funcion"
                                        name="funcion"
                                        placeholder={this.props.intl.formatMessage({ id: 'movilesAbm.render.general_data.placeholder_funcion', defaultMessage: 'Seleccione' })}
                                        options={state.funciones}
                                        valueKey='id'
                                        labelKey='nombre'
                                        value={this.state.formData.funcion ? this.state.formData.funcion : null}
                                        onChange={(e) => this.handleFormChangeSelectFuncion(e)}
                                      />
                                    </div>
                                    <div className="col-md-1" style = {{display: "inline-table",  'paddingRight': 0 + "px"}}>
                                      <button type="button" className="btn btn-primary" onClick={()=>this.handleAgregarFuncion()}>+</button>
                                    </div>
                                  </div>
                              )}
                            </div>
                          </div>
                        </div>
                        {/* VALOR FRANQUICIA */}
                        <div className="col-md-6">
                          <div className="form-group row">
                            <label className="col-md-3 label-control col-form-label" htmlFor="valorFranquicia">
                              <FormattedMessage id="movilesAbm.render.general_data.label_valor_franquicia" defaultMessage="Valor de Franquicia"/>:
                            </label>
                            <div className="col-md-9">
                              {this.props.action === 'VIEW' || (this.props.action === 'EDIT' && (!Security.hasPermission('MOVILES_MODIFICAR_DATOS_GENERALES') )) ? (
                              <div className="form-control-static col-form-label form-value">{formData.valorFranquicia ? formData.valorFranquicia : null}</div>
                              ) : (
                              <div>
                                <input className={this.state.validationErrors.valorFranquicia ? "form-control is-invalid" : "form-control"} id="valorFranquicia" name="valorFranquicia" placeholder="" value={formData.valorFranquicia} onChange={this.handleInputFormChange} data-db-column="valorFranquicia" />
                              </div>
                              )}
                              <small className="text-danger">{this.state.validationErrors.valorFranquicia}</small>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="row">

                        {/* FECHA DE ALTA */}
                        <div className="col-md-6">
                          <div className="form-group row">
                            <label className="col-md-3 label-control col-form-label" htmlFor="fechaAlta">
                              <FormattedMessage id="movilesAbm.render.general_data.label_fecha_de_alta" defaultMessage="Fecha de Alta"/>{ConfigBusiness.get('moviles.fechaAlta.obligatorio') === 'true' ? requiredSymbol : ' ' }:
                            </label>
                            <div className="col-md-9">
                              {this.props.action === 'VIEW' || (this.props.action === 'EDIT' && (!Security.hasPermission('MOVILES_MODIFICAR_DATOS_GENERALES') )) ? (
                              <div className="form-control-static col-form-label form-value">{formData.fechaAlta === null || formData.fechaAlta === '0000-00-00' ? '' : LocaleFormat.formatDate(formData.fechaAlta)}</div>
                              ) : (
                              <div data-db-column="fechaAlta">
                                <DatePicker
                                  id="fechaAlta"
                                  name="fechaAlta"
                                  className={this.state.validationErrors.fechaAlta ? 'form-control date-picker-placeholder is-invalid' : 'form-control date-picker-placeholder'}
                                  dateFormat={LocaleFormat.getDatePickerFormat()}
                                  placeholderText={this.props.intl.formatMessage({ id: 'movilesAbm.render.general_data.placeholder_fecha_de_alta', defaultMessage: 'DD/MM/AAAA' })}
                                  selected={formData.fechaAlta === null || formData.fechaAlta === '0000-00-00' ? null : moment(formData.fechaAlta) }
                                  onChange={(event) => this.handleDatePickerFormChange("fechaAlta", event)}
                                  minDate={moment('01-01-1901')}
                                  maxDate={moment()}
                                  onKeyDown={(e) => e.preventDefault()}
                                  showMonthDropdown
                                  showYearDropdown
                                  dropdownMode="select"
                                  />
                              </div>
                              )}
                              <small className="text-danger">{this.state.validationErrors.fechaAlta}</small>
                            </div>
                          </div>
                        </div>
                        {/* FECHA FIN GARANTIA */}
                        <div className="col-md-6">
                          <div className="form-group row">
                            <label className="col-md-3 label-control col-form-label" htmlFor="fechaFinGarantia">
                              <FormattedMessage id="movilesAbm.render.general_data.label_fecha_fin_garantia" defaultMessage="Fecha Fin de Garantía"/>{ConfigBusiness.get('moviles.fechaFinGarantia.obligatorio') === 'true' ? requiredSymbol : ' ' }:
                            </label>
                            <div className="col-md-9">
                              {this.props.action === 'VIEW' || (this.props.action === 'EDIT' && (!Security.hasPermission('MOVILES_MODIFICAR_DATOS_GENERALES') )) ? (
                              <div className="form-control-static col-form-label form-value">{formData.fechaFinGarantia === null || formData.fechaFinGarantia === '0000-00-00' ? '' : LocaleFormat.formatDate(formData.fechaFinGarantia) }</div>
                              ) : (
                              <div data-db-column="fechaFinGarantia">
                                <DatePicker
                                  id="fechaFinGarantia"
                                  name="fechaFinGarantia"
                                  className={this.state.validationErrors.fechaFinGarantia ? 'form-control date-picker-placeholder is-invalid' : 'form-control date-picker-placeholder'}
                                  dateFormat={LocaleFormat.getDatePickerFormat()}
                                  placeholderText={this.props.intl.formatMessage({ id: 'movilesAbm.render.general_data.placeholder_fecha_fin_garantia', defaultMessage: 'DD/MM/AAAA' })}
                                  selected={formData.fechaFinGarantia === null || formData.fechaFinGarantia === '0000-00-00' ? null : moment(formData.fechaFinGarantia) }
                                  onChange={(event) => this.handleDatePickerFormChange("fechaFinGarantia", event)}
                                  onKeyDown={(e) => e.preventDefault()}
                                  minDate={moment('01-01-1901')}
                                  showMonthDropdown
                                  showYearDropdown
                                  dropdownMode="select"
                                />
                              </div>
                              )}
                              <small className="text-danger">{this.state.validationErrors.fechaFinGarantia}</small>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        {/* FECHA DE BAJA */}
                        <div className="col-md-6">
                          {this.props.action === 'VIEW' || this.props.action === 'EDIT' ? (
                          <div className="form-group row">
                            <label className="col-md-3 label-control col-form-label" htmlFor="fechaBaja">
                              <FormattedMessage id="movilesAbm.render.general_data.label_fecha_de_baja" defaultMessage="Fecha de Baja"/>:
                            </label>
                            <div className="col-md-9">
                              {this.props.action === 'VIEW' || (this.props.action === 'EDIT' && (!Security.hasPermission('MOVILES_MODIFICAR_DATOS_GENERALES') )) ? (
                              <div className="form-control-static col-form-label form-value">{formData.fechaBaja === null || formData.fechaBaja === '0000-00-00' ? '' : LocaleFormat.formatDate(formData.fechaBaja) }</div>
                              ) : (
                                this.props.action === 'EDIT' ? (
                                <div data-db-column="fechaBaja">
                                  <DatePicker
                                    id="fechaBaja"
                                    name="fechaBaja"
                                    className={this.state.validationErrors.fechaBaja ? 'form-control date-picker-placeholder is-invalid' : "form-control date-picker-placeholder"}
                                    dateFormat={LocaleFormat.getDatePickerFormat()}
                                    placeholderText={this.props.intl.formatMessage({ id: 'movilesAbm.render.general_data.placeholder_fecha_de_baja', defaultMessage: 'DD/MM/AAAA' })}
                                    selected={formData.fechaBaja === null || formData.fechaBaja === '0000-00-00' ? null : moment(formData.fechaBaja) }
                                    onChange={(event) => this.handleDatePickerFormChange("fechaBaja", event)}
                                    maxDate={moment()}
                                    minDate={moment(formData.fechaAlta ? formData.fechaAlta : '')}
                                    onKeyDown={(e) => e.preventDefault()}
                                    showMonthDropdown
                                    showYearDropdown
                                    dropdownMode="select"
                                  />
                                </div>
                                ) : (
                                <div></div>
                                )
                              )}
                            <small className="text-danger">{this.state.validationErrors.fechaBaja}</small>
                            </div>
                          </div>
                          ) : (
                            <div></div>
                          )}
                        </div>
                         {/* FECHA INICIO OPERACION */}
                         <div className="col-md-6">
                          <div className="form-group row">
                            <label className="col-md-3 label-control col-form-label" htmlFor="fechaInicioOperacion">
                              <FormattedMessage id="movilesAbm.render.general_data.label_fecha_inicio_operacion" defaultMessage="Fecha Inicio Operacion"/>:
                            </label>
                            <div className="col-md-9">
                              {this.props.action === 'VIEW' || (this.props.action === 'EDIT' && (!Security.hasPermission('MOVILES_MODIFICAR_DATOS_GENERALES') )) ? (
                              <div className="form-control-static col-form-label form-value">{formData.fechaInicioOperacion === null || formData.fechaInicioOperacion === '0000-00-00' ? '' : formData.fechaInicioOperacion}</div>
                              ) : (
                              <div data-db-column="fechaInicioOperacion">
                                <DatePicker
                                  id="fechaInicioOperacion"
                                  name="fechaInicioOperacion"
                                  className="form-control date-picker-placeholder"
                                  dateFormat={LocaleFormat.getDatePickerFormat()}
                                  placeholderText={this.props.intl.formatMessage({ id: 'movilesAbm.render.general_data.placeholder_fecha_inicio_operacion', defaultMessage: 'DD/MM/AAAA' })}
                                  selected={formData.fechaInicioOperacion === null || formData.fechaInicioOperacion === '0000-00-00' ? null : moment(formData.fechaInicioOperacion)}
                                  onChange={(event) => this.handleDatePickerFormChange("fechaInicioOperacion", event)}
                                  onKeyDown={(e) => e.preventDefault()}
                                  minDate={moment('01-01-1901')}
                                  showMonthDropdown
                                  showYearDropdown
                                  dropdownMode="select"
                                />
                              </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        {/* FECHA FIN DE CONTRATO */}
                        <div className="col-md-6">
                          <div className="form-group row">
                            <label className="col-md-3 label-control col-form-label" htmlFor="fechaFinContrato">
                              <FormattedMessage id="movilesAbm.render.general_data.label_fecha_fin_contrato" defaultMessage="Fecha Fin de Contrato"/>:
                            </label>
                            <div className="col-md-9">
                              {this.props.action === 'VIEW' || (this.props.action === 'EDIT' && (!Security.hasPermission('MOVILES_MODIFICAR_DATOS_GENERALES') )) ? (
                              <div className="form-control-static col-form-label form-value">{formData.fechaFinContrato === null || formData.fechaFinContrato === '0000-00-00' ? '' : LocaleFormat.formatDate(formData.fechaFinContrato) }</div>
                              ) : (
                              <div data-db-column="fechaFinContrato">
                                <DatePicker
                                  id="fechaFinContrato"
                                  name="fechaFinContrato"
                                  className={this.state.validationErrors.fechaFinContrato ? 'form-control date-picker-placeholder is-invalid' : 'form-control date-picker-placeholder'}
                                  dateFormat={LocaleFormat.getDatePickerFormat()}
                                  placeholderText={this.props.intl.formatMessage({ id: 'movilesAbm.render.general_data.placeholder_fecha_de_alta', defaultMessage: 'DD/MM/AAAA' })}
                                  selected={formData.fechaFinContrato === null || formData.fechaFinContrato === '0000-00-00' ? null : moment(formData.fechaFinContrato) }
                                  onChange={(event) => this.handleDatePickerFormChange("fechaFinContrato", event)}
                                  minDate={moment(formData.fechaAlta ? formData.fechaAlta : '' )}
                                  onKeyDown={(e) => e.preventDefault()}
                                  showMonthDropdown
                                  showYearDropdown
                                  dropdownMode="select"
                                />
                              </div>
                              )}
                              <small className="text-danger">{this.state.validationErrors.fechaFinContrato}</small>
                            </div>
                          </div>
                        </div>
                      </div>



                      <div className="row">
                        {this.state.utilizaMovilesReserva ? (
                          <div className="col-md-6">
                            <div className="form-group row">
                              <label className="col-md-3 label-control col-form-label" htmlFor="es_reserva">
                                <FormattedMessage id="movilesAbm.render.general_data.label_es_reserva" defaultMessage="¿Es reserva?" />:
                              </label>
                              <div className="col-md-9">
                                {(this.props.action === 'VIEW'
                                  || (this.props.action === 'EDIT' 
                                      && (!Security.hasPermission('MOVILES_MODIFICAR_DATOS_GENERALES')
                                          || hasPermisoReserva
                                      )
                                ) 
                                ? (
                                  <div className="form-control-static col-form-label form-value">{
                                    (formData.es_reserva === null || formData.es_reserva.value === false)
                                     ? <FormattedMessage id="No" defaultMessage="No"/> :
                                      <FormattedMessage id="Si" defaultMessage="Si" />
                                    }
                                  </div>
                                ) : (
                                    hasPermisoReserva ? (
                                      <div className="form-control-static col-form-label form-value">
                                        {<FormattedMessage id="Si" defaultMessage="Si" />}
                                      </div>
                                    ) : (
                                      <div data-db-column="es_reserva">
                                        <Select
                                          id="es_reserva"
                                          name="es_reserva"
                                          placeholder={this.props.intl.formatMessage({
                                            id: 'movilesAbm.render.general_data.placeholder_es_reserva',
                                            defaultMessage: 'Seleccione'
                                          })}
                                          options={this.state.esReservaOpcion}
                                          value={formData.es_reserva}
                                          onChange={(e) => this.handleChange("es_reserva", e)}
                                          isClearable={false}
                                        />
                                      </div>
                                    )
                                ))
                                }
                              </div>
                            </div>
                          </div>) : ''
                        }
                        {this.state.utilizaMovilesReserva && this.props.action !== 'ADD' ? (
                          <div className="col-md-6">
                            <div className="form-group row">
                              <label className="col-md-3 label-control col-form-label" htmlFor="vehiculoReserva">
                                <FormattedMessage id="movilesAbm.render.general_data.label_vehiculo_reserva" defaultMessage="Vehículo Reserva" />:
                              </label>
                              <div className="col-md-9">
                                {formData.es_reserva_asignada ? 
                                  <div className="form-control-static col-form-label form-value">
                                    <FormattedMessage id="MovilesGridRow.Asignado" defaultMessage="Asignado a" /> {this.state.asignadoA ? this.state.asignadoA : ''}
                                  </div>
                                  : 
                                (this.props.action === 'VIEW' || (this.props.action === 'EDIT' && (!Security.hasPermission('MOVILES_MODIFICAR_DATOS_GENERALES'))) ? (
                                  <div className="form-control-static col-form-label form-value">{
                                    formData.movil_reserva_id && this.state.movilesReserva.length > 0 ?
                                      this.getVehiculoReservaValue('view') : ''}
                                  </div>
                                ) : (
                                  <div data-db-column="id_movilReserva">
                                    <Select
                                      id="movilReserva"
                                      name="movilReserva"
                                      placeholder={this.props.intl.formatMessage({
                                        id: 'movilesAbm.render.general_data.placeholder_vehiculo_reserva',
                                        defaultMessage: 'Seleccione'
                                      })}
                                      options={[{ value: '', label: "Seleccione" }, ...this.state.movilesReserva]}
                                      value={this.getVehiculoReservaValue()}
                                      onChange={(e) => this.handleFormChangeSelectObject("movilReserva", e)}
                                      isLoading={state.movilesReservaLoading}
                                      disabled={state.movilesReservaLoading}
                                    />
                                  </div>
                                ))
                                }
                              </div>
                            </div>
                          </div>) : ''
                        }
                      </div>


                      <div className="row">
                        
                        {/* AYUDANTE */}
                        <div className="col-md-6">
                          <div className="form-group row">
                            <label className="col-md-3 label-control col-form-label" htmlFor="ayudante">
                            <FormattedMessage id="movilesAbm.render.general_data.label_Ayudante" defaultMessage="Ayudante"/> :
                            </label>
                            <div className="col-md-9">
                              {this.props.action === 'VIEW' || (this.props.action === 'EDIT' && (!Security.hasPermission('MOVILES_MODIFICAR_DATOS_GENERALES') )) ? (
                              <div className="form-control-static col-form-label form-value">{this.state.formData.catalogoAyudante ? this.state.formData.catalogoAyudante.valor : ''}</div>
                              ) : (
                                <div >
                                  <div className={Security.hasPermission('AYUDANTE_CREAR') ? "col-md-10" : "col-md-12"} style = {{display: "inline-table", padding: 0 + "px"}} data-db-column="id_ayudante">
                                    <Select
                                      id="ayudante"
                                      name="ayudante"
                                      placeholder={this.props.intl.formatMessage({ id: 'movilesAbm.render.general_data.placeholder_ayudante', defaultMessage: 'Seleccione' })}
                                      options={this.state.catalogoAyudantes}
                                      valueKey='id'
                                      labelKey='valor'
                                      value={this.state.formData.catalogoAyudante ? this.state.formData.catalogoAyudante : null}
                                      onChange={(e) => this.handleFormChangeSelectAyudante(e)}
                                    />
                                  </div>
                                  {
                                    Security.hasPermission('AYUDANTE_CREAR') ? 
                                      <div className="col-md-1" style = {{display: "inline-table",  'paddingRight': 0 + "px"}}>
                                        <button type="button" className="btn btn-primary" onClick={()=>this.handleAgregarAyudante()}>+</button>
                                      </div>
                                      : ''
                                  }
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        {/* PLOTEADO */}
                        <div className="col-md-6">
                          <div className="form-group row">
                            <label className="col-md-3 label-control col-form-label" htmlFor="ploteado">
                            <FormattedMessage id="movilesAbm.render.general_data.label_Ploteado" defaultMessage="Ploteado"/> :
                            </label>
                            <div className="col-md-9">
                              {this.props.action === 'VIEW' || (this.props.action === 'EDIT' && (!Security.hasPermission('MOVILES_MODIFICAR_DATOS_GENERALES') )) ? (
                              <div className="form-control-static col-form-label form-value">{this.state.formData.catalogoPloteado ? this.state.formData.catalogoPloteado.valor : ''}</div>
                              ) : (
                                <div >
                                  <div className={Security.hasPermission('PLOTEADO_CREAR') ? "col-md-10" : "col-md-12"} style = {{display: "inline-table", padding: 0 + "px"}} data-db-column="id_ploteado">
                                    <Select
                                      id="ploteado"
                                      name="ploteado"
                                      placeholder={this.props.intl.formatMessage({ id: 'movilesAbm.render.general_data.placeholder_ploteado', defaultMessage: 'Seleccione' })}
                                      options={this.state.catalogoPloteados}
                                      valueKey='id'
                                      labelKey='valor'
                                      value={this.state.formData.catalogoPloteado ? this.state.formData.catalogoPloteado : null}
                                      onChange={(e) => this.handleFormChangeSelectPloteado(e)}
                                    />
                                  </div>
                                  { Security.hasPermission('PLOTEADO_CREAR') ? (
                                    <div className="col-md-1" style = {{display: "inline-table",  'paddingRight': 0 + "px"}}>
                                      <button type="button" className="btn btn-primary" onClick={()=>this.handleAgregarPloteado()}>+</button>
                                    </div>
                                  ) : ''}
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                        {/* TIPO DE PLOTEO*/}
                        <div className="col-md-6">
                          <div className="form-group row">
                            <label className="col-md-3 label-control col-form-label" htmlFor="tipoPloteo">
                            <FormattedMessage id="movilesAbm.render.general_data.label_Tipo_de_Ploteo" defaultMessage="Tipo de Ploteo"/> :
                            </label>
                            <div className="col-md-9">
                              {this.props.action === 'VIEW' || (this.props.action === 'EDIT' && (!Security.hasPermission('MOVILES_MODIFICAR_DATOS_GENERALES') )) ? (
                              <div className="form-control-static col-form-label form-value">{this.state.formData.catalogoTipoPloteo ? this.state.formData.catalogoTipoPloteo.valor : ''}</div>
                              ) : (
                                <div >
                                  <div className={Security.hasPermission('TIPO_DE_PLOTEO_CREAR') ? "col-md-10" : "col-md-12"} style = {{display: "inline-table", padding: 0 + "px"}} data-db-column="id_tipoPloteo">
                                    <Select
                                      id="tipoPloteo"
                                      name="tipoPloteo"
                                      placeholder={this.props.intl.formatMessage({ id: 'movilesAbm.render.general_data.placeholder_tipo_plote', defaultMessage: 'Seleccione' })}
                                      options={state.catalogoTipoPloteos}
                                      valueKey='id'
                                      labelKey='valor'
                                      value={this.state.formData.catalogoTipoPloteo ? this.state.formData.catalogoTipoPloteo : null}
                                      onChange={(e) => this.handleFormChangeSelectTipoPloteo(e)}
                                    />
                                  </div>
                                  { Security.hasPermission('TIPO_DE_PLOTEO_CREAR') ? (
                                    <div className="col-md-1" style = {{display: "inline-table",  'paddingRight': 0 + "px"}}>
                                      <button type="button" className="btn btn-primary" onClick={()=>this.handleAgregarTipoPloteo()}>+</button>
                                    </div>
                                  ) : ''}
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-6">
                        </div>
                        {/* BOTON DATOS GENERALES */}
                        <div className="col-md-6">
                          <div className="row justify-content-end">
                          {Security.renderIfHasPermission('MOVILES_DATOS_GENERALES_HISTORICO_LISTAR', (
                            <div className="col-md-4">
                              {this.props.action === 'VIEW' || this.props.action === 'EDIT' ? (
                                <button type="button" className="btn btn-fleet float-right" data-toggle="modal" data-target="#datosGenerales_modal" onClick={()=>this.handleSetTipo('datosGenerales')}>
                                <i className="la la-search align-middle"></i>
                                <FormattedMessage id="movilesAbm.render.administracion.datosGenerales_movil" defaultMessage="Histórico D. Generales"/>
                                </button>
                                ) : (
                                <div style={{display:'none'}}></div>
                              )}
                            </div>
                          ))}
                          </div>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
                <div className="card pull-up">
                  <div className="card-content">
                    <div className="card-body">
                      <h4 className="form-section mt-2">
                        <i className="ft-users"></i> <FormattedMessage id="movilesAbm.render.choferes.header_choferes" defaultMessage="Choferes"/>
                      </h4>
                      <div className="row">
                        {/* RESPONSABLE 1 */}
                        <div className="col-md-6">
                          <div className="form-group row">
                            <label className="col-md-3 label-control col-form-label" htmlFor="responsable1">
                              <FormattedMessage id="movilesAbm.render.choferes.label_responsable1" defaultMessage="Responsable 1"/>:
                            </label>
                            <div className="col-md-9">
                              <div data-db-column="responsable1">
                                <Select.Async
                                  name="responsable1"
                                  placeholder={this.props.intl.formatMessage({ id: 'movilesAbm.render.choferes.placeholder_responsable1', defaultMessage: 'Seleccione' })}
                                  value={this.state.formData.responsable1}
                                  valueKey="id"
                                  labelKey="label"
                                  loadOptions={this.getBackendPersonasPorBase}
                                  onChange={e => this.handleChange("responsable1", e)}
                                  disabled={(this.state.disableAvlFields && this.props.action === 'EDIT' ) || this.props.action === 'VIEW' || (this.props.action === 'EDIT' && !Security.hasPermission('MOVILES_MODIFICAR_CHOFERES'))}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        {/* RESPONSABLE 2 */}
                        <div className="col-md-6">
                          <div className="form-group row">
                            <label className="col-md-3 label-control col-form-label" htmlFor="responsable2">
                              <FormattedMessage id="movilesAbm.render.choferes.label_responsable2" defaultMessage="Responsable 2"/>:
                            </label>
                            <div className="col-md-9">
                              <div data-db-column="responsable2">
                                <Select.Async
                                  name="responsable2"
                                  placeholder={this.props.intl.formatMessage({ id: 'movilesAbm.render.choferes.placeholder_responsable2', defaultMessage: 'Seleccione' })}
                                  value={this.state.formData.responsable2}
                                  valueKey="id"
                                  labelKey="label"
                                  loadOptions={this.getBackendPersonasPorBase}
                                  onChange={e => this.handleChange("responsable2", e)}
                                  disabled={this.props.action === 'VIEW' || (this.props.action === 'EDIT' && !Security.hasPermission('MOVILES_MODIFICAR_CHOFERES'))}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        {/* RESPONSABLE 3 */}
                        <div className="col-md-6">
                          <div className="form-group row">
                            <label className="col-md-3 label-control col-form-label" htmlFor="responsable3">
                              <FormattedMessage id="movilesAbm.render.choferes.label_responsable3" defaultMessage="Responsable 3"/>:
                            </label>
                            <div className="col-md-9">
                              <div data-db-column="responsable3">
                                <Select.Async
                                  name="responsable1"
                                  placeholder={this.props.intl.formatMessage({ id: 'movilesAbm.render.choferes.placeholder_responsable1', defaultMessage: 'Seleccione' })}
                                  value={this.state.formData.responsable3}
                                  valueKey="id"
                                  labelKey="label"
                                  loadOptions={this.getBackendPersonasPorBase}
                                  onChange={e => this.handleChange("responsable3", e)}
                                  disabled={(this.state.disableAvlFields && this.props.action === 'EDIT' ) || this.props.action === 'VIEW' || (this.props.action === 'EDIT' && !Security.hasPermission('MOVILES_MODIFICAR_CHOFERES'))}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        {/* RESPONSABLE 4 */}
                        <div className="col-md-6">
                          <div className="form-group row">
                            <label className="col-md-3 label-control col-form-label" htmlFor="responsable4">
                              <FormattedMessage id="movilesAbm.render.choferes.label_responsable4" defaultMessage="Responsable 4"/>:
                            </label>
                            <div className="col-md-9">
                              <div data-db-column="responsable4">
                                <Select.Async
                                  name="responsable2"
                                  placeholder={this.props.intl.formatMessage({ id: 'movilesAbm.render.choferes.placeholder_responsable2', defaultMessage: 'Seleccione' })}
                                  value={this.state.formData.responsable4}
                                  valueKey="id"
                                  labelKey="label"
                                  loadOptions={this.getBackendPersonasPorBase}
                                  onChange={e => this.handleChange("responsable4", e)}
                                  disabled={this.props.action === 'VIEW' || (this.props.action === 'EDIT' && !Security.hasPermission('MOVILES_MODIFICAR_CHOFERES'))}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        {/* RESPONSABLE 5 */}
                        <div className="col-md-6">
                          <div className="form-group row">
                            <label className="col-md-3 label-control col-form-label" htmlFor="responsable5">
                              <FormattedMessage id="movilesAbm.render.choferes.label_responsable5" defaultMessage="Responsable 5"/>:
                            </label>
                            <div className="col-md-9">
                              <div data-db-column="responsable5">
                                <Select.Async
                                  name="responsable1"
                                  placeholder={this.props.intl.formatMessage({ id: 'movilesAbm.render.choferes.placeholder_responsable1', defaultMessage: 'Seleccione' })}
                                  value={this.state.formData.responsable5}
                                  valueKey="id"
                                  labelKey="label"
                                  loadOptions={this.getBackendPersonasPorBase}
                                  onChange={e => this.handleChange("responsable5", e)}
                                  disabled={(this.state.disableAvlFields && this.props.action === 'EDIT' ) || this.props.action === 'VIEW' || (this.props.action === 'EDIT' && !Security.hasPermission('MOVILES_MODIFICAR_CHOFERES'))}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        {/* SUPERVISOR */}
                        <div className="col-md-6">
                          <div className="form-group row">
                            <label className="col-md-3 label-control col-form-label" htmlFor="supervisor">
                              <FormattedMessage id="movilesAbm.render.choferes.label_supervisor" defaultMessage="Supervisor"/>:
                            </label>
                            <div className="col-md-9">
                              <div data-db-column="supervisor">
                                <Select.Async
                                  name="supervisor"
                                  placeholder={this.props.intl.formatMessage({ id: 'movilesAbm.render.choferes.placeholder_supervisor', defaultMessage: 'Seleccione' })}
                                  value={this.state.formData.supervisor}
                                  valueKey="id"
                                  labelKey="label"
                                  loadOptions={this.getBackendPersonasPorBase}
                                  onChange={e => this.handleChange("supervisor", e)}
                                  disabled={this.props.action === 'VIEW' || (this.props.action === 'EDIT' && !Security.hasPermission('MOVILES_MODIFICAR_CHOFERES'))}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        {/* TEMPORAL */}
                        <div className="col-md-6">
                          <div className="form-group row">
                            <label className="col-md-3 label-control col-form-label" htmlFor="temporal">
                              <FormattedMessage id="movilesAbm.render.choferes.label_temporal" defaultMessage="Temporal"/>:
                            </label>
                            <div className="col-md-9">
                              <div data-db-column="temporal">
                                <Select.Async
                                  name="temporal"
                                  placeholder={this.props.intl.formatMessage({ id: 'movilesAbm.render.choferes.placeholder_temporal', defaultMessage: 'Seleccione' })}
                                  value={this.state.formData.temporal}
                                  valueKey="id"
                                  labelKey="label"
                                  loadOptions={this.getBackendPersonasPorBase}
                                  onChange={e => this.handleChange("temporal", e)}
                                  disabled={this.props.action === 'VIEW' || (this.props.action === 'EDIT' && !Security.hasPermission('MOVILES_MODIFICAR_CHOFERES'))}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        {/* COORDINADOR */}
                        <div className="col-md-6">
                          <div className="form-group row">
                            <label className="col-md-3 label-control col-form-label" htmlFor="coordinador">
                              <FormattedMessage id="movilesAbm.render.choferes.label_coordinador" defaultMessage="Coordinador"/>:
                            </label>
                            <div className="col-md-9">
                              <div data-db-column="coordinador">
                                <Select.Async
                                  name="coordinador"
                                  placeholder={this.props.intl.formatMessage({ id: 'movilesAbm.render.choferes.placeholder_coordinador', defaultMessage: 'Seleccione' })}
                                  value={this.state.formData.coordinador}
                                  valueKey="id"
                                  labelKey="label"
                                  loadOptions={this.getBackendPersonasPorBase}
                                  onChange={e => this.handleChange("coordinador", e)}
                                  disabled={this.props.action === 'VIEW' || (this.props.action === 'EDIT' && !Security.hasPermission('MOVILES_MODIFICAR_CHOFERES'))}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        {/* BOTON HISTORICO CHOFERES */}
                        <div className="col-md-6">
                          <div className="row justify-content-end">
                          {Security.renderIfHasPermission('MOVILES_CHOFERES_HISTORICO_LISTAR', (
                            <div className="col-md-4">
                              {this.props.action === 'VIEW' || this.props.action === 'EDIT' ? (
                              <button type="button" className="btn btn-fleet float-right" data-toggle="modal" data-target="#choferes_modal" onClick={()=>this.handleSetTipo('choferes')}>
                              <i className="la la-search align-middle"></i>
                              <FormattedMessage id="movilesAbm.render.administracion.historico_de_choferes_del_movil" defaultMessage="Histórico de Choferes"/>
                              </button>
                              ) : (
                              <div style={{display:'none'}}></div>
                              )}
                            </div>
                          ))}
                          </div>
                        </div>

                      </div>
                    </div>
                  </div>
                </div>
                <div className="card pull-up" >
                  <div className="card-content">
                    <div className="card-body">
                      <h4 className="form-section mt-2">
                        <i className="la la-cog"></i> <FormattedMessage id="movilesAbm.render.administracion.header_administracion" defaultMessage="Administración"/>
                      </h4>
                    {ConfigBusiness.get('moviles.base.mostrarEnDatosGenerales') === 'false' ? (
                        <div className="row">
                            {/* BASE */}
                            <div className="col-md-6">
                                <div className="form-group row">
                                    <label className="col-md-3 label-control col-form-label" htmlFor="base">
                                        <FormattedMessage id="movilesAbm.render.administracion.label_base" defaultMessage="Base" />
                                        {requiredSymbol}:
                                    </label>
                                    <div className="col-md-9">
                                        {/* Verificar acción y permisos para visualización o edición */}
                                        {(
                                            this.props.action === 'VIEW' ||                                        
                                            (this.props.action === 'EDIT' && 
                                            !Security.hasPermission('MOVILES_MODIFICAR_ADMINISTRACION') && 
                                            !permisoMovilesModificarBase)) ? (
                                            <div className="form-control-static col-form-label form-value">
                                                {formData.base && formData.base.descripcion ? formData.base.descripcion : ''}
                                            </div>
                                        ) : (
                                            <div data-db-column="id_base">                                            
                                            {
                                                (
                                                    Security.hasPermission('MOVILES_MODIFICAR_DATOS_GENERALES') ||
                                                    permisoMovilesModificarBase) ? (
                                                    <Select.Async
                                                        id="base"
                                                        name="base"
                                                        placeholder={this.props.intl.formatMessage({
                                                            id: 'movilesAbm.render.general_data.placeholder_base',
                                                            defaultMessage: 'Seleccione',
                                                        })}
                                                        valueKey="value"
                                                        labelKey="label"
                                                        value={base ? { value: base.id, label: base.descripcion || base.label } : null}
                                                        loadOptions={this.getBackendBases}
                                                        onChange={(e) =>
                                                            this.handleFormChangeSelectObject("base", e).then(() => {
                                                                this.getJefeBase();
                                                            })
                                                        }
                                                    />
                                                ) : (

                                                    <div className="form-control-static col-form-label form-value">
                                                        {formData.base && formData.base.descripcion ? formData.base.descripcion : ''}
                                                    </div>
                                                )
                                            }
                                                {/* Mensaje de error para validaciones */}
                                                <small className="text-danger">{this.state.validationErrors.base}</small>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    ) : null}
                      <div className="row">
                        {/* TRANSPORTADORA */}
                        <div className="col-md-6">
                          <div className="form-group row">
                            <label className="col-md-3 label-control col-form-label" htmlFor="transportadora">
                              <FormattedMessage id="movilesAbm.render.general_data.label_Transportadora" defaultMessage="Transportadora" />{ConfigBusiness.get('moviles.transportadora.obligatorio') === 'true' ? requiredSymbol : ' '}:
                            </label>
                            <div className="col-md-9">
                              <small className="text-danger">{this.state.validationErrors.transportadoras}</small>
                              {ConfigBusiness.get('moviles.transportadora.asignacionUnica') !== 'true' ? (
                              <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                                <div style={{ flexGrow: 1, minWidth: 0 }}>
                                  <div className="form-control-static col-form-label form-value pl-2 pr-2" style={{ marginBottom: 0, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                    {formData.transportadoras && formData.transportadoras[0] ? formData.transportadoras[0].nombre : ''}
                                  </div>
                                </div>
                                <div style={{ flexShrink: 0, marginLeft: '8px' }}>
                                  <button
                                    type="button"
                                    className="btn btn-fleet"
                                    data-toggle="modal"
                                    data-target="#gestionar_transportadoras_modal"
                                    onClick={() => this.handleSetTipo('GestionarTransportadoras')}
                                    style={{ minWidth: '180px' }}
                                  >
                                    <i className="la la-search align-middle mr-1"></i>
                                    <FormattedMessage id="movilesAbm.render.administracion.gestionar_transportadoras" defaultMessage="Gestionar Transportadoras" />
                                  </button>
                                </div>
                              </div>) : (
                              <div>
                                <Select
                                  id="transportadora"
                                  name="transportadora"
                                  placeholder={this.props.intl.formatMessage({ id: 'movilesAbm.render.general_data.placeholder_funcion', defaultMessage: 'Seleccione' })}
                                  options={state.transportadoras}
                                  valueKey='id'
                                  labelKey='nombre'
                                  value={this.state.formData.transportadoras ? this.state.formData.transportadoras[0] : ''}
                                  onChange={(e) => this.handleTransportadoraChange(e)}
                                  disabled={this.props.action === 'VIEW' || !Security.hasPermission('MOVILES_MODIFICAR_ADMINISTRACION') ? true : false}
                                />
                              </div>)}

                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        {/* CENTRO DE COSTOS */}
                        {this.state.viewCentroCostos ? (
                        <div className="col-md-6">
                          <div className="form-group row">
                            <label className="col-md-3 label-control col-form-label" htmlFor="centroCostos">
                              <FormattedMessage id="movilesAbm.render.administracion.label_centro_de_costos" defaultMessage="Centro de costos"/>{ConfigBusiness.get('moviles.centroCostos.obligatorio') === 'true' ? requiredSymbol : ' ' }:
                            </label>
                            <div className="col-md-9">
                              {this.props.action === 'VIEW' || (this.props.action === 'EDIT' && !Security.hasPermission('MOVILES_MODIFICAR_ADMINISTRACION')) ? (
                              <div className="form-control-static col-form-label form-value">{formData.centroCostos && formData.centroCostos.nombre ? formData.centroCostos.nombre : ''}</div>
                              ) : (
                              <div data-db-column="id_centroCostos">
                                <Select.Async
                                  id="centroCostos"
                                  name="centroCostos"
                                  placeholder={this.props.intl.formatMessage({ id: 'movilesAbm.render.general_data.placeholder_centro_de_costos', defaultMessage: 'Seleccione' })}
                                  valueKey='value'
                                  labelKey='label'
                                  value={centroCostos ? { value: centroCostos.id, label: centroCostos.nombre || centroCostos.label } : null}
                                  loadOptions={this.getBackendCentrosCostos}
                                  onChange={this.props.action === 'ADD' ? (e) => this.handleFormChangeSelectObject("centroCostos", e) : (e) => this.handleChangeCentroCosto("centroCostos", e)}
                                  className={this.state.validationErrors.centroCostos ? 'is-invalid' : ''}
                                  clearable={false}
                                />
                                <small className="text-danger">{this.state.validationErrors.centroCostos}</small>
                              </div>
                              )}
                            </div>
                          </div>
                        </div>
                        ) : null}
                        {/* CERTIFICADO VTV */}
                        <div className="col-md-6">
                          <div className="form-group row">
                            <label className="col-md-3 label-control col-form-label" htmlFor="certificadoVtv">
                              <FormattedMessage id="movilesAbm.render.administracion.label_certificado_VTV" defaultMessage="Certificado VTV"/>:
                            </label>
                            <div className="col-md-9">
                              {this.props.action === 'VIEW' || (this.props.action === 'EDIT' && !Security.hasPermission('MOVILES_MODIFICAR_ADMINISTRACION')) ? (
                              <div className="form-control-static col-form-label form-value">{formData.certificadoVtv ? formData.certificadoVtv : ''}</div>
                              ) : (
                              <div>
                                <input type="text" className="form-control" id="certificadoVtv" name="certificadoVtv" placeholder="" value={formData.certificadoVtv} onChange={this.handleInputFormChange} data-db-column="certificadoVtv" />
                              </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        {/* DIVISION */}
                        {ConfigBusiness.get('moviles.trabajaConDivisiones.habilitado') === 'true' ? (
                        <div className="col-md-6">
                          <div className="form-group row">
                            <label className="col-md-3 label-control col-form-label" htmlFor="division">
                              <FormattedMessage id="División" defaultMessage="División"/>*:
                            </label>
                            <div className="col-md-9">
                              {this.props.action === 'VIEW' || (this.props.action === 'EDIT' && !Security.hasPermission('MOVILES_MODIFICAR_ADMINISTRACION')) ? (
                              <div className="form-control-static col-form-label form-value">{formData.division && formData.division.nombre ? formData.division.nombre : ''}</div>
                              ) : (
                              <div data-db-column="id_division">
                                <Select
                                  id="division"
                                  name="division"
                                  placeholder={!state.divisionesLoading ? this.props.intl.formatMessage({ id: 'Seleccione', defaultMessage: 'Seleccione' }) : ''}
                                  options={this.state.divisiones}
                                  valueKey='value'
                                  labelKey='label'
                                  value={division ? {value: division.value, label: division.label} : null }
                                  onChange={(e) => this.handleFormChangeSelectObject("division", e)}
                                  isLoading={state.divisionesLoading}
                                  disabled={state.divisionesLoading}
                                />
                              </div>
                              )}
                            </div>
                          </div>
                        </div>
                        ) : null}
                      </div>
                      <div className="row">
                        {/* POLIZA */}
                        {this.state.viewPoliza ? (
                        <div className="col-md-6">
                          <div className="form-group row">
                            <label className="col-md-3 label-control col-form-label" htmlFor="poliza">
                              <FormattedMessage id="movilesAbm.render.administracion.label_poliza" defaultMessage="Póliza"/>:
                            </label>
                            <div className="col-md-9">
                              {this.props.action === 'VIEW' || (this.props.action === 'EDIT' && !Security.hasPermission('MOVILES_MODIFICAR_ADMINISTRACION')) ? (
                              <div className="form-control-static col-form-label form-value">{formData.poliza ? formData.poliza : ''}</div>
                              ) : (
                              <div>
                                <input type="text" className="form-control" id="poliza" name="poliza" placeholder="" value={formData.poliza ? formData.poliza : ''} onChange={this.handleInputFormChange} data-db-column="poliza"/>
                              </div>
                              )}
                            </div>
                          </div>
                        </div>
                        ) : null}
                        {/* YPF RUTA | TARJETA COMBUSTIBLE ADD */}
                        {this.state.viewYpfRuta && this.props.action !== 'EDIT' ? (
                        <div className="col-md-6">
                          <div className="form-group row">
                            <label className="col-md-3 label-control col-form-label" htmlFor="ypfRuta">
                              <FormattedMessage id="movilesAbm.render.administracion.label_YPF_ruta" defaultMessage="YPF Ruta"/>:
                            </label>
                            <div className="col-md-9">
                              {this.props.action === 'VIEW' || (this.props.action === 'EDIT' && !Security.hasPermission('MOVILES_MODIFICAR_ADMINISTRACION')) ? (
                              <div className="form-control-static col-form-label form-value">{formData.ypfRuta ? formData.ypfRuta : ''}</div>
                              ) : (
                              <div>
                                <input type="text" className="form-control" id="ypfRuta" name="ypfRuta" placeholder="" value={formData.ypfRuta ? formData.ypfRuta : ''} onChange={this.handleInputFormChange} data-db-column="ypfRuta" />
                              </div>
                              )}
                            </div>
                          </div>
                        </div>
                        ) : null}
                        {/* YPF RUTA | TARJETA COMBUSTIBLE EDIT */}
                        {this.state.viewYpfRuta && this.props.action === 'EDIT' ? (
                        <div className="col-md-6">
                          <div className="form-group row">
                            <label className="col-md-3 label-control col-form-label" htmlFor="ypfRuta">
                              <FormattedMessage id="movilesAbm.render.administracion.label_YPF_ruta" defaultMessage="YPF Ruta"/>:
                            </label>
                            <div className="col-md-9">
                              {(this.props.action === 'EDIT' && !Security.hasPermission('MOVILES_MODIFICAR_ADMINISTRACION')) ? (
                              <div className="form-control-static col-form-label form-value">{formData.ypfRuta ? formData.ypfRuta : ''}</div>
                              ) : (
                              <div>
                                <input
                                  type="text"
                                  className="form-control"
                                  id="ypfRuta"
                                  name="ypfRuta"
                                  value={formData.ypfRuta ? formData.ypfRuta : ''}
                                  onChange={this.handleInputFormChange}
                                  onBlur={this.handleChangeTarjetaCombustible}
                                  data-db-column="ypfRuta"
                                />
                              </div>
                              )}
                            </div>
                          </div>
                        </div>
                        ) : null}
                      </div>
                      <div className="row">
                        {/* TELEPEAJE */}
                        <div className="col-md-6">
                          <div className="form-group row">
                            <label className="col-md-3 label-control col-form-label" htmlFor="telepeaje">
                              <FormattedMessage id="movilesAbm.render.administracion.label_telepeaje" defaultMessage="Telepeaje"/>:
                            </label>
                            <div className="col-md-9">
                              {this.props.action === 'VIEW' || (this.props.action === 'EDIT' && !Security.hasPermission('MOVILES_MODIFICAR_ADMINISTRACION')) ? (
                              <div className="form-control-static col-form-label form-value">{formData.telepeaje ? formData.telepeaje : ''}</div>
                              ) : (
                              <div>
                                <input type="text" className="form-control" id="telepeaje" name="telepeaje" placeholder="" value={formData.telepeaje ? formData.telepeaje : ''} onChange={this.handleInputFormChange} data-db-column="telepeaje" />
                              </div>
                              )}
                            </div>
                          </div>
                        </div>
                        {/* PROVEEDOR GPS */}
                        <div className="col-md-6">
                          <div className="form-group row">
                            <label className="col-md-3 label-control col-form-label" htmlFor="proveedorGps">
                              <FormattedMessage id="movilesAbm.render.administracion.label_proveedor_GPS" defaultMessage="Proveedor GPS"/>:
                            </label>
                            <div className="col-md-9">
                              {this.props.action === 'VIEW' || (this.props.action === 'EDIT' && !Security.hasPermission('MOVILES_MODIFICAR_ADMINISTRACION')) ? (
                              <div className="form-control-static col-form-label form-value">{formData.proveedorGps ? formData.proveedorGps.razon_social : ''}</div>
                              ) : (
                              <div data-db-column="id_proveedorGps">
                                <Select
                                  id="proveedorGps"
                                  name="proveedorGps"
                                  placeholder={!state.proveedoresGpsLoading ? this.props.intl.formatMessage({ id: 'movilesAbm.render.general_data.placeholder_proveedorGps', defaultMessage: 'Seleccione' }) : ''}
                                  options={this.state.proveedoresGps}
                                  valueKey='value'
                                  labelKey='label'
                                  value={proveedorGps ? { value: proveedorGps.id, label: proveedorGps.label } : null}
                                  onChange={(e) => this.handleFormChangeSelectObject("proveedorGps", e)}
                                  isLoading={state.proveedoresGpsLoading}
                                  disabled={state.proveedoresGpsLoading}
                                />
                              </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        {/* KM ACTUAL */}
                        <div className="col-md-6">
                          <div className="form-group row">
                          { formData.unidadMedidorId && UNIDAD_MEDIDOR[formData.unidadMedidorId]['label'] === 'ODOMETRO' ? (
														<label className="col-md-3 label-control col-form-label" htmlFor="kmActual">
                              <FormattedMessage id="movilesAbm.render.administracion.label_km_actual" defaultMessage="Km Actual"/>{ConfigBusiness.get('moviles.kmActual.obligatorio') === 'true' ? requiredSymbol : ' ' }:
														</label>
                          ):''}
                          { formData.unidadMedidorId && UNIDAD_MEDIDOR[formData.unidadMedidorId]['label'] === 'HOROMETRO' ? (
                            <label className="col-md-3 label-control col-form-label" htmlFor="kmActual">
                            <FormattedMessage id="correctivosAbm.datos_generales.label_horometro_actual" defaultMessage="Horometro Actual"/>{ConfigBusiness.get('moviles.kmActual.obligatorio') === 'true' ? requiredSymbol : ' ' }:
                          </label>
                          ):''}
														<div className="col-md-9">
                            {this.props.action === 'VIEW' || (this.props.action === 'EDIT' && !Security.hasPermission('MOVILES_MODIFICAR_KM')) ? (
                              <div className="form-control-static col-form-label form-value">{formData.kmActual ? Math.floor(formData.kmActual).toLocaleString(LocaleFormat.getNumberLocale()) + ' ' + this.props.intl.formatMessage(Number(formData.kmActual) === 0 ? UnitSystem.message('distance') : UnitSystem.message('distancePlural')) : 0 + ' ' + this.props.intl.formatMessage(UnitSystem.message('distance'))}</div>
                              ) : (
                                <div>
                                  <input 
                                  type="text" 
                                  className={this.state.validationErrors.kmActual ? 'form-control is-invalid' : 'form-control'} 
                                  id="kmActual" 
                                  name="kmActual" 
                                  placeholder="" 
                                  value={formData.kmActual ? formData.kmActual : '' } 
                                  onChange={(e)=>this.handleChange('kmActual', e.target.value)} 
                                  onBlur={this.handleKmActualChange} 
                                  data-db-column="kmActual" />
                                  
                                  <small className="text-danger">{this.state.validationErrors.kmActual}</small>
                                </div>
                              )}
                               </div>
                          
                          </div>
                        </div>
                        {/* KM UPDATE */}
                        {this.state.props.action !== 'ADD' && this.state.cambiokmActual ?
                          <div className="col-md-6">
                            <div className="form-group row">
                              <label className="col-md-3 label-control col-form-label" htmlFor="kmUpdate">
                                <FormattedMessage id="Fecha_de_Lectura" defaultMessage="Fecha de Lectura"/>:
                              </label>
                              <div data-db-column="idKmUpdate" className="col-md-9">
                                <DatePicker
                                  id="kmUpdate"
                                  name="kmUpdate"
                                  className="form-control date-picker-placeholder"
                                  dateFormat={LocaleFormat.getDateTimePickerFormat()}
                                  placeholderText={this.props.intl.formatMessage({ id: 'ticketModificarAsignacion.render.edit_assignment.placeholder_turno', defaultMessage: 'DD/MM/AAAA' })}
                                  selected={formData.kmUpdate === null || formData.kmUpdate === '0000-00-00 00:00' ? null : moment(formData.kmUpdate) }
                                  onChange={(event) => this.handleDatePickerFormChange("kmUpdate", event)}
                                  onChangeRaw={(event) => this.handleDatePickerFormRawChange("kmUpdate", event.target.value)}
                                  showTimeSelect
                                  maxDate={moment()}
                                  timeIntervals = { 10 }
                                  minTime={moment().hours(0).minutes(0)}
                                  maxTime={this.getMaxTime(formData.kmUpdate)}
                                  popperPlacement="right"
                                />
                              </div>
                            </div>
                          </div>
                        : null}
                      </div>
                      {/* IMEI */}
                      <div className="row">
                        <div className="col-md-6">
                          <div className="form-group row">
                            <label className="col-md-3 label-control col-form-label" htmlFor="imei">
                              <FormattedMessage id="movilesAbm.render.administracion.label_IMEI" defaultMessage="IMEI"/> :
                            </label>
                            <div className="col-md-9">
                              <div className="form-control-static col-form-label form-value">{formData.imei ? formData.imei : ''}</div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        {/* CEBE */}
                        {this.state.viewCebe ? (
                        <div className="col-md-6">
                          <div className="form-group row">
                            <label className="col-md-3 label-control col-form-label" htmlFor="cebe">
                              <FormattedMessage id="movilesAbm.render.administracion.label_cebe" defaultMessage="Cebe"/>{ConfigBusiness.get('moviles.cebe.obligatorio') === 'true' ? requiredSymbol : ' ' }:
                            </label>
                            <div className="col-md-9">
                              {this.props.action === 'VIEW' || (this.props.action === 'EDIT' && !Security.hasPermission('MOVILES_MODIFICAR_ADMINISTRACION')) ? (
                              <div className="form-control-static col-form-label form-value">{formData.cebe ? formData.cebe.nombre : ''}</div>
                              ) : (
                              <div data-db-column="id_cebe">
                                <Select.Async
                                  id="cebe"
                                  name="cebe"
                                  placeholder={this.props.intl.formatMessage({ id: 'movilesAbm.render.general_data.placeholder_cebe', defaultMessage: 'Seleccione' })}
                                  valueKey='value'
                                  labelKey='label'
                                  value={cebe ? { value: cebe.id, label: cebe.nombre } : null}
                                  loadOptions={this.getBackendCebes}
                                  onChange={(e) => this.handleFormChangeSelectObject("cebe", e)}
                                  className={this.state.validationErrors.cebe ? 'is-invalid':''}
                                />
                                <small className="text-danger">{this.state.validationErrors.cebe}</small>
                              </div>
                              )}
                            </div>
                          </div>
                        </div>
                        ) : ''}
                        {/* LUGAR DE GUARDA */}
                        {this.state.viewLugarGuarda ? (
                        <div className="col-md-6">
                          <div className="form-group row">
                            <label className="col-md-3 label-control col-form-label" htmlFor="lugarGuarda">
                              <FormattedMessage id="movilesAbm.render.administracion.label_lugar_guarda" defaultMessage="Lugar Guarda"/>{ConfigBusiness.get('moviles.lugarGuarda.obligatorio') === 'true' ? requiredSymbol : ' ' }:
                            </label>
                            <div className="col-md-9">
                              {this.props.action === 'VIEW' || (this.props.action === 'EDIT' && !Security.hasPermission('MOVILES_MODIFICAR_ADMINISTRACION')) ? (
                              <div className="form-control-static col-form-label form-value">{formData.lugarGuarda ? formData.lugarGuarda : ''}</div>
                              ) : (
                              <div>
                                <input type="text" className="form-control" id="lugarGuarda" name="lugarGuarda" placeholder="" value={formData.lugarGuarda ? formData.lugarGuarda : ''} onChange={this.handleInputFormChange} data-db-column="lugarGuarda"/>
                              </div>
                              )}
                            </div>
                          </div>
                        </div>
                        ) : null}
                      </div>

                      {(ConfigBusiness.get('moviles.visualizar_restringido') === 'true' && !Security.hasPermission('MOVILES_VISUALIZAR_ATRIBUTOS_CONTRATO')) ? null : (<div><div className="row">
                        {/* VALOR ADQUISICION */}
                        <div className="col-md-6">
                          <div className="form-group row">
                            <label className="col-md-3 label-control col-form-label" htmlFor="valor_adquisicion">
                              <FormattedMessage id="movilesAbm.render.administracion.valor_adquisicion" defaultMessage="Valor de Adquisición"/>{ConfigBusiness.get('moviles.valorAdquisicion.obligatorio') === 'true' ? requiredSymbol : ' '}:
                            </label>
                            <div className="col-md-9">
                              {this.props.action === 'VIEW' || (this.props.action === 'EDIT' && !Security.hasPermission('MOVILES_MODIFICAR_ADMINISTRACION')) ? (
                              <div className="form-control-static col-form-label form-value">{formData.valorAdquisicion ? formData.valorAdquisicion : ''}</div>
                              ) : (
                                <div>
                                  <input type="text" className={this.state.validationErrors.valorAdquisicion ? "form-control is-invalid" : "form-control"} id="valorAdquisicion" name="valorAdquisicion" placeholder="" value={formData.valorAdquisicion === 0 ? '' : formData.valorAdquisicion} onChange={this.handleInputFormChange} data-db-column="valorAdquisicion" />
                                  <small className="text-danger">{this.state.validationErrors.valorAdquisicion}</small>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                        {/* VALOR AMORTIZACION */}
                        <div className="col-md-6">
                          <div className="form-group row">
                            <label className="col-md-3 label-control col-form-label" htmlFor="valor_amortizacion">
                              <FormattedMessage id="movilesAbm.render.administracion.valor_amortizacion" defaultMessage="Valor de Amortización"/>{ConfigBusiness.get('moviles.valorAmortizacion.obligatorio') === 'true' ? requiredSymbol : ' '}:
                            </label>
                            <div className="col-md-9">
                              {this.props.action === 'VIEW' || (this.props.action === 'EDIT' && !Security.hasPermission('MOVILES_MODIFICAR_ADMINISTRACION')) ? (
                              <div className="form-control-static col-form-label form-value">{formData.valorAmortizacion ? formData.valorAmortizacion : ''}</div>
                              ) : (
                                <div>
                                  <input type="text" className={this.state.validationErrors.valorAmortizacion ? "form-control is-invalid" : "form-control"} id="valorAmortizacion" name="valorAmortizacion" placeholder="" value={formData.valorAmortizacion === 0 ? '' : formData.valorAmortizacion} onChange={this.handleInputFormChange} data-db-column="valorAmortizacion" />
                                  <small className="text-danger">{this.state.validationErrors.valorAmortizacion}</small>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="row">
                        {/* VALOR CONTABLE */}
                        <div className="col-md-6">
                          <div className="form-group row">
                            <label className="col-md-3 label-control col-form-label" htmlFor="valor_contable">
                              <FormattedMessage id="movilesAbm.render.administracion.valor_contable" defaultMessage="Valor de Contable"/>{ConfigBusiness.get('moviles.valorContable.obligatorio') === 'true' ? requiredSymbol : ' '}:
                            </label>
                            <div className="col-md-9">
                              {this.props.action === 'VIEW' || (this.props.action === 'EDIT' && !Security.hasPermission('MOVILES_MODIFICAR_ADMINISTRACION')) ? (
                              <div className="form-control-static col-form-label form-value">{formData.valorContable ? formData.valorContable : ''}</div>
                              ) : (
                                <div>
                                  <input type="text" className={this.state.validationErrors.valorContable ? "form-control is-invalid" : "form-control"} id="valorContable" name="valorContable" placeholder="" value={formData.valorContable === 0 ? '' : formData.valorContable} onChange={this.handleInputFormChange} data-db-column="valorContable" />
                                  <small className="text-danger">{this.state.validationErrors.valorContable}</small>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                        {/* VALOR ALQUILER */}
                        <div className="col-md-6">
                          <div className="form-group row">
                            <label className="col-md-3 label-control col-form-label" htmlFor="valor_alquiler">
                              <FormattedMessage id="movilesAbm.render.administracion.valor_alquiler" defaultMessage="Valor de Alquiler"/>{ConfigBusiness.get('moviles.valorAlquiler.obligatorio') === 'true' ? requiredSymbol : ' '}:
                            </label>
                            <div className="col-md-9">
                              {this.props.action === 'VIEW' || (this.props.action === 'EDIT' && !Security.hasPermission('MOVILES_MODIFICAR_ADMINISTRACION')) ? (
                              <div className="form-control-static col-form-label form-value">{formData.valorAlquiler ? formData.valorAlquiler : ''}</div>
                              ) : (
                                <div>
                                  <input type="text" className={this.state.validationErrors.valorAlquiler ? "form-control is-invalid" : "form-control"} id="valorAlquiler" name="valorAlquiler" placeholder="" value={formData.valorAlquiler === 0 ? '' : formData.valorAlquiler} onChange={this.handleInputFormChange} data-db-column="valorAlquiler"/>
                                  <small className="text-danger">{this.state.validationErrors.valorAlquiler}</small>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                      </div>
                      )}



                      <div className="row">
                        {/* COMENTARIOS LABORALES */}
                        <div className="col-md-6">
                          <div className="form-group row">
                            <label className="col-md-3 label-control col-form-label" htmlFor="observaciones">
                              <FormattedMessage id="movilesAbm.render.administracion.label_observaciones" defaultMessage="Observaciones"/>:
                            </label>
                            <div className="col-md-9">
                              {this.props.action === 'VIEW' || (this.props.action === 'EDIT' && !Security.hasPermission('MOVILES_MODIFICAR_ADMINISTRACION') && !Security.hasPermission('MOVILES_EDITAR_OBSERVACIONES')) ? (
                              <div className="form-control-static col-form-label form-value">{formData.observaciones ? formData.observaciones : ''}</div>
                              ) : (
                              <div>
                                <textarea className="form-control" maxLength="200" id="observaciones" name="observaciones" rows="3" placeholder="" value={formData.observaciones ? formData.observaciones : ''} onChange={this.handleInputFormChange} data-db-column="observaciones"></textarea>
                              </div>
                              )}
                            </div>
                          </div>
                        </div>

                        {/* SWITCH BUSCAR INFRACCIONES */}
                        <div className="col-md-3">
                          <div className="form-group row">
                            <label className="col-md-6 label-control col-form-label">
                              <FormattedMessage id="movilesAbm.render.buscar_infracciones_movil.label_buscar_infracciones" defaultMessage="Buscar infracciones"/>:
                            </label>
                            <div data-db-column="buscarInfracciones" className="col-md-6 mt-auto">
                              <Switch
                                onChange={ ()=>this.handleBuscarInfracciones(!formData.buscar_infracciones) }
                                checked={formData.buscar_infracciones ? formData.buscar_infracciones : false}
                                id="buscarInfracciones"
                                name="buscarInfracciones"
                                disabled={this.state.props.action === 'VIEW' || !Security.hasPermission('MOVILES_MODIFICAR_ADMINISTRACION')}  
                                offColor="#FF4961"
                                onColor="#28D094"
                              />
                            </div>
                          </div>
                        </div>
                        {/* BOTON HISTORICO CECO + TARJETA COMBUSTIBLE */}
                        {Security.renderIfHasPermission('MOVILES_ADMINISTRACION_HISTORICO_LISTAR', (
                          <div className="col-md-3">
                            <div className="row justify-content-end">
                              <div className="col-md-4">
                                {this.props.action === 'VIEW' || this.props.action === 'EDIT' ? (
                                <button type="button" className="btn btn-fleet float-right" data-toggle="modal" data-target="#historico_adm_modal" onClick={()=>this.handleSetTipo('HistoricoAdm')}>
                                <i className="la la-search align-middle"></i>
                                <FormattedMessage id="movilesAbm.render.administracion.historico_de_administracion" defaultMessage="Histórico de Administración"/>
                                </button>
                                ) : (
                                <div style={{display:'none'}}></div>
                                )}
                              </div>
                            </div>
                          </div>
                        ))}

                      </div>

                    </div>
                  </div>
                </div>

                {/* RENTING - RENTADORA */}

                { this.state.rentingHabilitado &&
                  <RentadoraComponent
                    rentadoras={this.state.rentadoras}
                    rentadora={formData.rentadora}
                    contrato={formData.contrato}
                    modificarRentadora={modificarRentadora}
                    handleAgregarRentadora={this.handleAgregarRentadora}
                    handleChangeRentadora={this.handleChangeRentadora}
                    handleChangeContrato={this.handleChangeContrato}
                    rentadorasLoading={false}
                    validationErrors={this.state.validationErrors}
                  />
                }

                <div className="card pull-up">
                  <div className="card-content">
                    <div className="card-body">
                      <h4 className="form-section mt-2">
                        <i className="la la-cog"></i>
                        <FormattedMessage id="movilesAbm.render.dimensiones.header_dimensiones" defaultMessage="Dimensiones"/>
                      </h4>
                      <div className="row">
                        {/* PESO CARGA TOTAL AUTORIZADO */}
                        <div className="col-md-6">
                          <div className="form-group row">
                            <label className="col-md-6 label-control col-form-label" htmlFor="peso_carga_total_autorizado">
                              <FormattedMessage id="movilesAbm.render.dimensiones.peso_carga_total_autorizado" defaultMessage="Peso Carga Total Autorizado (kg)"/>{ConfigBusiness.get('moviles.pesoCargaTotalAutorizado.obligatorio') === 'true' ? requiredSymbol : ' '}:
                            </label>
                            <div className="col-md-6">
                              {this.props.action === 'VIEW' || (this.props.action === 'EDIT' && !Security.hasPermission('MOVILES_MODIFICAR_DIMENSIONES')) ? (
                              <div className="form-control-static col-form-label form-value">{formData.pesoCargaTotalAutorizado ? formData.pesoCargaTotalAutorizado : ''}</div>
                              ) : (
                                <div>
                                  <input type="text" className={this.state.validationErrors.pesoCargaTotalAutorizado ? "form-control is-invalid" : "form-control"} id="pesoCargaTotalAutorizado" name="pesoCargaTotalAutorizado" placeholder="" value={formData.pesoCargaTotalAutorizado === 0 ? '' : formData.pesoCargaTotalAutorizado} onChange={this.handleInputFormChange} data-db-column="pesoCargaTotalAutorizado" />
                                  <small className="text-danger">{this.state.validationErrors.pesoCargaTotalAutorizado}</small>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                        {/* PESO CARGA MAXIMA */}
                        <div className="col-md-6">
                          <div className="form-group row">
                            <label className="col-md-6 label-control col-form-label" htmlFor="peso_carga_maxima">
                              <FormattedMessage id="movilesAbm.render.dimensiones.peso_carga_maxima" defaultMessage="Peso Carga Máxima (kg)"/>{ConfigBusiness.get('moviles.pesoCargaMaxima.obligatorio') === 'true' ? requiredSymbol : ' '}:
                            </label>
                            <div className="col-md-6">
                              {this.props.action === 'VIEW' || (this.props.action === 'EDIT' && !Security.hasPermission('MOVILES_MODIFICAR_DIMENSIONES')) ? (
                              <div className="form-control-static col-form-label form-value">{formData.pesoCargaMaxima ? formData.pesoCargaMaxima : ''}</div>
                              ) : (
                                <div>
                                  <input type="text" className={this.state.validationErrors.pesoCargaMaxima ? "form-control is-invalid" : "form-control"} id="pesoCargaMaxima" name="pesoCargaMaxima" placeholder="" value={formData.pesoCargaMaxima === 0 ? '' : formData.pesoCargaMaxima} onChange={this.handleInputFormChange} data-db-column="pesoCargaMaxima" />
                                  <small className="text-danger">{this.state.validationErrors.pesoCargaMaxima}</small>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="row">
                        {/* VOLUMEN AREA CARCA */}
                        <div className="col-md-6">
                          <div className="form-group row">
                            <label className="col-md-6 label-control col-form-label" htmlFor="volumen_area_carga">
                              <FormattedMessage id="movilesAbm.render.dimensiones.volumen_area_carga" defaultMessage="Volumen Área de Carga (m3)"/>{ConfigBusiness.get('moviles.volumenAreaCarga.obligatorio') === 'true' ? requiredSymbol : ' '}:
                            </label>
                            <div className="col-md-6">
                              {this.props.action === 'VIEW' || (this.props.action === 'EDIT' && !Security.hasPermission('MOVILES_MODIFICAR_DIMENSIONES')) ? (
                              <div className="form-control-static col-form-label form-value">{formData.volumenAreaCarga ? formData.volumenAreaCarga : ''}</div>
                              ) : (
                                <div>
                                  <input type="text" className={this.state.validationErrors.volumenAreaCarga ? "form-control is-invalid" : "form-control"} id="volumenAreaCarga" name="volumenAreaCarga" placeholder="" value={formData.volumenAreaCarga === 0 ? '' : formData.volumenAreaCarga} onChange={this.handleInputFormChange} data-db-column="volumenAreaCarga" />
                                  <small className="text-danger">{this.state.validationErrors.volumenAreaCarga}</small>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                        {/* CANTIDAD COMPARTIMENTOS */}
                        <div className="col-md-6">
                          <div className="form-group row">
                            <label className="col-md-6 label-control col-form-label" htmlFor="cantidad_compartimentos">
                              <FormattedMessage id="movilesAbm.render.dimensiones.cantidad_compartimentos" defaultMessage="Cantidad Compartimentos"/>{ConfigBusiness.get('moviles.cantidadCompartimentos.obligatorio') === 'true' ? requiredSymbol : ' '}:
                            </label>
                            <div className="col-md-6">
                              {this.props.action === 'VIEW' || (this.props.action === 'EDIT' && !Security.hasPermission('MOVILES_MODIFICAR_DIMENSIONES')) ? (
                              <div className="form-control-static col-form-label form-value">{formData.cantidadCompartimentos ? formData.cantidadCompartimentos : ''}</div>
                              ) : (
                                <div>
                                  <input type="text" className={this.state.validationErrors.cantidadCompartimentos ? "form-control is-invalid" : "form-control"} id="cantidadCompartimentos" name="cantidadCompartimentos" placeholder="" value={formData.cantidadCompartimentos === 0 ? '' : formData.cantidadCompartimentos} onChange={this.handleInputFormChange} data-db-column="cantidadCompartimentos" />
                                  <small className="text-danger">{this.state.validationErrors.cantidadCompartimentos}</small>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="row">
                        {/* ALTURA ESPACIO CARGA */}
                        <div className="col-md-6">
                          <div className="form-group row">
                            <label className="col-md-6 label-control col-form-label" htmlFor="altura_espacio_carga">
                              <FormattedMessage id="movilesAbm.render.dimensiones.altura_espacio_carga" defaultMessage="Altura Espacio de Carga (mts)"/>{ConfigBusiness.get('moviles.alturaEspacioCarga.obligatorio') === 'true' ? requiredSymbol : ' '}:
                            </label>
                            <div className="col-md-6">
                              {this.props.action === 'VIEW' || (this.props.action === 'EDIT' && !Security.hasPermission('MOVILES_MODIFICAR_DIMENSIONES')) ? (
                              <div className="form-control-static col-form-label form-value">{formData.alturaEspacioCarga ? formData.alturaEspacioCarga : ''}</div>
                              ) : (
                                <div>
                                  <input type="text" className={this.state.validationErrors.alturaEspacioCarga ? "form-control is-invalid" : "form-control"} id="alturaEspacioCarga" name="alturaEspacioCarga" placeholder="" value={formData.alturaEspacioCarga === 0 ? '' : formData.alturaEspacioCarga} onChange={this.handleInputFormChange} data-db-column="alturaEspacioCarga" />
                                  <small className="text-danger">{this.state.validationErrors.alturaEspacioCarga}</small>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                        {/* ANCHO ESPACIO CARGA */}
                        <div className="col-md-6">
                          <div className="form-group row">
                            <label className="col-md-6 label-control col-form-label" htmlFor="ancho_espacio_carga">
                              <FormattedMessage id="movilesAbm.render.dimensiones.ancho_espacio_carga" defaultMessage="Ancho Espacio de Carga (mts)"/>{ConfigBusiness.get('moviles.anchoEspacioCarga.obligatorio') === 'true' ? requiredSymbol : ' '}:
                            </label>
                            <div className="col-md-6">
                              {this.props.action === 'VIEW' || (this.props.action === 'EDIT' && !Security.hasPermission('MOVILES_MODIFICAR_DIMENSIONES')) ? (
                              <div className="form-control-static col-form-label form-value">{formData.anchoEspacioCarga ? formData.anchoEspacioCarga : ''}</div>
                              ) : (
                                <div>
                                  <input type="text" className={this.state.validationErrors.anchoEspacioCarga ? "form-control is-invalid" : "form-control"} id="anchoEspacioCarga" name="anchoEspacioCarga" placeholder="" value={formData.anchoEspacioCarga === 0 ? '' : formData.anchoEspacioCarga} onChange={this.handleInputFormChange} data-db-column="anchoEspacioCarga" />
                                  <small className="text-danger">{this.state.validationErrors.anchoEspacioCarga}</small>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        {/* LONGITUD ESPACIO CARGA */}
                        <div className="col-md-6">
                          <div className="form-group row">
                            <label className="col-md-6 label-control col-form-label" htmlFor="longitud_espacio_carga">
                              <FormattedMessage id="movilesAbm.render.dimensiones.longitud_espacio_carga" defaultMessage="Longitud Espacio de Carga (mts)"/>{ConfigBusiness.get('moviles.longitudEspacioCarga.obligatorio') === 'true' ? requiredSymbol : ' '}:
                            </label>
                            <div className="col-md-6">
                              {this.props.action === 'VIEW' || (this.props.action === 'EDIT' && !Security.hasPermission('MOVILES_MODIFICAR_DIMENSIONES')) ? (
                              <div className="form-control-static col-form-label form-value">{formData.longitudEspacioCarga ? formData.longitudEspacioCarga : ''}</div>
                              ) : (
                                <div>
                                  <input type="text" className={this.state.validationErrors.longitudEspacioCarga ? "form-control is-invalid" : "form-control"} id="longitudEspacioCarga" name="longitudEspacioCarga" placeholder="" value={formData.longitudEspacioCarga === 0 ? '' : formData.longitudEspacioCarga} onChange={this.handleInputFormChange} data-db-column="longitudEspacioCarga" />
                                  <small className="text-danger">{this.state.validationErrors.longitudEspacioCarga}</small>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group row">
                            <label className="col-md-6 label-control col-form-label" htmlFor="tipologia_posicion">
                              <FormattedMessage id="movilesAbm.render.dimensiones.tipologia_posicion" defaultMessage="Diagrama de Posicion"/>:
                            </label>
                            <div className="col-md-6">
                              {this.props.action === 'VIEW' || (this.props.action === 'EDIT' && !Security.hasPermission('MOVILES_MODIFICAR_DIMENSIONES')) ? (
                              <div className="form-control-static col-form-label form-value">{this.state.formData.tipologia_posicion ? this.state.formData.tipologia_posicion.identificador : null}</div>
                              ) : (
                                <div data-db-column="id_tipologiaPosicion">
                                  <Select
                                  id="tipologia_posicion"
                                  name="tipologia_posicion"
                                  placeholder={!state.cebesLoading ? this.props.intl.formatMessage({ id: 'movilesAbm.render.general_data.placeholder_tipologia', defaultMessage: 'Seleccione' }) : ''}
                                  options={this.state.tipologias}
                                  valueKey='id'
                                  labelKey='identificador'
                                  value={tipologia ? { id: tipologia.id, identificador: tipologia.identificador } : this.state.formData.tipologia_posicion}
                                  onChange={(e) => this.handleFormChangeTipologia("tipologia_posicion", e)}
                                  />
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
                {this.state.valores_dinamicos.length > 0 ?
                  <div className="card pull-up">
                    <div className="card-content">
                      <div className="card-body">
                        <h4 className="form-section mt-2">
                          <i className="la la-cog"></i>
                          <FormattedMessage id="movilesAbm.render.caracteristicas.header_caracteristicas" defaultMessage="Características"/>
                        </h4>
                        {this.state.valores_dinamicos
                          .map((atributoDinamico, index)  => (
                          (atributoDinamico && atributoDinamico.activo ) &&
                          <div className="row" key={index}>
                            <div className="col-md-6">
                              <div className="form-group row">
                                  <AtributoDinamicoInstancia
                                    movil={formData.movil}
                                    className=""
                                    disabled={this.props.action === 'VIEW'}
                                    handleChange={(name, value) => this.handleChangeAtributoDinamico(index, name, value)}
                                    atributo={atributoDinamico}
                                  />
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                : ''}
								<div className="card pull-up">
									<div className="card-content">
										<div className="card-body" id="container-direccion">
											<h4 className="form-section mt-2">
												<i className="ft-map-pin"></i> <FormattedMessage id="movilesAbm.render.lugar_de_guarda.header_lugar_de_guarda" defaultMessage="Lugar de guarda"/>
											</h4>
											<div className="form-group row">
	                      <label className="col-md-8 label-control col-form-label">
													<FormattedMessage id="movilesAbm.render.lugar_de_guarda.label_el_lugar_de_guarda_del_vehiculo_es_la_base_operativa" defaultMessage="El lugar de guarda del vehículo es la Base Operativa"/>: {formData.base ? formData.base.descripcion : 'Desconocida'}
												</label>
	                      <div data-db-column="guardaEnBase" className="col-md-4 mt-auto">
													<Switch
														onChange={this.handleGuardaPersonalizada}
														checked={formData.guardaEnBase ? formData.guardaEnBase : false}
														id="guardaEnBase"
														name="guardaEnBase"
														disabled={this.state.props.action === 'VIEW' || !Security.hasPermission('MOVILES_MODIFICAR_LUGAR_GUARDA')}
														offColor="#FF4961"
														onColor="#28D094"
													/>
	                      </div>
	                    </div>
                      {!this.state.formData.guardaEnBase &&
                        <div className='form-group row'>
                          <div className="col-md-12">
                            <DireccionAutocompletar
                              disabled={this.state.props.action === 'VIEW' || !Security.hasPermission('MOVILES_MODIFICAR_LUGAR_GUARDA')}
                              action={this.props.action}
                              cambioDireccion={this.handleChangeDireccion}
                              formulario={state.direccionForm}
                              camposObligatorios={["latitud", "longitud"]}
                              camposHidden={["codigoPostal"]}
                              crearProvincias={true}
                              crearLocalidades={true}
                              localidadString={true}
                            />
                          </div>
                        </div>
                      }
                      <div className="row">
                        <div className="col-md-6">
                        </div>
                        {/* BOTON HISTORICO CHOFERES */}
                        {Security.renderIfHasPermission('MOVILES_GUARDA_HISTORICO_LISTAR', (
                        <div className="col-md-6">
                          <div className="form-group row">
                            <div className="col-md-12">
                              {this.props.action === 'VIEW' || this.props.action === 'EDIT' ? (
                              <button type="button" className="btn btn-fleet float-right" data-toggle="modal" data-target="#guarda_modal" onClick={()=>this.handleSetTipo('guarda')}>
                              <i className="la la-search align-middle"></i> <FormattedMessage id="movilesAbm.render.lugar_de_guarda.button_historico_de_lugares_de_guarda" defaultMessage="Histórico de Lugares de Guarda"/>
                              </button>
                              ) : (
                              <div style={{display:'none'}}></div>
                              )}
                            </div>
                          </div>
                        </div>
                        ))}
                      </div>
										</div>
									</div>
								</div>

								<div className="card pull-up">
									<div className="card-content">
										<div className="card-body" id="container-direccion">
											<h4 className="form-section mt-2">
												<i className="la la-truck"></i> <FormattedMessage id="movilesAbm.render.equipamiento_asociado.header_equipamiento_asociado" defaultMessage="Equipamiento Asociado"/>:
											</h4>

			                <div className="row">
													{/* Equipamiento */}
			                    <div className="col-md-12">
			                        <div className="form-group row">
																	<label className="col-md-1 label-control col-form-label" htmlFor="equipamiento">
																	</label>
			                            {this.props.action === 'VIEW' || !Security.hasPermission('MOVILES_MODIFICAR_EQUIPAMIENTO') ? (
			                                this.state.formData.equipamientos && this.state.formData.equipamientos.length ? (
                                  <div className="col-md-offset-1 col-md-10">
                                      <table className="table table-bordered">
                                          <thead className="thead-fleet equipamientos">
                                              <tr>
																									<th scope="col"><FormattedMessage id="movilesAbm.render.equipamiento_asociado.table_column_identificador" defaultMessage="Identificador"/></th>
																									<th scope="col"><FormattedMessage id="movilesAbm.render.equipamiento_asociado.table_column_tipo_de_equipamiento" defaultMessage="Tipo de Equipamiento"/></th>
																									<th scope="col"><FormattedMessage id="movilesAbm.render.equipamiento_asociado.table_column_marca" defaultMessage="Marca"/></th>
																									<th scope="col"><FormattedMessage id="movilesAbm.render.equipamiento_asociado.table_column_modelo" defaultMessage="Modelo"/></th>
																									<th scope="col"><FormattedMessage id="movilesAbm.render.equipamiento_asociado.table_column_opciones" defaultMessage="Opciones"/></th>
                                              </tr>
                                          </thead>
                                          <tbody>
                                          {this.state.formData.equipamientos.map((equipo, index) =>
                                                  <tr key={index}>
																											<td className="align-middle">{equipo.identificador}</td>
																											<td className="align-middle">{equipo.tipo_equipamiento.nombre}</td>
																											<td className="align-middle">{equipo.marca}</td>
																											<td className="align-middle">{equipo.modelo}</td>
                                                      <td className="align-middle">
																												<Link to={'/equipamiento/' + equipo.id}><i className="fa fa-eye"/></Link>
																											</td>
                                                  </tr>
                                          )}
                                          </tbody>
                                      </table>
                                  </div>
																		) : (<p style={{marginTop:'10px'}}><FormattedMessage id="movilesAbm.render.equipamiento_asociado.information_no_cuenta_con_equipamientos" defaultMessage="No cuenta con equipamientos"/></p>)
	                                ) :
	                                (
			                            <div className="col-md-10">

			                                <div className="form-group">
			                                    <select multiple="multiple" size="10" ref="duallistboxequipamientos" value={formData.equipamientos} readOnly>
			                                        {this.state.equipamientosDisponibles.map(function(equipamiento) {
			                                        return <option key={equipamiento.id} value={equipamiento.id}>[{equipamiento.identificador}] {equipamiento.marca} {equipamiento.modelo}</option>;
			                                        })}
			                                    </select>
			                                </div>
			                            </div>
			                            )}
			                        </div>
			                    </div>
			                </div>
										</div>
								</div>
						</div>


            {ConfigBusiness.get('moviles.vinculacionActivos.habilitado') === 'true' && (this.props.action === 'VIEW' || Security.hasPermission('MOVILES_MODIFICAR_RELACIONES')) && (this.props.action === 'ADD' || this.state.formData.id) && !this.state.modeloTipoPermiteVinculacion && (
              <div className="card pull-up">
                <div className="card-content">
                  <div className="card-body">
                    <h4 className="form-section mt-2">
                      <i className="la la-link"></i> <FormattedMessage id="movilesAbm.render.relaciones.header" defaultMessage="Relaciones entre activos:" />
                    </h4>
                    <div className="row">
                      <div className="col-md-12">
                        <div className="form-group">
                          {this.props.action === 'VIEW' ? (
                            this.state.activosAsociadosLabels && this.state.activosAsociadosLabels.length > 0 ? (
                              <ul className="list-unstyled">
                                {this.state.activosAsociadosLabels.map((label, i) => <li key={i}>{label}</li>)}
                              </ul>
                            ) : (
                              <p style={{ marginTop: '10px' }}>
                                <FormattedMessage id="movilesAbm.render.relaciones.sin_asociados" defaultMessage="Sin activos asociados" />
                              </p>
                            )
                          ) : (
                            <select
                              multiple="multiple"
                              size="10"
                              ref="duallistboxactivos"
                              onChange={() => {}}
                            >
                              {this.state.activosVinculables.map(a => (
                                <option key={a.id} value={a.id}>{a.label}</option>
                              ))}
                            </select>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="row justify-content-end">
                      <div className="col-md-4">
                        {(this.props.action === 'VIEW' || this.props.action === 'EDIT') && (
                          <button
                            type="button"
                            className="btn btn-fleet float-right"
                            data-toggle="modal"
                            data-target="#relaciones_historico_modal"
                            onClick={() => this.handleSetTipo('RelacionesHistorico')}
                          >
                            <i className="la la-search align-middle"></i>
                            <FormattedMessage id="movilesAbm.render.relaciones.btn_historico" defaultMessage="Histórico de Relaciones" />
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {(this.props.action === 'ADD' || this.props.action !== 'ADD' && this.state.formData.id) && (
                <MovilesAbmGPS
                  movil={this.state.formData}
                  action={this.props.action}
                  callbackUpdate={this.handleGpsChange.bind(this)}
                  relacionComoAsociado={this.state.relacionComoAsociado}
                />
            )}

                {(this.props.action === 'ADD' || this.props.action !== 'ADD' && this.state.formData.id) && (
                <MovilesAbmAdjuntos movil={this.state.formData} action={this.props.action} callbackUpdate={this.handleAdjuntosChange.bind(this)}></MovilesAbmAdjuntos>
                )}

                {!this.props.hideBack && (
                <div className="card pull-up">
                  <div className="card-content">
                    <div className="card-body">
                      <div className="text-cd text-right">
                        {this.props.action !== 'VIEW' && (
                        <button
                          type="submit"
                          className="btn btn-primary mr-1"
                          disabled={guardarDeshabilitado}
                        >
                          <i className="fa fa-check-circle"></i><FormattedMessage id="movilesAbm.finish_button.guardar" defaultMessage=" Guardar"/>
                        </button>
                        )}
                        <button type="button" className="btn btn-danger" onClick={this.handleCancel.bind(this)}>
                          <i className="fa fa-times-circle"></i> {this.props.action === 'VIEW' ? this.props.intl.formatMessage({ id: 'movilesAbm.finish_button.volver', defaultMessage: 'Volver' }) : this.props.intl.formatMessage({ id: 'movilesAbm.finish_button.cancelar', defaultMessage: 'Cancelar' })}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                )}
              </div>
            </form>
					</div>
				</div>

        {Security.renderIfHasPermission('MOVILES_CHOFERES_HISTORICO_LISTAR', (
        <div className="modal fade" tabIndex="-1" id="choferes_modal" role="dialog" aria-labelledby="myModalLabel">
          <div className="modal-xl modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header bg-fleet">
                <h4 className="modal-title text-white" id="myModalLabel">{this.props.intl.formatMessage({ id: 'movilesAbm.choferes_modal.volver.historico_de_choferes_del_movil', defaultMessage: 'Histórico de choferes del móvil' })+': ' + formData.dominio}</h4>
                <button type="button" className="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
              </div>
              <div className="modal-body modal-mh ovf-x-hidden">
                {
                  this.state.tipoModal === 'choferes' && <ChoferesGrid movilId={this.state.props.match.params.id}></ChoferesGrid>
                }
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-default btn-fleet" data-dismiss="modal"><FormattedMessage id="movilesAbm.choferes_modal.finish_button.ok" defaultMessage="Ok"/></button>
              </div>
            </div>
          </div>
        </div>
        ))}

        {Security.renderIfHasPermission('MOVILES_ADMINISTRACION_HISTORICO_LISTAR', (
        <div className="modal fade" tabIndex="-1" id="historico_adm_modal" role="dialog" aria-labelledby="myModalLabel">
          <div className="modal-xl modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header bg-fleet">
                <h4 className="modal-title text-white" id="myModalLabel">{this.props.intl.formatMessage({ id: 'movilesAbm.historico_adm_modal.volver.historico_de_cecos_del_movil', defaultMessage: 'Histórico de Administración' })+': ' + formData.dominio}</h4>
                <button type="button" className="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
              </div>
              <div className="modal-body modal-mh ovf-x-hidden">
                {
                this.state.tipoModal === 'HistoricoAdm' && <HistoricoAdmGrid movilId={this.state.props.match.params.id} movilDominio={this.state.formData.dominio}/>
                }
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-default btn-fleet" data-dismiss="modal"><FormattedMessage id="movilesAbm.historico_adm_modal.finish_button.ok" defaultMessage="Ok"/></button>
              </div>
            </div>
          </div>
        </div>
        ))}

        <div className="modal fade" tabIndex="-1" id="gestionar_transportadoras_modal" role="dialog" aria-labelledby="myModalLabel">
          <div className="modal-xl modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header bg-fleet">
                <h4 className="modal-title text-white" id="myModalLabel">{this.props.intl.formatMessage({ id: 'movilesAbm.gestionar_transportadoras_modal.volver', defaultMessage: 'Gestionar Transportadoras' })}</h4>
                <button type="button" className="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
              </div>
              <div className="modal-body modal-mh ovf-x-hidden">
                {
                  this.state.tipoModal === 'GestionarTransportadoras' && (
                    <GestionarTransportadorasGrid
                      transportadoras={this.state.transportadoras}
                      selectedTransportadoras={this.state.formData.transportadoras}
                      onChangeTransportadoras={this.handleTransportadoraChange}
                      disabled={this.props.action === 'VIEW' || !Security.hasPermission('MOVILES_MODIFICAR_ADMINISTRACION')}
                    />
                  )
                }
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-default btn-fleet" data-dismiss="modal"><FormattedMessage id="movilesAbm.gestionar_transportadoras_modal.finish_button.ok" defaultMessage="Ok"/></button>
              </div>
            </div>
          </div>
        </div>

        {Security.renderIfHasPermission('MOVILES_GUARDA_HISTORICO_LISTAR', (
        <div className="modal fade" tabIndex="-1" id="guarda_modal" role="dialog" aria-labelledby="myModalLabel">
          <div className="modal-xl modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header bg-fleet">
                <h4 className="modal-title text-white" id="myModalLabel">{this.props.intl.formatMessage({ id: 'movilesAbm.guarda_modal.volver.historico_de_choferes_del_movil', defaultMessage: 'Histórico de choferes del móvil' })+': ' + formData.dominio}</h4>
                <button type="button" className="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
              </div>
              <div className="modal-body modal-mh ovf-x-hidden">
                {
                  this.state.tipoModal === 'guarda' && <LugarDeGuardaGrid movilId={this.state.props.match.params.id}></LugarDeGuardaGrid>
                }
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-default btn-fleet" data-dismiss="modal"><FormattedMessage id="movilesAbm.guarda_modal.finish_button.ok" defaultMessage="Ok"/></button>
              </div>
            </div>
          </div>
        </div>
        ))}

        {Security.renderIfHasPermission('MOVILES_DATOS_GENERALES_HISTORICO_LISTAR', (
          <div className="modal fade" tabIndex="-1" id="datosGenerales_modal" role="dialog" aria-labelledby="myModalLabel">
            <div className="modal-xl modal-dialog" role="document">
              <div className="modal-content">
                <div className="modal-header bg-fleet">
                  <h4 className="modal-title text-white" id="myModalLabel">{this.props.intl.formatMessage({ id: 'movilesAbm.datosGenerales_modal.volver.datosGenerales_movil', defaultMessage: 'Histórico de D. Generales del móvil' })+': ' + formData.dominio}</h4>
                  <button type="button" className="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                </div>
                <div className="modal-body modal-mh ovf-x-hidden">
                  {
                    this.state.tipoModal === 'datosGenerales' && <HistoricoDatosGeneralesGrid movilId={this.state.props.match.params.id}></HistoricoDatosGeneralesGrid>
                  }
                </div>
                <div className="modal-footer">
                  <button type="button" className="btn btn-default btn-fleet" data-dismiss="modal"><FormattedMessage id="movilesAbm.datosGenerales_modal.finish_button.ok" defaultMessage="Ok"/></button>
                </div>
              </div>
            </div>
          </div>
        ))}
        <div className="modal fade" tabIndex="-1" id="relaciones_historico_modal" role="dialog" aria-labelledby="myModalLabel">
          <div className="modal-xl modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header bg-fleet">
                <h4 className="modal-title text-white" id="myModalLabel">
                  {this.props.intl.formatMessage({ id: 'movilesAbm.relaciones_historico_modal.titulo', defaultMessage: 'Histórico de relaciones del vehículo' }) + ': ' + formData.dominio}
                </h4>
                <button type="button" className="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
              </div>
              <div className="modal-body modal-mh ovf-x-hidden">
                {this.state.tipoModal === 'RelacionesHistorico' && (
                  <HistoricoRelacionesGrid movilId={this.state.props.match.params.id} />
                )}
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-default btn-fleet" data-dismiss="modal">
                  <FormattedMessage id="movilesAbm.relaciones_historico_modal.btn_ok" defaultMessage="Ok" />
                </button>
              </div>
            </div>
          </div>
        </div>

        <MovilesCambioTipologia
          movil={this.state.formData}
          tipologia_posicion={this.state.tipologiaSelect}
          open={this.state.showModalTipologiaLlanta}
          intl={this.props.intl}
          callbackUpdate={this.closeModalTipologiaLlanta.bind(this)}
          update={this.updateTipologiaLlanta.bind(this)}
        >
        </MovilesCambioTipologia>
			</React.Fragment>
		);
	}
}

export default injectIntl(MovilesAbm);
